var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorldwide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 319,
    viewBox: "0 0 328 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.303 43.3164C181.21 43.3164 190.863 33.6747 190.863 21.781C190.863 9.88733 181.21 0.245605 169.303 0.245605C157.396 0.245605 147.744 9.88733 147.744 21.781C147.744 33.6747 157.396 43.3164 169.303 43.3164Z",
    fill: "#141332"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.949 35.1642C172.889 35.1642 172.83 35.1352 172.796 35.081C167.676 27.2435 161.871 14.9367 159.859 7.64666C159.836 7.56153 159.876 7.47254 159.954 7.43384C170.578 2.21396 183.416 4.39439 188.576 12.2919C188.585 12.3074 188.593 12.3248 188.599 12.3442C190.631 19.7 183.646 29.9289 173.03 35.1449C173.005 35.1584 172.976 35.1642 172.949 35.1642ZM160.25 7.69503C162.28 14.9309 167.965 26.9823 173.013 34.7463C183.385 29.5883 190.206 19.6284 188.252 12.468C183.203 4.77167 170.675 2.64347 160.25 7.69503Z",
    fill: "url(#paint0_linear_376_3569)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.099 28.6204C182.039 28.6204 181.981 28.5914 181.946 28.5372C179.414 24.662 173.092 23.6056 167.851 26.1807C167.76 26.2252 167.651 26.1885 167.607 26.0975C167.562 26.0066 167.599 25.8983 167.69 25.8538C173.09 23.1993 179.623 24.3137 182.252 28.3379C182.306 28.4231 182.283 28.5353 182.199 28.5914C182.168 28.6107 182.134 28.6204 182.099 28.6204Z",
    fill: "url(#paint1_linear_376_3569)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.65 20.5179C187.59 20.5179 187.531 20.4889 187.497 20.4347C183.133 13.7522 172.242 11.9239 163.218 16.3582C163.127 16.4027 163.018 16.366 162.973 16.275C162.929 16.1841 162.966 16.0758 163.057 16.0313C172.238 11.5195 183.34 13.4059 187.803 20.2354C187.857 20.3206 187.834 20.4328 187.75 20.4889C187.719 20.5082 187.684 20.5179 187.65 20.5179Z",
    fill: "url(#paint2_linear_376_3569)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M172.949 35.1635C172.91 35.1635 172.871 35.1519 172.836 35.1248C172.757 35.0629 172.741 34.9487 172.803 34.8694C179.296 26.4862 182.953 13.7886 180.956 6.56246C180.929 6.46572 180.987 6.36512 181.083 6.33803C181.18 6.31288 181.281 6.36899 181.308 6.46572C183.33 13.7886 179.644 26.6313 173.092 35.0938C173.055 35.1402 173.003 35.1654 172.947 35.1654L172.949 35.1635Z",
    fill: "url(#paint3_linear_376_3569)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M172.949 35.1637C172.949 35.1637 172.937 35.1637 172.931 35.1637C172.831 35.154 172.757 35.065 172.767 34.9644C173.671 25.612 172.778 12.0999 170.774 4.84273C170.747 4.746 170.805 4.64539 170.902 4.6183C170.998 4.59315 171.099 4.64926 171.126 4.746C173.141 12.0399 174.039 25.612 173.131 34.9993C173.121 35.0941 173.042 35.1637 172.949 35.1637Z",
    fill: "url(#paint4_linear_376_3569)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M161.194 38.1721C158.945 38.1721 156.874 37.7813 155.106 36.988C152.497 35.8175 150.738 33.8364 150.018 31.2574C147.881 27.9741 147.32 24.1724 148.395 20.2623C149.836 15.0115 154.05 10.3353 159.954 7.43513C160.002 7.40998 160.059 7.40998 160.109 7.43319C160.159 7.45448 160.196 7.49897 160.21 7.55121C162.214 14.8122 167.998 27.0726 173.1 34.883C173.129 34.9275 173.137 34.9798 173.123 35.0301C173.109 35.0804 173.075 35.1229 173.028 35.1462C168.957 37.1467 164.839 38.174 161.194 38.174V38.1721ZM159.917 7.85883C154.209 10.7203 150.144 15.2669 148.745 20.3571C147.697 24.1724 148.247 27.8813 150.337 31.0813C150.347 31.0968 150.355 31.1142 150.36 31.1316C151.046 33.6158 152.739 35.5254 155.255 36.6533C159.753 38.6712 166.255 38.0173 172.681 34.9063C167.64 27.1383 161.966 15.1179 159.917 7.8569V7.85883Z",
    fill: "url(#paint5_linear_376_3569)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M162.801 38.104C162.741 38.104 162.683 38.075 162.648 38.0208C161.565 36.3628 161.267 34.3603 161.809 32.385C162.543 29.7092 164.687 27.3295 167.692 25.8533C167.783 25.8088 167.891 25.8456 167.936 25.9365C167.98 26.0275 167.943 26.1358 167.852 26.1803C164.943 27.6101 162.869 29.9066 162.162 32.4817C161.641 34.3816 161.914 36.2293 162.954 37.8215C163.008 37.9067 162.985 38.0189 162.902 38.075C162.871 38.0943 162.836 38.104 162.801 38.104Z",
    fill: "url(#paint6_linear_376_3569)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M154.635 36.7404C154.575 36.7404 154.517 36.7113 154.482 36.6572C152.623 33.8112 152.133 30.5125 153.064 27.1228C154.312 22.5821 157.953 18.5385 163.059 16.0311C163.15 15.9866 163.258 16.0233 163.303 16.1143C163.347 16.2052 163.31 16.3136 163.219 16.358C158.209 18.821 154.635 22.7794 153.415 27.2196C152.512 30.5067 152.987 33.7028 154.788 36.4579C154.842 36.543 154.819 36.6552 154.736 36.7113C154.705 36.7307 154.67 36.7404 154.635 36.7404Z",
    fill: "url(#paint7_linear_376_3569)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M172.948 35.1636C172.925 35.1636 172.9 35.1597 172.877 35.1481C163.097 30.9884 153.498 21.6457 151.474 14.3247C151.447 14.2279 151.505 14.1273 151.602 14.1002C151.699 14.0751 151.799 14.1312 151.826 14.2279C153.823 21.4561 163.33 30.6905 173.02 34.8134C173.113 34.8521 173.156 34.9604 173.117 35.0533C173.088 35.1229 173.02 35.1636 172.948 35.1636Z",
    fill: "url(#paint8_linear_376_3569)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M171.405 35.1983C160.222 35.1983 149.883 29.814 147.942 22.7851C147.915 22.6884 147.973 22.5878 148.07 22.5607C148.166 22.5355 148.267 22.5916 148.294 22.6884C150.282 29.8855 161.341 35.3124 172.939 34.7997C173.048 34.7765 173.125 34.8733 173.129 34.9739C173.133 35.0745 173.056 35.1596 172.955 35.1635C172.438 35.1867 171.919 35.1983 171.403 35.1983H171.405Z",
    fill: "url(#paint9_linear_376_3569)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M171.047 41.9464C167.535 41.9464 164.312 40.565 162.648 38.0208C162.594 37.9357 162.617 37.8235 162.701 37.7674C162.786 37.7113 162.898 37.7364 162.954 37.8196C165.486 41.6949 171.808 42.7493 177.049 40.1761C177.14 40.1316 177.249 40.1684 177.293 40.2593C177.338 40.3502 177.301 40.4586 177.21 40.5031C175.225 41.4782 173.086 41.9445 171.047 41.9445V41.9464Z",
    fill: "url(#paint10_linear_376_3569)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M178.577 41.3448C177.191 41.3448 174.706 38.0054 172.794 35.0821C172.765 35.0376 172.757 34.9853 172.771 34.935C172.784 34.8847 172.819 34.8422 172.866 34.819C183.333 29.6745 190.23 19.6372 188.243 12.442C188.219 12.3549 188.262 12.264 188.343 12.2272C188.423 12.1904 188.522 12.2175 188.572 12.293C190.722 15.582 191.287 19.3934 190.211 23.3132C188.779 28.5234 184.619 33.1667 178.785 36.0746C179.629 39.1798 179.66 40.9307 178.878 41.2829C178.785 41.3254 178.682 41.3448 178.574 41.3448H178.577ZM173.212 35.0531C176.344 39.8163 178.116 41.2287 178.73 40.9501C178.945 40.8534 179.554 40.213 178.395 36.0243C178.372 35.9392 178.413 35.8502 178.49 35.8115C184.301 32.9558 188.446 28.3647 189.86 23.2145C190.807 19.7668 190.449 16.4062 188.828 13.4287C189.937 20.6316 183.212 30.0634 173.212 35.0511V35.0531Z",
    fill: "url(#paint11_linear_376_3569)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M177.129 40.523C177.061 40.523 176.997 40.4863 176.966 40.4205C176.922 40.3296 176.958 40.2212 177.049 40.1767C179.959 38.747 182.033 36.4504 182.74 33.8753C183.261 31.9754 182.988 30.1278 181.948 28.5355C181.894 28.4504 181.917 28.3382 182 28.282C182.085 28.2259 182.198 28.2511 182.254 28.3343C183.337 29.9923 183.635 31.9948 183.093 33.9701C182.358 36.6458 180.214 39.0256 177.21 40.5017C177.185 40.5153 177.156 40.5211 177.129 40.5211V40.523Z",
    fill: "url(#paint12_linear_376_3569)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M179.147 40.8807C179.079 40.8807 179.015 40.8439 178.984 40.7781C178.94 40.6872 178.976 40.5789 179.068 40.5344C184.078 38.0715 187.652 34.113 188.872 29.6728C189.775 26.3838 189.3 23.1896 187.499 20.4345C187.445 20.3494 187.468 20.2372 187.551 20.1811C187.636 20.1269 187.749 20.1501 187.805 20.2333C189.664 23.0793 190.154 26.3761 189.223 29.7676C187.975 34.3084 184.334 38.352 179.228 40.8594C179.203 40.8729 179.174 40.8788 179.147 40.8788V40.8807Z",
    fill: "url(#paint13_linear_376_3569)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M181.2 37.1426C178.853 37.1426 175.994 36.4751 172.875 35.1479C172.782 35.1092 172.74 35.0008 172.778 34.908C172.817 34.8151 172.926 34.7725 173.019 34.8112C178.643 37.2045 183.373 37.4328 185.674 35.4226C187.143 34.1399 187.524 32.0368 186.78 29.3437C186.753 29.247 186.811 29.1464 186.908 29.1193C187.005 29.0941 187.106 29.1502 187.133 29.247C187.917 32.0852 187.495 34.3179 185.915 35.6973C184.81 36.6628 183.187 37.1406 181.2 37.1406V37.1426Z",
    fill: "url(#paint14_linear_376_3569)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M172.949 35.1635C172.852 35.1635 172.771 35.088 172.767 34.9893C172.763 34.8887 172.84 34.8036 172.941 34.7997C180.111 34.4786 186.091 31.948 188.94 28.0321C190.528 25.8497 191.003 23.3791 190.315 20.8852C190.288 20.7885 190.346 20.6879 190.443 20.6608C190.54 20.6356 190.64 20.6917 190.668 20.7885C191.386 23.3926 190.892 25.9697 189.236 28.2468C186.323 32.2517 180.237 34.8365 172.958 35.1635C172.957 35.1635 172.953 35.1635 172.951 35.1635H172.949Z",
    fill: "url(#paint15_linear_376_3569)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M168.935 43.4907C168.732 43.4907 168.571 43.4907 168.474 43.4888C168.161 43.4849 167.769 43.4501 167.426 43.4191C167.291 43.4075 167.161 43.394 167.041 43.3862C166.987 43.3824 165.739 43.2721 164.149 42.8851C163.411 42.7052 162.292 42.3918 161.139 41.9178C160.62 41.705 159.923 41.3877 159.404 41.1284C159.074 40.964 158.677 40.7357 158.325 40.5344L158.052 40.3777C157.48 40.0527 156.75 39.5613 156.233 39.1511C155.468 38.5456 154.48 37.6788 153.773 36.992C153.264 36.4986 152.596 35.7305 152.109 35.0805C151.513 34.2834 150.8 33.2077 150.337 32.4028C149.799 31.4664 149.245 30.1179 148.877 29.226C148.702 28.8004 148.536 28.2277 148.402 27.7672L148.34 27.5525C148.232 27.1791 147.883 25.8054 147.722 24.453C147.604 23.4508 147.542 22.0849 147.569 21.0576C147.589 20.3708 147.655 19.3744 147.786 18.6392L147.86 18.2078C147.926 17.8169 148.001 17.3758 148.085 17.0256C148.154 16.7335 148.402 15.7197 148.673 14.9149C149.163 13.4561 149.657 12.4423 150.074 11.6413C150.287 11.2331 150.595 10.6972 150.839 10.3083C151.176 9.7743 151.65 9.10295 151.838 8.83983C151.97 8.65603 152.683 7.68286 153.866 6.48333C154.341 6.00223 155.079 5.35475 156.078 4.54087C156.09 4.53313 157.041 3.77666 158.459 2.95827C159.803 2.18631 160.973 1.72198 160.984 1.71618C161.906 1.36019 162.766 1.02742 163.541 0.837813C163.659 0.808792 163.789 0.773967 163.925 0.739142C164.238 0.657884 164.562 0.572756 164.839 0.522453C165.947 0.325112 166.822 0.195485 167.442 0.139378C168.288 0.0619895 169.325 0.0407075 170.216 0.079402C171.771 0.149052 172.875 0.350263 173.082 0.390892C173.94 0.559213 174.907 0.748816 176.082 1.14156C176.406 1.24991 177.014 1.45886 177.469 1.64653C177.973 1.85548 178.684 2.1631 179.209 2.43783C179.991 2.84992 181.039 3.48258 181.878 4.04945C182.403 4.40544 183.11 4.96264 183.638 5.43665C184.421 6.14089 185.015 6.72517 185.407 7.17403C186.257 8.153 187.223 9.4957 187.502 9.88651C187.502 9.88844 187.506 9.89231 187.508 9.89425C187.623 10.0684 187.729 10.2464 187.83 10.4302C188.275 11.1789 188.756 12.0224 189.071 12.7228C189.511 13.696 189.993 15.0174 190.27 16.0099C190.4 16.4742 190.722 17.7086 190.888 19.1074C191.01 20.1328 191.072 21.4968 191.041 22.5028C191.031 22.8414 190.985 24.0197 190.824 24.9212L190.751 25.3507C190.685 25.7416 190.609 26.1846 190.526 26.5329C190.381 27.1442 190.16 28.0071 189.937 28.6456C189.585 29.6536 189.257 30.5339 188.537 31.9153C188.324 32.3235 188.016 32.8594 187.77 33.2483C187.481 33.7068 187.061 34.3066 186.77 34.7167C186.691 34.827 185.965 35.835 184.742 37.0732C183.689 38.1412 182.643 38.9325 182.527 39.0176C181.823 39.5323 180.952 40.1669 180.144 40.5983C180.032 40.6583 179.908 40.7279 179.78 40.7995C179.478 40.9678 179.164 41.14 178.891 41.2658C177.955 41.6895 177.008 42.0842 176.356 42.3183C176.311 42.3337 175.224 42.7246 173.783 43.0283C172.321 43.3359 171.141 43.4153 171.13 43.4172C170.38 43.4694 169.497 43.4791 168.937 43.4791L168.935 43.4907ZM169.307 0.433456C168.68 0.433456 168.035 0.460542 167.475 0.510845C166.865 0.565017 165.999 0.692709 164.903 0.888116C164.641 0.934549 164.324 1.01774 164.017 1.09707C163.88 1.13383 163.748 1.16672 163.628 1.19767C162.877 1.38147 162.026 1.71037 161.126 2.05862C161.106 2.06636 159.95 2.52683 158.643 3.27943C157.25 4.08041 156.318 4.82141 156.309 4.82915C155.321 5.6327 154.594 6.27051 154.128 6.74259C152.964 7.92277 152.266 8.87659 152.138 9.05651C151.953 9.3177 151.482 9.98131 151.151 10.5076C150.91 10.8887 150.608 11.4149 150.399 11.8154C149.988 12.6029 149.504 13.5992 149.022 15.0367C148.811 15.6636 148.584 16.5226 148.443 17.1166C148.361 17.4532 148.288 17.8885 148.222 18.2735L148.146 18.7088C148.019 19.4228 147.953 20.3979 147.935 21.0731C147.908 22.0849 147.968 23.4276 148.086 24.4143C148.245 25.7416 148.586 27.0862 148.693 27.4538L148.755 27.6685C148.886 28.1213 149.049 28.6843 149.216 29.0906C149.58 29.9747 150.128 31.3097 150.655 32.2248C151.112 33.0181 151.813 34.0802 152.402 34.8657C152.878 35.5022 153.531 36.251 154.027 36.7347C154.726 37.4137 155.704 38.2708 156.46 38.8687C156.965 39.2672 157.678 39.749 158.232 40.0643L158.507 40.221C158.854 40.4203 159.249 40.6467 159.566 40.8053C160.078 41.0607 160.765 41.3741 161.279 41.585C162.408 42.0493 163.51 42.357 164.234 42.535C165.797 42.9161 167.02 43.0225 167.07 43.0264C167.19 43.036 167.322 43.0477 167.457 43.0593C167.794 43.0902 168.176 43.1231 168.476 43.127C169.218 43.1347 170.301 43.1231 171.103 43.0689C171.114 43.0689 172.269 42.9896 173.706 42.6878C175.122 42.3898 176.183 42.0087 176.228 41.9932C176.871 41.7611 177.81 41.3722 178.736 40.9504C178.996 40.8324 179.304 40.6621 179.598 40.4977C179.728 40.4261 179.854 40.3565 179.968 40.2945C180.752 39.8747 181.612 39.2479 182.304 38.7429C182.418 38.6578 183.443 37.8839 184.479 36.8333C185.703 35.5932 186.439 34.5639 186.47 34.5213C186.759 34.115 187.173 33.5211 187.458 33.0703C187.698 32.6892 188 32.1629 188.209 31.7624C188.92 30.4004 189.228 29.5684 189.588 28.5411C189.805 27.9181 190.024 27.0668 190.168 26.4632C190.249 26.1246 190.323 25.6893 190.388 25.3043L190.464 24.8709C190.57 24.2808 190.65 23.3967 190.677 22.5067C190.706 21.5181 190.646 20.1754 190.526 19.1654C190.363 17.7918 190.048 16.5807 189.92 16.1221C189.647 15.1451 189.172 13.845 188.738 12.8873C188.734 12.8795 188.73 12.8718 188.727 12.8621C190.305 20.1734 183.4 30.0502 173.032 35.1462C172.941 35.1907 172.832 35.154 172.788 35.0631C172.743 34.9721 172.78 34.8638 172.871 34.8193C183.336 29.6768 190.235 19.6394 188.248 12.4442C188.161 12.1289 188.058 11.8232 187.938 11.5272C187.814 11.2157 187.671 10.9158 187.512 10.6256C187.406 10.4456 187.301 10.2735 187.2 10.1071C186.472 9.0836 185.697 8.08141 185.132 7.42748C184.752 6.99023 184.167 6.41562 183.396 5.72299C182.879 5.25865 182.188 4.71306 181.676 4.36675C180.861 3.81535 179.801 3.17496 179.042 2.77447C178.531 2.50554 177.831 2.20373 177.334 1.99671C176.888 1.81291 176.29 1.6059 175.97 1.49949C174.816 1.11448 173.863 0.92681 173.022 0.762359C172.892 0.737208 171.765 0.526323 170.204 0.456673C169.917 0.445065 169.617 0.437326 169.311 0.437326L169.307 0.433456Z",
    fill: "url(#paint16_linear_376_3569)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M168.738 43.316C162.775 43.316 157.303 40.975 154.483 36.6567C154.429 36.5716 154.452 36.4594 154.535 36.4033C154.62 36.3491 154.733 36.3723 154.789 36.4555C159.155 43.1361 170.044 44.9644 179.066 40.532C179.157 40.4875 179.266 40.5242 179.31 40.6152C179.355 40.7061 179.318 40.8144 179.227 40.8589C175.849 42.5189 172.209 43.3141 168.737 43.3141L168.738 43.316Z",
    fill: "url(#paint17_linear_376_3569)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M162.72 42.1517C162.375 42.1517 162.042 42.1208 161.717 42.0569C159.606 41.641 158.079 39.9307 157.299 37.1099C157.272 37.0131 157.33 36.9125 157.427 36.8854C157.523 36.8603 157.624 36.9164 157.651 37.0131C158.391 39.6927 159.821 41.3121 161.786 41.699C164.897 42.3123 169.017 39.7585 172.804 34.8694C172.866 34.7901 172.98 34.7766 173.059 34.8366C173.139 34.8985 173.154 35.0126 173.092 35.0919C169.608 39.5921 165.813 42.1517 162.72 42.1517Z",
    fill: "url(#paint18_linear_376_3569)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M170.233 43.4848C169.261 43.4848 168.335 41.9196 167.481 38.8279C167.454 38.7312 167.512 38.6306 167.609 38.6035C167.705 38.5783 167.806 38.6344 167.833 38.7312C168.953 42.7864 169.921 43.1424 170.28 43.1172C171.107 43.0456 172.193 40.8652 172.765 34.9623C172.774 34.8617 172.869 34.796 172.964 34.7979C173.065 34.8076 173.138 34.8966 173.129 34.9972C172.829 38.1005 172.064 43.3281 170.313 43.479C170.287 43.4809 170.26 43.4829 170.233 43.4829V43.4848Z",
    fill: "url(#paint19_linear_376_3569)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M172.949 35.1635C172.852 35.1635 172.771 35.088 172.767 34.9893C172.763 34.8887 172.84 34.8036 172.941 34.7997C180.111 34.4786 186.091 31.948 188.94 28.0321C190.528 25.8497 191.003 23.3791 190.315 20.8852C190.288 20.7885 190.346 20.6879 190.443 20.6608C190.54 20.6356 190.64 20.6917 190.668 20.7885C191.386 23.3926 190.892 25.9697 189.236 28.2468C186.323 32.2517 180.237 34.8365 172.958 35.1635C172.957 35.1635 172.953 35.1635 172.951 35.1635H172.949Z",
    fill: "url(#paint20_linear_376_3569)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M188.42 12.5737C188.36 12.5737 188.302 12.5447 188.267 12.4905C186.123 9.20729 182.621 6.93399 178.5 5.79637C174.653 5.56614 170.177 6.57607 165.739 8.7565C165.656 8.79713 165.557 8.77004 165.505 8.69265C164.897 7.76205 164.339 6.95334 163.83 6.26071C162.573 6.66506 161.327 7.16229 160.113 7.76012C160.064 7.78333 160.006 7.78527 159.958 7.76205C159.907 7.74077 159.871 7.69627 159.857 7.64403C158.976 4.44981 158.931 2.64858 159.725 2.29065C160.663 1.86695 162.336 3.63529 163.971 5.83313C168.928 4.29503 174.085 4.21377 178.544 5.43264C180.357 5.54292 182.033 5.92406 183.503 6.5838C186.119 7.75818 187.882 9.74901 188.599 12.3415C188.622 12.4286 188.579 12.5195 188.498 12.5563C188.475 12.5679 188.448 12.5718 188.422 12.5718L188.42 12.5737ZM180.336 6.01113C183.352 7.12746 185.951 8.88999 187.816 11.2426C186.968 9.34078 185.445 7.85879 183.352 6.92045C182.426 6.50448 181.415 6.20266 180.336 6.01306V6.01113ZM164.198 6.14656C164.723 6.86821 165.24 7.62469 165.722 8.35988C169.542 6.50448 173.394 5.5081 176.857 5.41136C172.89 4.62973 168.472 4.84255 164.198 6.14656ZM160.041 2.59247C159.977 2.59247 159.923 2.60408 159.873 2.62536C159.661 2.72016 159.071 3.33928 160.149 7.33641C161.279 6.79276 162.433 6.33229 163.599 5.95308C161.771 3.5134 160.609 2.59247 160.041 2.59247Z",
    fill: "url(#paint21_linear_376_3569)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M183.971 7.19905C183.911 7.19905 183.853 7.17003 183.818 7.11586C179.455 0.43333 168.563 -1.39305 159.541 3.0394C159.45 3.0839 159.342 3.04714 159.297 2.95621C159.253 2.86528 159.289 2.75693 159.381 2.71243C168.561 -1.79934 179.664 0.0850799 184.124 6.91659C184.179 7.00171 184.155 7.11393 184.072 7.17003C184.041 7.18938 184.006 7.19905 183.971 7.19905Z",
    fill: "url(#paint22_linear_376_3569)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M175.805 5.83526C175.745 5.83526 175.687 5.80624 175.652 5.75206C173.123 1.87681 166.801 0.820457 161.559 3.39557C161.468 3.44007 161.36 3.40331 161.315 3.31238C161.271 3.22145 161.308 3.1131 161.399 3.0686C166.801 0.414165 173.332 1.52856 175.96 5.55279C176.014 5.63792 175.991 5.75013 175.908 5.80624C175.877 5.82558 175.842 5.83526 175.807 5.83526H175.805Z",
    fill: "url(#paint23_linear_376_3569)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M165.66 8.77566C165.622 8.77566 165.583 8.76406 165.548 8.73697C165.469 8.67506 165.453 8.56091 165.515 8.48159C169.389 3.48033 173.64 0.881997 176.893 1.51659C179.002 1.93255 180.53 3.64285 181.309 6.46367C181.336 6.56041 181.278 6.66101 181.181 6.6881C181.084 6.71519 180.983 6.65714 180.956 6.56041C180.216 3.88275 178.787 2.26145 176.821 1.87451C173.71 1.2612 169.59 3.81504 165.804 8.70408C165.767 8.75051 165.715 8.77566 165.658 8.77566H165.66Z",
    fill: "url(#paint24_linear_376_3569)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M165.66 8.7755C165.66 8.7755 165.649 8.7755 165.643 8.7755C165.542 8.76583 165.469 8.67683 165.478 8.57622C165.779 5.47293 166.544 0.245308 168.295 0.0924651C169.292 0.0170109 170.249 1.57059 171.124 4.74354C171.152 4.84027 171.093 4.94088 170.997 4.96797C170.902 4.99505 170.799 4.93701 170.772 4.84027C169.652 0.785096 168.68 0.429107 168.326 0.454258C167.499 0.525843 166.412 2.70627 165.841 8.60911C165.831 8.70391 165.751 8.77357 165.659 8.77357L165.66 8.7755Z",
    fill: "url(#paint25_linear_376_3569)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M150.957 23.422C150.897 23.422 150.839 23.393 150.804 23.3388C148.945 20.4928 148.455 17.1941 149.387 13.8045C150.634 9.26369 154.277 5.22012 159.381 2.71272C159.472 2.66822 159.58 2.70498 159.625 2.79591C159.67 2.88685 159.633 2.99519 159.542 3.03969C154.531 5.50259 150.957 9.46103 149.737 13.9012C148.834 17.1902 149.309 20.3845 151.11 23.1395C151.165 23.2246 151.141 23.3369 151.058 23.393C151.027 23.4123 150.992 23.422 150.957 23.422Z",
    fill: "url(#paint26_linear_376_3569)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M156.508 15.3189C156.448 15.3189 156.39 15.2898 156.355 15.2357C155.273 13.5776 154.974 11.5752 155.517 9.59981C156.251 6.92409 158.395 4.54438 161.399 3.06819C161.49 3.02369 161.599 3.06045 161.643 3.15138C161.688 3.24232 161.651 3.35066 161.56 3.39516C158.651 4.82492 156.576 7.12143 155.869 9.69655C155.348 11.5964 155.621 13.4441 156.661 15.0364C156.716 15.1215 156.692 15.2337 156.609 15.2898C156.578 15.3092 156.543 15.3189 156.508 15.3189Z",
    fill: "url(#paint27_linear_376_3569)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M151.65 14.4582C151.571 14.4582 151.497 14.406 151.474 14.3248C150.69 11.4865 151.112 9.25578 152.692 7.87439C155.1 5.77134 159.975 5.97642 165.732 8.42578C165.825 8.46448 165.867 8.57282 165.828 8.66569C165.79 8.75855 165.683 8.80112 165.588 8.76242C159.963 6.36917 155.234 6.14087 152.932 8.15105C151.464 9.43377 151.083 11.5349 151.827 14.23C151.854 14.3267 151.796 14.4273 151.699 14.4544C151.683 14.4582 151.666 14.4602 151.65 14.4602V14.4582Z",
    fill: "url(#paint28_linear_376_3569)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M148.118 22.9187C148.039 22.9187 147.965 22.8665 147.942 22.7853C147.223 20.1831 147.717 17.6041 149.373 15.3288C152.286 11.324 158.372 8.73723 165.651 8.4122C165.759 8.39092 165.837 8.48572 165.841 8.58632C165.845 8.68693 165.767 8.77206 165.666 8.77593C158.496 9.09709 152.515 11.6277 149.668 15.5436C148.079 17.726 147.605 20.1966 148.294 22.6885C148.321 22.7853 148.263 22.8859 148.167 22.9129C148.151 22.9168 148.134 22.9187 148.118 22.9187Z",
    fill: "url(#paint29_linear_376_3569)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M166.516 38.9786C159.619 38.9786 153.293 36.2719 150.033 31.2803C150.024 31.2648 150.016 31.2474 150.01 31.2281C147.978 23.8742 154.963 13.6453 165.579 8.42931C165.662 8.38674 165.761 8.41577 165.813 8.49315C170.933 16.3307 176.736 28.6375 178.75 35.9275C178.773 36.0126 178.733 36.1016 178.655 36.1403C174.746 38.0615 170.536 38.9805 166.518 38.9805L166.516 38.9786ZM150.353 31.1043C155.404 38.8006 167.932 40.9288 178.355 35.8772C176.325 28.6433 170.64 16.5919 165.593 8.82786C155.22 13.9858 148.399 23.9458 150.351 31.1043H150.353Z",
    fill: "url(#paint30_linear_376_3569)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M165.058 29.9977C159.094 29.9977 153.622 27.6566 150.802 23.3383C150.748 23.2532 150.771 23.141 150.855 23.0849C150.94 23.0307 151.052 23.0539 151.108 23.1371C155.472 29.8177 166.363 31.646 175.385 27.2136C175.476 27.1691 175.585 27.2059 175.629 27.2968C175.674 27.3877 175.637 27.4961 175.546 27.5406C172.168 29.2006 168.529 29.9957 165.056 29.9957L165.058 29.9977Z",
    fill: "url(#paint31_linear_376_3569)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M164.753 19.1614C161.242 19.1614 158.019 17.78 156.355 15.2358C156.301 15.1507 156.324 15.0385 156.407 14.9824C156.492 14.9282 156.605 14.9514 156.661 15.0346C159.193 18.9079 165.515 19.9662 170.756 17.3911C170.847 17.3466 170.955 17.3834 171 17.4743C171.044 17.5652 171.008 17.6736 170.917 17.7181C168.931 18.6932 166.795 19.1594 164.753 19.1594V19.1614Z",
    fill: "url(#paint32_linear_376_3569)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M157.475 37.2414C157.395 37.2414 157.322 37.1892 157.298 37.1079C155.276 29.785 158.962 16.9423 165.515 8.48175C165.577 8.40243 165.691 8.38888 165.77 8.44886C165.85 8.51077 165.865 8.62492 165.803 8.70424C159.311 17.0855 155.654 29.785 157.649 37.0112C157.676 37.1079 157.618 37.2085 157.521 37.2356C157.506 37.2395 157.488 37.2414 157.473 37.2414H157.475Z",
    fill: "url(#paint33_linear_376_3569)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M167.659 38.9635C167.579 38.9635 167.506 38.9112 167.483 38.83C165.468 31.538 164.569 17.9659 165.478 8.57672C165.488 8.47611 165.586 8.4084 165.677 8.41227C165.778 8.42194 165.852 8.51094 165.842 8.61154C164.937 17.964 165.83 31.4761 167.835 38.7313C167.862 38.828 167.804 38.9286 167.707 38.9557C167.692 38.9596 167.674 38.9615 167.659 38.9615V38.9635Z",
    fill: "url(#paint34_linear_376_3569)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M178.574 36.1585C178.548 36.1585 178.523 36.1527 178.498 36.143C178.448 36.1217 178.411 36.0772 178.397 36.025C176.393 28.7659 170.609 16.5056 165.507 8.69509C165.478 8.65059 165.47 8.59835 165.484 8.54805C165.498 8.49774 165.532 8.45518 165.579 8.43196C172.164 5.19711 178.864 4.50835 183.501 6.58817C186.11 7.75868 187.869 9.73984 188.589 12.3169C190.726 15.6001 191.287 19.4018 190.214 23.3119C188.773 28.5628 184.559 33.237 178.655 36.1391C178.63 36.1507 178.603 36.1585 178.574 36.1585ZM165.926 8.668C170.967 16.4359 176.639 28.4544 178.69 35.7154C184.398 32.854 188.463 28.3074 189.862 23.2171C190.91 19.4018 190.36 15.693 188.268 12.4929C188.258 12.4775 188.25 12.4601 188.245 12.4407C187.559 9.95846 185.866 8.04889 183.352 6.91901C178.854 4.9011 172.352 5.55697 165.926 8.66607V8.668Z",
    fill: "url(#paint35_linear_376_3569)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M175.469 27.5623C175.401 27.5623 175.337 27.5256 175.304 27.4598C175.26 27.3689 175.296 27.2605 175.387 27.216C180.398 24.7531 183.972 20.7947 185.192 16.3545C186.095 13.0655 185.62 9.87122 183.819 7.11618C183.764 7.03105 183.788 6.91884 183.871 6.86273C183.956 6.80856 184.069 6.83178 184.125 6.91497C185.984 9.76095 186.474 13.0577 185.543 16.4493C184.295 20.9901 180.652 25.0336 175.548 27.541C175.523 27.5546 175.494 27.5604 175.467 27.5604L175.469 27.5623Z",
    fill: "url(#paint36_linear_376_3569)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M170.835 17.7394C170.768 17.7394 170.704 17.7026 170.671 17.6368C170.626 17.5459 170.663 17.4375 170.754 17.393C173.663 15.9633 175.738 13.6668 176.445 11.0917C176.968 9.19176 176.693 7.34603 175.652 5.75375C175.598 5.66862 175.621 5.55641 175.705 5.5003C175.79 5.4442 175.902 5.46935 175.958 5.55254C177.041 7.2106 177.34 9.2111 176.797 11.1865C176.063 13.8622 173.919 16.2419 170.915 17.7181C170.89 17.7316 170.861 17.7374 170.833 17.7374L170.835 17.7394Z",
    fill: "url(#paint37_linear_376_3569)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M186.957 29.4795C186.877 29.4795 186.804 29.4273 186.78 29.346C184.783 22.1179 175.277 12.8835 165.589 8.76253C165.496 8.72384 165.453 8.61549 165.492 8.52263C165.531 8.42976 165.637 8.3872 165.732 8.42589C175.509 12.5855 185.111 21.9264 187.133 29.2493C187.16 29.346 187.102 29.4466 187.005 29.4737C186.99 29.4776 186.972 29.4795 186.957 29.4795Z",
    fill: "url(#paint38_linear_376_3569)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M190.489 21.0191C190.41 21.0191 190.336 20.9668 190.313 20.8856C188.326 13.6884 177.266 8.26539 165.668 8.77615C165.546 8.7897 165.482 8.70263 165.478 8.60203C165.474 8.50142 165.552 8.41629 165.652 8.41243C177.423 7.87844 188.636 13.4369 190.668 20.7888C190.695 20.8856 190.637 20.9862 190.54 21.0133C190.524 21.0171 190.507 21.0191 190.491 21.0191H190.489Z",
    fill: "url(#paint39_linear_376_3569)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M169.304 317.955C181.211 317.955 190.863 308.313 190.863 296.419C190.863 284.526 181.211 274.884 169.304 274.884C157.397 274.884 147.744 284.526 147.744 296.419C147.744 308.313 157.397 317.955 169.304 317.955Z",
    fill: "#141332"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M169.302 318.138C157.421 318.138 147.692 308.547 147.564 296.653C147.502 290.852 149.705 285.375 153.768 281.229C157.83 277.083 163.267 274.767 169.074 274.703C174.865 274.643 180.364 276.841 184.515 280.898C188.665 284.957 190.984 290.386 191.048 296.187C191.11 301.987 188.907 307.464 184.844 311.61C180.782 315.756 175.345 318.074 169.538 318.136C169.461 318.136 169.382 318.136 169.302 318.136V318.138ZM169.312 275.067C169.232 275.067 169.155 275.067 169.075 275.067C163.366 275.127 158.022 277.406 154.028 281.483C150.034 285.559 147.866 290.945 147.928 296.647C148.054 308.342 157.621 317.772 169.302 317.772C169.38 317.772 169.457 317.772 169.535 317.772C175.245 317.71 180.588 315.433 184.582 311.357C188.576 307.28 190.744 301.894 190.682 296.192C190.622 290.489 188.34 285.151 184.259 281.161C180.234 277.228 174.935 275.069 169.312 275.069V275.067Z",
    fill: "url(#paint40_linear_376_3569)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M169.496 315.363C169.341 315.363 169.194 315.332 169.08 315.274C168.925 315.197 168.835 315.075 168.835 314.938C168.834 314.692 169.118 314.502 169.5 314.499H169.513C169.893 314.499 170.17 314.677 170.174 314.924C170.176 315.17 169.891 315.36 169.51 315.363H169.498H169.496ZM169.219 314.934C169.262 314.961 169.339 315 169.504 315C169.694 314.998 169.796 314.932 169.81 314.909C169.796 314.926 169.695 314.864 169.51 314.864H169.5C169.353 314.864 169.258 314.907 169.215 314.934H169.219Z",
    fill: "url(#paint41_linear_376_3569)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M169.504 315.114C169.434 315.114 169.368 315.074 169.337 315.006C169.3 314.923 169.329 314.826 169.407 314.778C169.451 314.749 173.933 311.835 172.399 304.411C170.993 297.613 166.507 291.367 163.234 286.805C162.835 286.25 162.451 285.714 162.089 285.202C159.318 281.278 158.128 279.43 158.38 278.211C158.465 277.803 158.715 277.476 159.143 277.215C159.228 277.161 159.341 277.19 159.395 277.275C159.447 277.362 159.42 277.474 159.335 277.526C158.992 277.735 158.804 277.977 158.74 278.287C158.506 279.421 159.974 281.572 162.391 284.991C162.754 285.503 163.137 286.037 163.536 286.593C166.831 291.18 171.342 297.462 172.764 304.336C173.914 309.898 171.77 313.025 170.482 314.338C172.312 313.452 176.041 310.984 176.854 305.321C177.995 297.381 173.174 288.906 170.199 284.563C168.502 282.085 166.563 279.978 165.15 278.442C163.647 276.809 163.042 276.13 163.164 275.737C163.186 275.669 163.249 275.547 163.439 275.505C163.54 275.483 163.635 275.545 163.658 275.642C163.679 275.741 163.617 275.837 163.521 275.861C163.48 276.089 164.466 277.161 165.419 278.196C166.84 279.742 168.789 281.858 170.501 284.358C173.507 288.746 178.375 297.311 177.216 305.375C176.099 313.154 169.628 315.091 169.564 315.11C169.546 315.116 169.531 315.118 169.513 315.118L169.504 315.114Z",
    fill: "url(#paint42_linear_376_3569)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M170.52 315.166C169.873 315.166 169.494 315.116 169.478 315.114C169.385 315.1 169.317 315.021 169.321 314.928C169.325 314.835 169.399 314.758 169.492 314.752C169.565 314.746 176.875 314.168 180.24 306.948C183.612 299.71 181.293 291.071 178 285.399C174.776 279.848 169.714 275.412 167.342 275.152C167.241 275.141 167.169 275.052 167.181 274.951C167.193 274.851 167.28 274.767 167.382 274.791C170.158 275.092 175.267 279.964 178.316 285.217C181.657 290.967 184.003 299.737 180.571 307.102C178.157 312.282 173.766 314.133 171.307 314.779C173.774 314.634 178.376 313.702 182.252 309.192C188.746 301.635 185.897 291.563 184.371 287.583C181.954 281.282 175.825 275.864 171.959 275.23C171.86 275.214 171.793 275.119 171.808 275.019C171.824 274.92 171.921 274.854 172.017 274.868C175.988 275.52 182.176 280.848 184.71 287.449C186.259 291.491 189.149 301.72 182.527 309.428C178.103 314.574 172.744 315.164 170.52 315.164V315.166Z",
    fill: "url(#paint43_linear_376_3569)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M174.405 316.356C171.364 316.356 169.437 315.11 169.4 315.083C169.325 315.033 169.298 314.934 169.338 314.853C169.377 314.771 169.472 314.729 169.559 314.76C169.666 314.793 180.169 318.039 187.113 306.172C187.179 306.067 193.323 296.001 185.575 283.76C182.449 278.82 177.694 276.773 177.646 276.754C177.553 276.715 177.51 276.609 177.549 276.516C177.587 276.423 177.696 276.379 177.789 276.419C177.837 276.441 182.695 278.526 185.885 283.566C193.759 296.01 187.491 306.261 187.425 306.363C181.936 315.745 174.24 315.868 170.99 315.423C173.584 316.34 179.524 317.147 186.228 309.47C186.294 309.395 186.41 309.387 186.486 309.453C186.561 309.519 186.569 309.635 186.503 309.71C181.849 315.04 177.537 316.36 174.407 316.36L174.405 316.356Z",
    fill: "url(#paint44_linear_376_3569)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M171.659 317.991C171.094 317.991 170.617 317.817 170.239 317.475C169.292 316.614 169.319 314.996 169.321 314.929C169.323 314.845 169.381 314.776 169.461 314.756C169.538 314.735 169.623 314.774 169.664 314.845C169.747 314.996 171.766 318.515 177.572 316.116C177.665 316.078 177.774 316.124 177.811 316.215C177.849 316.308 177.805 316.414 177.712 316.453C173.005 318.394 170.603 316.529 169.734 315.542C169.807 316.051 169.999 316.761 170.487 317.206C170.861 317.544 171.363 317.678 171.973 317.608C172.072 317.6 172.165 317.668 172.176 317.767C172.188 317.867 172.116 317.958 172.017 317.97C171.895 317.983 171.775 317.991 171.661 317.991H171.659Z",
    fill: "url(#paint45_linear_376_3569)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M167.962 318.095C167.962 318.095 167.95 318.095 167.944 318.095C167.632 318.066 167.512 317.908 167.466 317.78C167.456 317.755 167.45 317.73 167.446 317.703C166.805 317.902 166.056 317.919 165.205 317.751C165.107 317.732 165.043 317.635 165.062 317.538C165.081 317.44 165.18 317.376 165.277 317.395C166.137 317.565 166.881 317.532 167.497 317.302C167.77 316.47 168.955 315.228 169.376 314.806C169.43 314.752 169.515 314.737 169.585 314.772C169.654 314.804 169.695 314.88 169.685 314.957C169.678 315.017 169.499 316.42 168.337 317.262C168.169 317.383 167.991 317.488 167.799 317.573C167.799 317.606 167.799 317.635 167.809 317.658C167.824 317.701 167.88 317.726 167.979 317.736C168.08 317.745 168.153 317.834 168.144 317.933C168.134 318.028 168.055 318.099 167.962 318.099V318.095ZM169.137 315.58C168.674 316.093 168.254 316.627 168.014 317.037C168.049 317.014 168.084 316.991 168.118 316.965C168.669 316.569 168.973 316.014 169.139 315.582L169.137 315.58Z",
    fill: "url(#paint46_linear_376_3569)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M169.813 318.131C169.716 318.131 169.635 318.053 169.631 317.955C169.627 317.854 169.705 317.769 169.807 317.765C170.243 317.748 170.328 317.57 170.356 317.512C170.598 317.001 169.873 315.726 169.358 315.043C169.306 314.973 169.31 314.877 169.368 314.811C169.426 314.745 169.523 314.731 169.596 314.776L173.867 317.336C173.954 317.388 173.981 317.5 173.929 317.587C173.877 317.674 173.764 317.701 173.679 317.649L170.11 315.509C170.503 316.157 170.954 317.101 170.685 317.67C170.547 317.959 170.257 318.115 169.821 318.133H169.813V318.131Z",
    fill: "url(#paint47_linear_376_3569)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M176.757 316.488C174.156 316.488 169.681 315.174 169.451 315.106C169.362 315.079 169.306 314.99 169.323 314.899C169.34 314.808 169.418 314.737 169.517 314.75C169.612 314.756 179.135 315.424 181.893 313.68C181.977 313.626 182.091 313.651 182.145 313.737C182.2 313.822 182.174 313.934 182.089 313.988C179.943 315.346 174.138 315.315 171.213 315.205C173.336 315.741 176.875 316.501 178.002 315.932C178.091 315.888 178.202 315.923 178.246 316.014C178.291 316.103 178.256 316.213 178.165 316.259C177.84 316.424 177.346 316.49 176.757 316.49V316.488Z",
    fill: "url(#paint48_linear_376_3569)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M169.503 315.114C169.503 315.114 169.488 315.114 169.48 315.114C169.41 315.104 169.35 315.056 169.329 314.988L169.294 314.874C169.116 314.292 168.783 313.208 166.921 310.362C165.42 308.068 162.61 305.102 159.635 301.964C157.487 299.698 155.265 297.355 153.252 294.983C148.356 289.212 150.163 286.095 150.243 285.965C150.295 285.878 150.407 285.851 150.492 285.903C150.58 285.956 150.607 286.068 150.554 286.153C150.537 286.182 148.823 289.196 153.531 294.745C155.538 297.109 157.756 299.448 159.9 301.712C162.887 304.862 165.709 307.839 167.227 310.161C168.806 312.574 169.304 313.75 169.532 314.421C169.935 313.317 170.615 309.993 167.365 304.359C164.94 300.157 162.193 296.564 159.768 293.393C158.071 291.174 156.47 289.078 155.298 287.171C152.503 282.624 153.936 281.121 154.548 280.478L154.602 280.422C154.672 280.349 154.786 280.345 154.86 280.415C154.934 280.482 154.938 280.598 154.868 280.672L154.812 280.73C154.258 281.31 152.96 282.672 155.608 286.979C156.77 288.871 158.368 290.959 160.059 293.17C162.49 296.349 165.246 299.953 167.682 304.175C171.849 311.399 169.751 314.884 169.658 315.029C169.625 315.081 169.565 315.114 169.503 315.114Z",
    fill: "url(#paint49_linear_376_3569)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M169.503 315.114C169.484 315.114 169.462 315.11 169.443 315.104C169.418 315.097 166.94 314.23 162.972 312.202C162.257 311.837 161.478 311.457 160.663 311.063C155.365 308.488 148.77 305.28 147.899 300.244C147.881 300.143 147.947 300.05 148.048 300.033C148.147 300.012 148.242 300.081 148.259 300.182C149.101 305.036 155.602 308.197 160.824 310.736C161.641 311.132 162.422 311.514 163.138 311.879C165.708 313.193 167.647 314.015 168.693 314.431C167.556 313.456 165.3 311.699 162.6 309.596C159.832 307.441 156.694 304.999 153.727 302.596C146.979 297.127 147.771 293.298 147.808 293.138C147.831 293.041 147.93 292.977 148.027 293.002C148.125 293.023 148.185 293.122 148.164 293.221C148.156 293.257 147.409 297.009 153.957 302.314C156.919 304.715 160.057 307.157 162.824 309.31C166.293 312.009 169.032 314.141 169.638 314.814C169.695 314.876 169.7 314.967 169.656 315.037C169.621 315.089 169.563 315.118 169.503 315.118V315.114Z",
    fill: "url(#paint50_linear_376_3569)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M167.934 315.135C164.659 315.135 157.276 314.892 155.002 312.775C154.928 312.707 154.924 312.591 154.992 312.518C155.062 312.444 155.176 312.44 155.25 312.508C157.343 314.456 164.295 314.743 167.652 314.764C162.918 313.843 159.877 313.054 156.092 311.494C151.775 309.716 150.737 307.735 150.694 307.652C150.65 307.563 150.684 307.453 150.775 307.408C150.865 307.362 150.975 307.4 151.021 307.487C151.031 307.507 152.06 309.438 156.232 311.157C160.45 312.895 163.745 313.671 169.536 314.75C169.627 314.768 169.691 314.851 169.685 314.944C169.678 315.037 169.602 315.11 169.509 315.112C169.408 315.116 168.822 315.133 167.934 315.133V315.135Z",
    fill: "url(#paint51_linear_376_3569)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M164.687 317.089C163.393 317.089 161.824 316.805 159.951 316.027C159.916 316.013 159.889 315.988 159.869 315.959C159.825 315.944 159.78 315.926 159.74 315.907C159.647 315.866 159.604 315.76 159.645 315.667C159.685 315.574 159.792 315.534 159.885 315.572C162.029 316.497 169.389 314.769 169.463 314.752C169.538 314.735 169.614 314.764 169.657 314.828C169.699 314.889 169.699 314.973 169.655 315.035C169.635 315.062 168.146 317.087 164.688 317.087L164.687 317.089ZM161.508 316.205C165.773 317.519 168.099 316.021 168.961 315.242C167.555 315.549 163.952 316.267 161.508 316.205Z",
    fill: "url(#paint52_linear_376_3569)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M163.931 317.449C163.879 317.449 163.832 317.444 163.795 317.434C163.699 317.405 163.644 317.302 163.673 317.208C163.702 317.111 163.803 317.059 163.902 317.086C164.295 317.21 167.018 316.004 169.42 314.772C169.511 314.727 169.62 314.762 169.666 314.851C169.713 314.94 169.678 315.05 169.587 315.097C168.791 315.505 164.944 317.451 163.931 317.451V317.449Z",
    fill: "url(#paint53_linear_376_3569)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M164.702 316.23C164.252 316.23 163.78 316.203 163.29 316.139C159.858 315.696 155.033 313.57 151.787 308.925C149.528 305.694 148.92 303.788 148.449 301.965C147.967 300.091 147.477 297.777 147.8 294.046C148.128 290.251 150.107 286.257 150.127 286.217C150.171 286.126 150.282 286.091 150.371 286.135C150.462 286.18 150.497 286.29 150.452 286.379C150.433 286.418 148.484 290.353 148.163 294.077C147.845 297.751 148.325 300.029 148.802 301.874C149.263 303.664 149.861 305.535 152.085 308.716C155.263 313.262 159.98 315.346 163.334 315.777C165.2 316.017 166.821 315.71 167.921 315.373C163.751 315.824 159.85 314.533 156.046 311.469C151.8 308.048 149.733 302.352 149.569 298.224C149.396 293.894 149.571 289.157 153.691 283.065C157.713 277.114 162.827 275.678 162.877 275.665C162.976 275.64 163.075 275.696 163.102 275.792C163.129 275.889 163.071 275.99 162.974 276.017C162.924 276.03 157.938 277.439 153.995 283.27C149.937 289.272 149.764 293.942 149.935 298.212C150.098 302.257 152.12 307.839 156.276 311.186C160.481 314.572 164.799 315.744 169.476 314.758C169.563 314.742 169.653 314.789 169.685 314.872C169.716 314.957 169.684 315.052 169.604 315.094C169.509 315.149 167.534 316.23 164.702 316.23Z",
    fill: "url(#paint54_linear_376_3569)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M169.054 315.132C167.278 315.132 160.909 314.714 156.694 309.047C151.628 302.233 152.642 293.192 155.284 287.005C157.891 280.895 163.135 275.64 167.481 274.779C167.58 274.76 167.677 274.824 167.696 274.923C167.715 275.021 167.651 275.118 167.553 275.137C163.313 275.977 158.184 281.141 155.619 287.148C153.018 293.244 152.013 302.14 156.987 308.83C160.34 313.34 165.091 314.443 167.667 314.697C161.676 312.88 157.845 307.256 157.746 299.871C157.64 291.931 162.616 283.073 166.183 279.32C170.038 275.265 171.793 274.876 171.864 274.861C171.961 274.841 172.06 274.903 172.079 275.004C172.099 275.102 172.035 275.197 171.938 275.219C171.913 275.224 170.187 275.638 166.449 279.572C162.924 283.281 158.006 292.029 158.11 299.867C158.217 307.91 162.598 313.617 169.544 314.758C169.635 314.774 169.701 314.855 169.697 314.946C169.693 315.039 169.621 315.112 169.528 315.12C169.517 315.12 169.348 315.134 169.054 315.134V315.132Z",
    fill: "url(#paint55_linear_376_3569)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M169.515 315.12C169.495 315.12 169.476 315.118 169.456 315.111C169.394 315.089 163.313 312.971 162.718 305.162C162.245 298.954 164.69 292.149 170.192 284.356C171.448 282.58 172.61 281.071 173.545 279.86C174.955 278.032 176.069 276.588 175.932 276.17C175.926 276.149 175.91 276.103 175.798 276.07C175.701 276.043 175.645 275.942 175.672 275.845C175.699 275.749 175.8 275.689 175.899 275.72C176.145 275.789 176.241 275.942 176.28 276.054C176.47 276.633 175.717 277.645 173.836 280.08C172.902 281.29 171.742 282.795 170.493 284.565C165.042 292.285 162.619 299.014 163.086 305.133C163.526 310.91 167.039 313.466 168.705 314.364C165.666 310.841 166.127 305.195 170.078 297.559C171.308 295.185 173.855 291.366 176.102 287.995C178.111 284.983 180.009 282.137 180.499 281.013C181.458 278.811 180.321 278.115 180.272 278.086C180.185 278.035 180.156 277.923 180.206 277.836C180.257 277.749 180.367 277.72 180.454 277.768C180.514 277.803 181.93 278.641 180.834 281.158C180.33 282.313 178.513 285.041 176.408 288.199C174.167 291.559 171.626 295.371 170.406 297.727C166.263 305.731 166.005 311.477 169.642 314.803C169.706 314.861 169.72 314.956 169.675 315.029C169.642 315.085 169.58 315.118 169.518 315.118L169.515 315.12Z",
    fill: "url(#paint56_linear_376_3569)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M169.515 315.117C169.439 315.117 169.372 315.071 169.344 315.001C169.284 314.847 167.94 311.147 172.424 304.273C175.539 299.496 177.164 297.451 178.736 295.472C179.436 294.594 180.156 293.685 181.005 292.543C183.412 289.304 187.05 284.411 184.807 281.714C184.743 281.637 184.752 281.521 184.83 281.457C184.907 281.393 185.024 281.403 185.088 281.48C187.513 284.398 183.772 289.43 181.297 292.76C180.445 293.905 179.722 294.816 179.021 295.697C177.383 297.761 175.835 299.709 172.728 304.471C169.279 309.758 169.366 313.14 169.565 314.359C169.885 313.728 170.634 312.473 172.36 310.259C173.886 308.303 176.29 305.856 178.837 303.263C181.481 300.574 184.214 297.792 186.275 295.252C190.207 290.405 188.692 287.401 188.675 287.37C188.628 287.281 188.661 287.17 188.75 287.124C188.837 287.077 188.95 287.11 188.996 287.199C189.066 287.329 190.656 290.43 186.558 295.482C184.485 298.038 181.744 300.824 179.097 303.521C176.557 306.104 174.16 308.543 172.649 310.484C170.022 313.854 169.695 314.97 169.691 314.98C169.67 315.056 169.602 315.11 169.525 315.115H169.515V315.117Z",
    fill: "url(#paint57_linear_376_3569)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M169.515 315.12C169.449 315.12 169.385 315.083 169.354 315.023C169.312 314.944 169.335 314.845 169.408 314.791C169.408 314.791 175.86 310.084 180.298 306.878L180.451 306.768C184.755 303.658 191.259 298.957 190.585 294.525C190.569 294.426 190.637 294.333 190.738 294.318C190.836 294.304 190.931 294.372 190.945 294.47C191.654 299.122 185.039 303.9 180.664 307.064L180.511 307.174C177.172 309.586 172.69 312.85 170.677 314.317C172.848 313.498 177.592 311.616 182.302 309.149C187.577 306.388 189.136 304.419 189.858 302.31C189.891 302.215 189.994 302.161 190.091 302.196C190.186 302.229 190.236 302.331 190.205 302.428C189.455 304.618 187.854 306.653 182.475 309.472C176.087 312.817 169.641 315.087 169.577 315.11C169.558 315.116 169.536 315.12 169.517 315.12H169.515Z",
    fill: "url(#paint58_linear_376_3569)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M169.49 315.116C169.399 315.116 169.319 315.048 169.308 314.953C169.296 314.853 169.368 314.764 169.469 314.752C172.699 314.384 179.614 312.953 182.543 311.728C185.462 310.505 186.356 309.296 186.366 309.283C186.424 309.201 186.539 309.182 186.62 309.24C186.701 309.298 186.721 309.412 186.663 309.493C186.626 309.546 185.713 310.794 182.684 312.063C179.521 313.386 172.357 314.791 169.509 315.114C169.502 315.114 169.496 315.114 169.488 315.114L169.49 315.116Z",
    fill: "url(#paint59_linear_376_3569)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6734 174.327C55.093 165.917 55.093 152.282 46.6734 143.872C38.2538 135.462 24.603 135.462 16.1835 143.872C7.76389 152.282 7.76389 165.917 16.1835 174.327C24.603 182.738 38.2538 182.738 46.6734 174.327Z",
    fill: "#27E6D6"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M306.375 180.635C318.282 180.635 327.934 170.994 327.934 159.1C327.934 147.206 318.282 137.564 306.375 137.564C294.468 137.564 284.815 147.206 284.815 159.1C284.815 170.994 294.468 180.635 306.375 180.635Z",
    fill: "#27E6D6"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M247.388 36.5433H247.382C245.892 36.6188 244.38 36.7523 242.838 36.9438C239.638 37.3327 236.328 37.9557 232.919 38.7973V38.7915C232.919 38.7915 232.902 38.8031 232.896 38.8031C231.499 39.1455 230.091 39.5286 228.66 39.9542C228.654 39.9542 228.648 39.96 228.642 39.96C228.608 39.9716 228.573 39.9832 228.538 39.9949C227.531 40.2851 226.508 40.6043 225.478 40.9487C225.46 40.9545 225.443 40.9603 225.425 40.9661L225.419 40.9719C225.036 41.088 224.658 41.2157 224.267 41.3492C224.267 41.3492 224.255 41.355 224.238 41.3608C222.795 41.8483 221.34 42.3726 219.868 42.9356C219.862 42.9356 219.862 42.9414 219.857 42.9414C218.297 43.5335 216.715 44.1739 215.121 44.8529C215.121 44.8529 215.086 44.8704 215.034 44.8936C213.527 45.5262 212.008 46.2014 210.478 46.9096C210.467 46.9154 210.455 46.9212 210.443 46.9328C208.692 47.7415 206.918 48.6005 205.132 49.5079L205.121 49.5137C205.121 49.5137 205.115 49.5195 205.109 49.5195C203.66 50.2508 202.2 51.0131 200.734 51.8025C200.699 51.8199 200.664 51.8431 200.629 51.8605C198.895 52.7969 197.15 53.772 195.388 54.7955C195.388 54.7955 195.382 54.8013 195.37 54.8071C193.753 55.7377 192.124 56.707 190.478 57.713C188.494 58.9222 186.499 60.1895 184.479 61.4954C184.467 61.507 184.45 61.5186 184.438 61.5244L184.433 61.5303C182.722 62.6466 180.995 63.7958 179.261 64.9876C175.875 67.2996 172.443 69.7528 168.982 72.3453C169.156 72.473 169.331 72.6007 169.505 72.7342C169.517 72.7458 169.534 72.7574 169.546 72.7691C171.663 74.3555 173.799 75.9942 175.945 77.6794C175.945 77.6794 175.951 77.6852 175.963 77.6968C175.974 77.7026 175.992 77.7142 176.009 77.7316C177.783 79.1266 179.569 80.5563 181.361 82.0209C183.298 83.6074 185.24 85.2287 187.197 86.8906L187.202 86.8848C187.202 86.8848 187.231 86.9138 187.284 86.9719C189.168 88.5641 191.065 90.2028 192.969 91.8764C192.969 91.8764 192.974 91.8822 192.98 91.888L192.986 91.8938C194.905 93.5847 196.837 95.3105 198.775 97.0769V97.0827C200.613 98.7562 202.463 100.465 204.313 102.208V102.214C205.303 103.144 206.291 104.079 207.286 105.032C208.427 104.255 209.554 103.504 210.672 102.773C210.672 102.767 210.678 102.767 210.678 102.767C212.057 101.865 213.413 101.001 214.757 100.163C214.774 100.151 214.786 100.145 214.786 100.145C216.304 99.1974 217.8 98.2861 219.277 97.4194C219.341 97.3787 219.405 97.3439 219.469 97.3033C220.639 96.6184 221.795 95.9548 222.942 95.3163C224.31 94.556 225.66 93.8285 226.984 93.1378C228.114 92.5516 229.229 91.9867 230.324 91.4527C230.335 91.4469 230.341 91.4469 230.341 91.4469C231.389 90.9361 232.412 90.4524 233.425 89.9939C234.531 89.4947 235.611 89.0227 236.671 88.5873C236.677 88.5873 236.682 88.5815 236.688 88.5815C237.415 88.2739 238.137 87.9895 238.846 87.7148C239.613 87.4188 240.37 87.1402 241.108 86.8771C240.969 87.3356 240.824 87.8077 240.667 88.2778C240.661 88.2836 240.661 88.2894 240.661 88.2952C240.057 90.1138 239.357 92.0021 238.561 93.9485C238.125 95.0068 237.659 96.0805 237.165 97.1736C236.537 98.5628 235.861 99.9751 235.147 101.411C234.99 101.713 234.839 102.02 234.682 102.324C234.112 103.376 233.523 104.433 232.913 105.508C232.907 105.514 232.902 105.52 232.902 105.52C232.028 107.06 231.11 108.623 230.144 110.21C229.365 111.506 228.549 112.814 227.705 114.137L227.699 114.143C226.628 115.828 225.512 117.537 224.348 119.262C224.348 119.262 224.344 119.266 224.337 119.274C223.965 119.825 223.587 120.385 223.207 120.942C224.267 122.046 225.313 123.149 226.349 124.248C228.158 126.171 229.938 128.094 231.672 130.008C231.678 130.014 231.683 130.019 231.689 130.019L231.701 130.031C231.736 130.06 231.771 130.095 231.794 130.13H231.788C233.417 131.919 235.011 133.703 236.576 135.475V135.481H236.582C238.327 137.462 240.026 139.426 241.684 141.392C241.695 141.398 241.701 141.409 241.713 141.421C243.371 143.367 244.982 145.308 246.559 147.244C247.949 148.947 249.305 150.638 250.624 152.323C250.642 152.34 250.653 152.358 250.671 152.375C250.7 152.41 250.729 152.439 250.752 152.474C252.23 154.356 253.673 156.227 255.069 158.086C255.087 158.11 255.104 158.127 255.11 158.133C255.122 158.144 255.122 158.15 255.122 158.15C255.36 158.47 255.598 158.783 255.831 159.104C255.848 159.075 255.871 159.04 255.895 159.005C255.906 158.988 255.918 158.976 255.929 158.959C257.285 157.146 258.606 155.339 259.885 153.55C259.89 153.544 259.896 153.532 259.902 153.521C261.281 151.597 262.608 149.692 263.898 147.798C263.898 147.798 263.904 147.786 263.915 147.769C265.138 145.967 266.317 144.184 267.458 142.411H267.464C267.47 142.4 267.475 142.388 267.481 142.376C268.605 140.639 269.68 138.919 270.727 137.211C270.727 137.211 270.745 137.182 270.78 137.118C272.025 135.079 273.211 133.061 274.346 131.062C274.346 131.062 274.347 131.058 274.351 131.051C275.452 129.11 276.503 127.187 277.505 125.279C278.593 123.205 279.616 121.153 280.582 119.125L280.588 119.131V119.113C281.52 117.173 282.391 115.244 283.201 113.348H283.207V113.331C283.207 113.331 283.213 113.325 283.213 113.319V113.313C283.823 111.901 284.4 110.494 284.94 109.105C284.94 109.099 284.94 109.093 284.946 109.082C285.713 107.118 286.418 105.183 287.046 103.276H287.057C287.057 103.276 287.063 103.253 287.069 103.212C288.378 99.3134 289.413 95.5349 290.176 91.8744V91.8628C290.554 90.0732 290.856 88.3184 291.096 86.5926H291.102V86.5578C291.352 84.7972 291.526 83.0773 291.63 81.3863V81.3747C291.741 79.6489 291.776 77.9638 291.747 76.3077V76.3019C291.735 75.7447 291.706 75.1913 291.677 74.6399V74.6341C291.671 74.5064 291.665 74.3729 291.66 74.2394V74.1988C291.59 73.0651 291.479 71.9565 291.34 70.8634L291.346 70.8575C291.346 70.8575 291.34 70.8169 291.322 70.7299C291.084 68.9344 290.765 67.1854 290.339 65.4887H290.333V65.4771C290.333 65.4771 290.327 65.4597 290.321 65.4481C289.792 63.3508 289.105 61.329 288.262 59.3982L288.309 59.3808C288.309 59.3808 288.262 59.3111 288.181 59.195C288.181 59.195 288.181 59.1892 288.175 59.1834C287.623 57.922 286.994 56.6896 286.308 55.5055L286.302 55.4997C285.15 53.5186 283.817 51.6477 282.3 49.8871C282.3 49.8871 282.271 49.8523 282.213 49.7942C281.632 49.1209 281.014 48.4631 280.375 47.8247C279.864 47.3081 279.333 46.8128 278.798 46.3369C278.793 46.3311 278.787 46.3195 278.781 46.3137L278.775 46.3195C277.913 45.5475 277.03 44.8259 276.11 44.1468C276.11 44.1468 276.104 44.1468 276.093 44.141V44.1352C276.081 44.1294 276.069 44.1235 276.052 44.1061C274.44 42.9202 272.736 41.8812 270.962 40.968L270.973 40.9506C270.973 40.9506 270.88 40.9042 270.712 40.8345C270.712 40.8345 270.706 40.8345 270.7 40.8287C270.689 40.8287 270.683 40.8229 270.671 40.8171C269.35 40.1554 267.983 39.5673 266.575 39.0623C266.569 39.0623 266.563 39.0565 266.557 39.0565H266.551C265.936 38.8301 265.318 38.627 264.684 38.4355C264.684 38.4355 264.649 38.4239 264.603 38.4122C262.341 37.7157 259.978 37.2147 257.518 36.8896H257.512C256.249 36.7213 254.963 36.6052 253.65 36.5356H253.534C253.365 36.524 253.191 36.5182 253.016 36.5124C252.999 36.5124 252.987 36.5065 252.97 36.5065L252.964 36.5124C251.149 36.4369 249.288 36.4427 247.386 36.5472L247.388 36.5433Z",
    fill: "#27E6D6"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M187.676 164.08C185.478 166.375 183.22 168.683 180.899 171.001C176.898 174.998 172.917 178.823 168.979 182.466C168.997 182.477 169.009 182.495 169.026 182.506C174.25 187.335 179.41 191.857 184.473 196.057L184.479 196.063C187.829 198.841 191.14 201.484 194.397 203.984C198.755 207.331 203.024 210.428 207.179 213.265C209.873 210.689 212.571 208.052 215.283 205.344C215.946 204.682 216.61 204.013 217.272 203.351C219.122 201.48 220.943 199.615 222.74 197.75V197.744C222.862 197.616 222.984 197.489 223.112 197.361C222.891 197.036 222.67 196.711 222.444 196.384C222.444 196.384 222.421 196.355 222.386 196.291C221.297 194.711 220.176 193.112 219.017 191.503C217.888 189.928 216.726 188.347 215.521 186.749C215.521 186.743 215.516 186.743 215.516 186.738C214.282 185.093 213.007 183.431 211.7 181.758C211.7 181.758 211.698 181.754 211.694 181.746C210.565 180.299 209.408 178.846 208.221 177.381C208.221 177.375 208.215 177.37 208.215 177.364C206.871 175.714 205.504 174.046 204.09 172.378C204.084 172.366 204.078 172.361 204.072 172.349C202.693 170.705 201.279 169.054 199.836 167.398C198.358 165.701 196.846 163.993 195.298 162.285C194.337 161.22 193.373 160.158 192.383 159.094C190.847 160.75 189.282 162.406 187.676 164.08Z",
    fill: "#27E6D6"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M291.911 240.676C291.911 252.817 288.098 262.877 280.486 270.481C266.472 284.478 244.105 285.622 215.799 273.789C187.89 262.123 155.654 238.492 122.576 205.451C89.4973 172.411 65.8419 140.212 54.1605 112.332C42.3144 84.0584 43.461 61.7162 57.4726 47.7185C71.4861 33.7208 93.8534 32.5774 122.159 44.4082C150.068 56.0746 182.304 79.7053 215.382 112.746C248.461 145.786 272.118 177.985 283.798 205.865C289.209 218.781 291.909 230.465 291.909 240.674L291.911 240.676ZM46.3412 77.5287C46.3412 87.7015 49.0335 99.3408 54.4297 112.222C66.0937 140.065 89.7298 172.233 122.781 205.246C155.832 238.26 188.035 261.869 215.909 273.52C244.097 285.302 266.356 284.18 280.278 270.274C294.201 256.367 295.324 234.133 283.528 205.977C271.864 178.134 248.228 145.968 215.177 112.953C182.126 79.9394 149.923 56.33 122.049 44.6791C93.8612 32.8966 71.6023 34.0187 57.6798 47.9255C50.1279 55.469 46.3412 65.4657 46.3412 77.5268V77.5287Z",
    fill: "url(#paint60_linear_376_3569)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M252.388 257.324C252.388 263.051 250.867 267.464 247.847 270.48C244.034 274.289 237.991 275.709 229.885 274.7C221.843 273.697 212.176 270.356 201.149 264.769C177.65 252.86 149.964 231.575 123.192 204.835C96.4204 178.093 75.1126 150.44 63.1909 126.968C57.5972 115.954 54.2521 106.297 53.2488 98.2645C52.2378 90.1677 53.6575 84.1294 57.4732 80.3199C61.287 76.5105 67.332 75.0904 75.436 76.1003C83.4781 77.1025 93.1451 80.4438 104.172 86.0312C127.67 97.9395 155.356 119.225 182.128 145.965C208.9 172.707 230.208 200.36 242.13 223.834C247.723 234.848 251.069 244.504 252.07 252.537C252.281 254.222 252.386 255.819 252.386 257.324H252.388ZM53.2663 93.507C53.2663 102.117 56.7004 113.547 63.4505 126.836C75.3586 150.283 96.649 177.911 123.398 204.63C150.148 231.35 177.807 252.615 201.279 264.509C223.258 275.648 240.156 277.749 247.64 270.273C255.124 262.797 253.019 245.919 241.87 223.963C229.962 200.518 208.672 172.891 181.923 146.17C155.172 119.45 127.514 98.1852 104.042 86.2905C82.0622 75.1523 65.1627 73.0512 57.6805 80.527C54.7267 83.4774 53.2663 87.8925 53.2663 93.507Z",
    fill: "url(#paint61_linear_376_3569)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M246.499 251.254C246.499 256.546 245.125 260.704 242.348 263.478C235.323 270.495 219.43 268.539 198.746 258.107C176.673 246.975 150.777 227.121 125.83 202.2C100.882 177.28 81.0039 151.413 69.8589 129.365C59.4171 108.706 57.4569 92.8316 64.4821 85.8124C71.5072 78.7952 87.3995 80.7512 108.084 91.1832C130.157 102.316 156.053 122.17 181 147.089C205.948 172.008 225.824 197.875 236.969 219.924C243.283 232.414 246.497 243.16 246.497 251.251L246.499 251.254ZM60.616 98.0418C60.616 106.077 63.8216 116.774 70.1204 129.235C81.2518 151.258 101.111 177.098 126.037 201.996C150.963 226.894 176.832 246.729 198.88 257.85C219.444 268.22 235.212 270.197 242.144 263.275C249.077 256.352 247.097 240.6 236.713 220.059C225.582 198.036 205.725 172.196 180.799 147.298C155.873 122.4 130.004 102.565 107.956 91.4463C87.3918 81.0762 71.6234 79.0989 64.6913 86.0214C61.9641 88.7435 60.618 92.8355 60.618 98.0437L60.616 98.0418Z",
    fill: "url(#paint62_linear_376_3569)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M242.981 240.043C242.981 240.08 242.966 240.119 242.937 240.148C236.539 246.377 222.785 244.559 204.21 235.026C185.046 225.192 162.728 208.025 141.365 186.685C123.929 169.269 109.261 151.179 98.9415 134.369C89.197 118.494 83.9596 104.611 84.2056 95.2524C84.3198 90.82 85.6369 87.4381 88.12 85.2035C88.1801 85.1493 88.2711 85.1551 88.3253 85.2131C88.3796 85.2731 88.3738 85.364 88.3137 85.4182C85.8926 87.5986 84.6084 90.909 84.4961 95.2602C84.252 104.551 89.4739 118.388 99.1894 134.216C109.496 151.005 124.15 169.078 141.571 186.478C162.914 207.797 185.205 224.945 204.344 234.765C222.533 244.098 236.525 245.985 242.735 239.937C242.793 239.881 242.884 239.883 242.94 239.939C242.968 239.968 242.981 240.003 242.981 240.039V240.043Z",
    fill: "url(#paint63_linear_376_3569)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M242.785 237.233C242.785 237.298 242.739 237.36 242.671 237.374C233.916 239.274 219.905 234.984 203.216 225.297C185.536 215.034 166.2 199.629 147.302 180.752C128.572 162.041 113.189 142.764 102.821 125.001C92.9796 108.14 88.637 94.1114 90.5952 85.5019C90.6127 85.4245 90.6921 85.3742 90.7696 85.3916C90.847 85.409 90.8974 85.4864 90.88 85.5658C86.7505 103.708 110.571 143.65 147.509 180.547C166.39 199.407 185.705 214.794 203.364 225.046C219.988 234.698 233.926 238.976 242.609 237.091C242.687 237.074 242.764 237.124 242.782 237.202C242.783 237.211 242.785 237.223 242.785 237.233Z",
    fill: "url(#paint64_linear_376_3569)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M242.03 233.968C242.03 233.968 242.03 233.978 242.03 233.982C242.022 234.061 241.951 234.121 241.871 234.113C231.854 233.142 218.303 227.361 202.682 217.397C186.346 206.975 168.867 192.635 152.138 175.924C119.341 143.164 95.9004 107.141 93.8124 86.2887C93.8008 86.2113 93.8628 86.1378 93.9422 86.1301C94.0216 86.1223 94.0933 86.1804 94.101 86.2597C96.1832 107.05 119.589 143.001 152.344 175.719C169.057 192.414 186.518 206.743 202.839 217.153C218.421 227.094 231.929 232.859 241.9 233.825C241.976 233.833 242.032 233.896 242.032 233.97L242.03 233.968Z",
    fill: "url(#paint65_linear_376_3569)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M241.411 231.766C241.411 231.778 241.411 231.791 241.405 231.803C241.384 231.88 241.304 231.927 241.227 231.905C219.287 226.076 185.601 202.821 155.404 172.658C125.303 142.591 102.004 108.942 96.0442 86.9307C96.0229 86.8514 96.0694 86.774 96.1469 86.7527C96.2244 86.7314 96.3038 86.7779 96.3251 86.8553C102.271 108.82 125.543 142.419 155.61 172.453C185.773 202.583 219.407 225.807 241.3 231.625C241.364 231.642 241.409 231.7 241.409 231.766H241.411Z",
    fill: "url(#paint66_linear_376_3569)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M241.265 231.296C241.265 231.312 241.263 231.329 241.257 231.345C241.23 231.42 241.147 231.461 241.072 231.434C218.247 223.499 186.794 200.956 156.934 171.132C127.664 141.895 104.522 109.695 96.5438 87.1014C96.5167 87.0278 96.5554 86.9427 96.6329 86.9156C96.7084 86.8886 96.7917 86.9292 96.8188 87.0046C104.785 109.562 127.9 141.719 157.142 170.927C186.97 200.722 218.383 223.238 241.168 231.161C241.228 231.182 241.265 231.238 241.265 231.298V231.296Z",
    fill: "url(#paint67_linear_376_3569)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M243.02 239.956C243.02 243.773 241.707 246.53 238.898 248.724C232.191 253.961 217.687 251.371 199.105 241.616C179.379 231.261 156.783 213.841 135.483 192.563C114.038 171.142 96.4953 148.388 86.0844 128.493C76.1597 109.525 73.849 95.0608 79.7449 88.8078C82.7607 85.6097 86.5628 84.532 91.3702 85.5149C91.4496 85.5303 91.4961 85.6097 91.4845 85.687C91.4671 85.7664 91.3915 85.8167 91.3121 85.8012C86.6113 84.8396 82.8963 85.8883 79.9561 89.007C74.1531 95.1633 76.4793 109.505 86.342 128.357C96.7393 148.229 114.262 170.956 135.688 192.358C156.969 213.615 179.54 231.018 199.24 241.359C217.718 251.057 232.107 253.66 238.72 248.496C241.955 245.971 243.152 242.669 242.602 237.785C242.586 237.708 242.65 237.634 242.729 237.625C242.809 237.615 242.882 237.673 242.89 237.752C242.977 238.524 243.022 239.258 243.022 239.958L243.02 239.956Z",
    fill: "url(#paint68_linear_376_3569)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M243.574 244.573C243.574 249.425 242.334 253.254 239.82 255.767C233.454 262.126 218.598 260.159 199.064 250.369C177.963 239.794 153.502 221.143 130.184 197.853C106.866 174.561 88.1939 150.127 77.6087 129.05C67.808 109.539 65.8401 94.6993 72.2047 88.3398C78.6004 81.9514 93.5552 83.8222 112.21 93.3411C112.281 93.3778 112.31 93.4649 112.273 93.5365C112.237 93.6081 112.149 93.6371 112.078 93.6003C93.5397 84.1395 78.7108 82.2493 72.4101 88.5449C66.1384 94.8115 68.1256 109.527 77.8682 128.919C88.4418 149.968 107.094 174.375 130.389 197.646C153.686 220.917 178.12 239.548 199.194 250.108C218.609 259.838 233.341 261.824 239.613 255.56C245.916 249.264 244.041 234.475 234.589 216.003C234.554 215.931 234.581 215.844 234.653 215.807C234.724 215.77 234.812 215.799 234.848 215.871C240.62 227.152 243.574 237.081 243.574 244.573Z",
    fill: "url(#paint69_linear_376_3569)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M259.695 261.623C259.695 267.358 258.258 271.873 255.347 274.913C249.972 280.525 238.883 281.249 224.12 276.95C224.043 276.929 223.998 276.849 224.021 276.77C224.045 276.693 224.124 276.648 224.201 276.671C238.854 280.937 249.84 280.243 255.136 274.711C262.63 266.884 260.195 249.049 248.451 225.78C235.732 200.579 213.211 171.202 185.037 143.061C156.815 114.87 127.38 92.3328 102.157 79.6004C78.7962 67.8064 60.9651 65.417 53.2408 73.0417C47.9278 78.2868 47.0795 88.8136 50.8545 102.684C50.8758 102.761 50.8293 102.84 50.7518 102.862C50.6744 102.883 50.5949 102.836 50.5736 102.759C46.7715 88.7826 47.645 78.1552 53.0374 72.8347C60.8586 65.1171 78.8098 67.4891 102.289 79.3412C127.538 92.0871 157.001 114.644 185.245 142.856C213.488 171.068 235.98 200.422 248.713 225.651C255.986 240.062 259.697 252.414 259.697 261.623H259.695Z",
    fill: "url(#paint70_linear_376_3569)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M267.861 262.346C267.861 262.468 267.861 262.588 267.861 262.71C267.797 269.141 266.005 274.092 262.533 277.426C260.295 279.575 256.642 281.266 253.001 281.841C252.922 281.852 252.848 281.798 252.834 281.721C252.823 281.643 252.875 281.568 252.955 281.554C256.54 280.989 260.133 279.326 262.329 277.217C265.742 273.939 267.505 269.058 267.568 262.708C267.692 249.815 260.605 231.06 247.603 209.883C233.68 187.208 213.618 162.532 189.581 138.524C165.529 114.499 140.742 94.4318 117.9 80.496C96.6214 67.5121 77.8199 60.4639 64.9569 60.6457C58.7046 60.7347 53.9185 62.4876 50.7323 65.8579C48.4216 68.2995 46.9611 71.4512 46.3878 75.2219C46.3762 75.3013 46.3006 75.3554 46.2232 75.3438C46.1438 75.3322 46.0876 75.2568 46.1011 75.1774C46.6822 71.3467 48.1698 68.1428 50.5212 65.6567C53.7635 62.2283 58.6193 60.4445 64.953 60.3536C77.8683 60.1698 96.726 67.2335 118.051 80.2464C140.913 94.1958 165.718 114.276 189.786 138.317C213.839 162.343 233.917 187.035 247.849 209.73C260.946 231.062 267.859 249.244 267.859 262.346H267.861Z",
    fill: "url(#paint71_linear_376_3569)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M276.068 260.87C276.068 262.143 276 263.366 275.866 264.54C275.12 271.078 272.258 275.944 267.355 279C267.288 279.043 267.197 279.022 267.154 278.954C267.113 278.886 267.133 278.797 267.2 278.755C272.021 275.746 274.84 270.952 275.576 264.507C277.121 250.959 269.631 230.532 253.911 205.446C239.181 181.941 218.286 156.225 195.07 133.035C171.758 109.749 145.869 88.7843 122.173 74.005C96.7646 58.1577 76.2451 50.7748 62.8321 52.6553C56.4364 53.553 51.7549 56.5963 48.9212 61.7021C48.8825 61.7717 48.7934 61.7969 48.7237 61.7582C48.6539 61.7195 48.6268 61.6305 48.6675 61.5608C51.5496 56.37 56.3008 53.2764 62.7933 52.367C76.2741 50.4768 96.8615 57.8733 122.328 73.7573C146.041 88.5483 171.949 109.526 195.275 132.828C218.505 156.031 239.417 181.765 254.157 205.289C268.554 228.266 276.064 247.356 276.064 260.868L276.068 260.87Z",
    fill: "url(#paint72_linear_376_3569)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M283.352 257.33C283.352 263.565 281.777 268.555 278.639 272.225C278.587 272.287 278.494 272.293 278.434 272.241C278.372 272.188 278.366 272.095 278.416 272.035C287.21 261.752 283.325 240.407 267.479 211.926C252.729 185.416 228.522 154.48 201.06 127.049C173.599 99.6188 142.893 75.5334 116.807 60.9592C103.168 53.3383 91.1064 48.4202 80.9571 46.3404C70.1685 44.129 61.8224 45.2028 56.1512 49.5308C56.0872 49.5791 55.9962 49.5675 55.9478 49.5037C55.8994 49.4398 55.911 49.3489 55.9749 49.3005C61.7159 44.9203 70.1414 43.8291 81.0152 46.0579C91.1936 48.1436 103.282 53.0732 116.949 60.7077C143.058 75.2955 173.791 99.4021 201.266 126.846C228.745 154.294 252.971 185.253 267.733 211.786C275.397 225.563 280.307 237.681 282.321 247.803C283.007 251.245 283.348 254.422 283.348 257.33H283.352Z",
    fill: "url(#paint73_linear_376_3569)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M288.874 250.777C288.874 255.076 288.167 258.88 286.741 262.15C286.708 262.223 286.623 262.256 286.549 262.225C286.476 262.192 286.443 262.105 286.474 262.033C287.886 258.797 288.587 255.028 288.587 250.766C288.587 237.853 282.153 220.406 269.549 199.414C254.856 174.94 231.985 146.476 206.801 121.321C181.376 95.924 152.675 72.9511 128.062 58.2937C99.9463 41.5506 78.253 35.9283 65.3242 42.0362C65.2525 42.071 65.1654 42.0401 65.1305 41.9665C65.0957 41.895 65.1266 41.8079 65.2002 41.7731C78.2201 35.6226 100.008 41.2488 128.212 58.0441C152.843 72.7132 181.564 95.7015 207.007 121.116C232.206 146.287 255.094 174.772 269.799 199.265C282.428 220.298 288.874 237.801 288.874 250.777Z",
    fill: "url(#paint74_linear_376_3569)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M291.756 244.626C291.756 244.694 291.756 244.763 291.756 244.831C291.756 244.91 291.69 244.976 291.611 244.976C291.531 244.976 291.465 244.91 291.465 244.831C291.465 244.763 291.465 244.694 291.465 244.626C291.465 229.934 283.64 209.905 268.825 186.679C254.602 164.381 234.706 140.232 211.287 116.841C163.607 69.2143 113.809 37.7499 84.4183 36.68C84.3389 36.6781 84.2769 36.6162 84.2789 36.5291C84.2808 36.4498 84.3486 36.3859 84.4299 36.3898C113.89 37.4617 163.767 68.9609 211.495 116.636C234.927 140.043 254.837 164.209 269.071 186.524C283.915 209.795 291.756 229.879 291.756 244.628V244.626Z",
    fill: "url(#paint75_linear_376_3569)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M291.841 241.788C291.841 242.819 291.812 243.835 291.756 244.837C291.75 244.919 291.682 244.978 291.603 244.975C291.524 244.971 291.475 244.903 291.466 244.822C293.325 212.583 265.143 164.887 214.166 113.967C188.99 88.8193 164.87 69.2941 142.473 55.9348C119.817 42.4188 100.14 35.9452 83.9924 36.6979C83.913 36.7017 83.8432 36.6398 83.8394 36.5605C83.8394 36.485 83.8975 36.4115 83.9788 36.4096C100.185 35.655 119.916 42.1422 142.622 55.6872C165.04 69.06 189.18 88.6007 214.371 113.764C263.824 163.161 291.841 209.554 291.841 241.79V241.788Z",
    fill: "url(#paint76_linear_376_3569)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M161.997 175.76C161.997 175.807 161.974 175.855 161.932 175.882C161.897 175.905 158.362 178.225 151.734 184.904C142.919 193.786 137.43 199.486 134.958 202.326C134.571 202.773 134.185 203.212 133.81 203.641C131.255 206.563 129.047 209.086 128.212 210.73C128.175 210.802 128.088 210.831 128.016 210.794C127.945 210.757 127.916 210.67 127.952 210.599C128.805 208.921 131.022 206.387 133.591 203.45C133.967 203.02 134.35 202.581 134.739 202.134C137.217 199.288 142.708 193.585 151.528 184.697C158.184 177.991 161.74 175.658 161.777 175.634C161.844 175.592 161.934 175.609 161.978 175.677C161.994 175.702 162.001 175.729 162.001 175.756L161.997 175.76Z",
    fill: "url(#paint77_linear_376_3569)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M166.95 180.49C166.95 180.55 166.912 180.608 166.852 180.627C166.83 180.635 164.721 181.372 161.142 184.445C157.556 187.521 149.594 195.233 144.573 201.132L143.494 202.397C138.741 207.967 133.827 213.727 133.794 215.988C133.794 216.068 133.727 216.133 133.647 216.131C133.568 216.131 133.504 216.066 133.504 215.986C133.539 213.618 138.488 207.818 143.274 202.207L144.352 200.942C149.383 195.031 157.361 187.304 160.954 184.224C164.585 181.107 166.673 180.382 166.761 180.353C166.836 180.328 166.919 180.368 166.945 180.444C166.95 180.459 166.952 180.475 166.952 180.49H166.95Z",
    fill: "url(#paint78_linear_376_3569)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M171.93 185.062C171.93 185.088 171.922 185.115 171.909 185.138C171.868 185.204 171.783 185.227 171.715 185.188C171.68 185.173 170.477 184.736 165.621 188.574C160.243 192.827 152.712 200.898 149.082 205.273C146.673 208.175 138.857 217.893 139.33 221.099C139.343 221.176 139.287 221.251 139.208 221.263C139.128 221.275 139.055 221.221 139.043 221.141C138.549 217.916 145.745 208.838 148.858 205.087C152.495 200.703 160.047 192.612 165.441 188.348C170.531 184.323 171.74 184.863 171.862 184.939C171.907 184.966 171.93 185.014 171.93 185.062Z",
    fill: "url(#paint79_linear_376_3569)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M176.939 189.51C176.939 189.524 176.939 189.535 176.933 189.549C176.912 189.626 176.832 189.672 176.755 189.651C174.175 188.945 168.186 193.42 158.953 202.956C151.657 210.492 147.903 217.546 146.098 220.938C143.963 224.948 145.085 226.212 145.096 226.223C145.15 226.281 145.149 226.372 145.092 226.428C145.034 226.483 144.943 226.483 144.889 226.426C144.835 226.372 143.589 225.033 145.842 220.802C148.6 215.619 152.29 209.422 158.746 202.755C168.058 193.138 174.142 188.634 176.832 189.373C176.896 189.39 176.939 189.448 176.939 189.512V189.51Z",
    fill: "url(#paint80_linear_376_3569)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M181.91 193.778C181.91 193.801 181.904 193.824 181.893 193.847C181.854 193.919 181.767 193.944 181.695 193.905C178.995 192.439 170.951 198.082 163.382 206.75C155.863 215.359 152.952 220.918 151.096 225.219C149.149 229.729 150.835 231.185 150.852 231.199C150.914 231.249 150.922 231.342 150.873 231.402C150.823 231.464 150.732 231.474 150.67 231.423C150.592 231.362 148.787 229.837 150.829 225.103C152.694 220.781 155.617 215.199 163.163 206.556C169.781 198.978 178.575 191.878 181.835 193.648C181.883 193.675 181.91 193.723 181.91 193.776V193.778Z",
    fill: "url(#paint81_linear_376_3569)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M186.833 197.851C186.833 197.876 186.825 197.903 186.811 197.926C186.769 197.994 186.68 198.015 186.612 197.974C186.587 197.959 184.14 196.543 178.955 200.027C173.76 203.515 167.814 209.648 162.637 216.855C157.272 224.323 153.51 233.32 156.692 236.065C156.754 236.117 156.76 236.21 156.708 236.27C156.656 236.332 156.565 236.338 156.503 236.286C153.032 233.295 157.126 224.029 162.401 216.687C167.597 209.453 173.571 203.293 178.793 199.787C184.156 196.185 186.66 197.665 186.765 197.729C186.809 197.756 186.833 197.804 186.833 197.852V197.851Z",
    fill: "url(#paint82_linear_376_3569)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M191.773 201.787C191.773 201.815 191.765 201.842 191.75 201.867C191.705 201.934 191.616 201.954 191.549 201.909C188.142 199.702 181.087 204.769 177.833 207.758L177.624 207.95C175.052 210.306 168.221 216.563 163.305 227.012C158.354 237.533 162.055 240.37 162.094 240.397C162.16 240.443 162.173 240.534 162.127 240.6C162.081 240.666 161.989 240.681 161.926 240.633C161.761 240.517 157.974 237.659 163.041 226.889C167.982 216.387 174.845 210.101 177.429 207.735L177.638 207.543C178.029 207.183 187.262 198.785 191.707 201.666C191.75 201.693 191.773 201.741 191.773 201.787Z",
    fill: "url(#paint83_linear_376_3569)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M196.399 205.334C196.399 205.362 196.391 205.391 196.374 205.416C196.329 205.481 196.238 205.501 196.172 205.456C196.143 205.437 193.284 203.626 187.751 206.911C181.801 210.444 176.472 215.939 171.461 223.712C166.528 231.366 163.168 241.071 168.544 245.35C168.608 245.401 168.618 245.492 168.568 245.553C168.517 245.615 168.426 245.627 168.362 245.577C162.836 241.177 166.214 231.316 171.217 223.556C176.253 215.745 181.613 210.22 187.602 206.662C193.31 203.274 196.213 205.133 196.333 205.214C196.376 205.242 196.397 205.288 196.397 205.334H196.399Z",
    fill: "url(#paint84_linear_376_3569)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M201.261 208.908C201.261 208.933 201.255 208.958 201.241 208.981C201.201 209.051 201.112 209.074 201.042 209.035C195.675 205.946 185.659 213.491 180.493 220.125C175.068 227.092 171.45 234.748 170.815 240.606C170.125 246.917 173.84 249.241 173.877 249.264C173.945 249.305 173.968 249.394 173.925 249.463C173.885 249.531 173.796 249.554 173.726 249.512C173.687 249.489 169.825 247.076 170.524 240.573C171.165 234.665 174.807 226.953 180.263 219.945C185.295 213.483 195.425 205.466 201.187 208.782C201.234 208.809 201.261 208.857 201.261 208.908Z",
    fill: "url(#paint85_linear_376_3569)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M205.545 211.936C205.545 211.957 205.541 211.977 205.531 211.998C205.496 212.071 205.411 212.102 205.338 212.068C205.299 212.05 201.377 210.286 196.358 213.11C190.16 216.599 184.235 222.716 180.104 229.892C175.314 238.215 173.592 249.081 179.002 252.859C179.067 252.906 179.083 252.997 179.036 253.062C178.99 253.128 178.899 253.144 178.833 253.099C173.288 249.224 174.996 238.184 179.85 229.749C184.007 222.529 189.97 216.372 196.213 212.859C201.369 209.957 205.419 211.787 205.458 211.806C205.51 211.832 205.541 211.884 205.541 211.938L205.545 211.936Z",
    fill: "url(#paint86_linear_376_3569)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M210.082 214.996C210.082 215.019 210.076 215.042 210.064 215.063C210.025 215.135 209.938 215.16 209.869 215.123C204.279 212.148 194.05 218.265 188.64 225.72C183.209 233.203 180.459 240.184 180.232 247.064C180.003 253.918 184.882 256.786 184.933 256.813C185.003 256.853 185.026 256.942 184.987 257.012C184.946 257.082 184.859 257.107 184.79 257.066C184.739 257.037 179.703 254.092 179.943 247.054C180.172 240.114 182.94 233.079 188.406 225.548C193.887 217.994 204.29 211.821 210.006 214.864C210.056 214.889 210.084 214.94 210.084 214.992L210.082 214.996Z",
    fill: "url(#paint87_linear_376_3569)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M214.274 217.695C214.274 217.716 214.27 217.738 214.259 217.759C214.224 217.83 214.137 217.861 214.065 217.827C213.997 217.794 207.309 214.708 198.498 222.338C189.284 230.319 186.98 238.364 185.74 242.686C184.402 247.366 183.315 255.929 191.109 260.698C191.177 260.741 191.198 260.83 191.157 260.897C191.115 260.965 191.026 260.986 190.958 260.946C182.703 255.894 184.363 246.437 185.461 242.605C186.708 238.253 189.027 230.155 198.308 222.118C207.272 214.354 214.123 217.531 214.193 217.563C214.245 217.589 214.274 217.641 214.274 217.695Z",
    fill: "url(#paint88_linear_376_3569)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M218.882 220.504C218.882 220.523 218.878 220.541 218.871 220.56C218.84 220.634 218.754 220.671 218.681 220.64C211.962 217.871 205.614 222.518 202.564 224.751L202.515 224.786C198.469 227.748 194.094 233.896 192.546 237.783L192.252 238.518C190.815 242.096 189.182 246.145 189.405 252.754C189.637 259.688 195.18 263.114 195.237 263.147C195.306 263.188 195.328 263.279 195.287 263.347C195.246 263.414 195.157 263.438 195.087 263.395C195.029 263.36 189.352 259.856 189.114 252.762C188.889 246.095 190.534 242.01 191.983 238.406L192.277 237.673C193.84 233.749 198.258 227.541 202.345 224.55L202.393 224.515C205.487 222.251 211.923 217.54 218.793 220.369C218.849 220.392 218.882 220.446 218.882 220.502V220.504Z",
    fill: "url(#paint89_linear_376_3569)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M222.838 222.777C222.838 222.798 222.834 222.82 222.824 222.839C222.789 222.913 222.704 222.943 222.631 222.909C222.586 222.887 218.077 220.842 212.518 223.203C205.818 226.045 199.982 232.182 196.504 240.039C192.516 249.051 192.157 260.578 200.345 266.014C200.412 266.059 200.43 266.148 200.385 266.215C200.341 266.281 200.25 266.301 200.184 266.256C191.857 260.725 192.202 249.043 196.238 239.921C199.744 231.996 205.636 225.805 212.404 222.934C218.089 220.521 222.708 222.622 222.755 222.644C222.807 222.669 222.838 222.721 222.838 222.775V222.777Z",
    fill: "url(#paint90_linear_376_3569)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M226.575 224.798C226.575 224.815 226.573 224.83 226.566 224.848C226.539 224.923 226.455 224.962 226.38 224.935C218.059 221.901 209.368 228.47 204.452 235.015C199.538 241.56 197.289 249.8 198.285 257.62C199.281 265.456 205.701 268.814 205.765 268.847C205.837 268.884 205.866 268.971 205.829 269.043C205.792 269.114 205.705 269.143 205.634 269.107C205.568 269.074 199.011 265.647 197.996 257.657C196.995 249.763 199.261 241.448 204.22 234.843C209.194 228.216 218.009 221.574 226.481 224.664C226.541 224.685 226.575 224.741 226.575 224.801V224.798Z",
    fill: "url(#paint91_linear_376_3569)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M230.57 226.807C230.57 226.827 230.566 226.846 230.558 226.865C230.527 226.939 230.442 226.974 230.367 226.941C230.318 226.92 225.532 224.919 220.159 227.154C214.99 229.305 209.053 232.989 204.222 244.007C199.196 255.468 203.219 267.197 210.132 270.962C210.201 271 210.229 271.089 210.19 271.159C210.151 271.229 210.064 271.256 209.992 271.217C202.967 267.39 198.867 255.497 203.957 243.891C208.83 232.78 214.827 229.059 220.049 226.887C225.54 224.604 230.434 226.655 230.483 226.676C230.537 226.699 230.57 226.753 230.57 226.809V226.807Z",
    fill: "url(#paint92_linear_376_3569)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M233.775 228.284C233.775 228.297 233.775 228.311 233.769 228.324C233.746 228.402 233.667 228.446 233.589 228.423C233.537 228.408 228.245 226.912 223.802 228.814C220.368 230.284 212.328 233.726 207.943 245.689C203.757 257.117 206.75 268.671 215.061 273.162C215.131 273.2 215.158 273.289 215.119 273.359C215.08 273.429 214.993 273.456 214.921 273.417C206.482 268.857 203.432 257.154 207.67 245.588C212.097 233.509 220.219 230.031 223.686 228.547C228.226 226.603 233.614 228.127 233.669 228.143C233.733 228.162 233.773 228.22 233.773 228.282L233.775 228.284Z",
    fill: "url(#paint93_linear_376_3569)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M237.113 229.727C237.113 229.742 237.111 229.758 237.105 229.773C237.08 229.849 236.996 229.891 236.921 229.866C228.65 227.107 218.929 233.869 215.09 239.811C212.835 243.301 207.879 252.566 210.581 263.204C212.746 271.74 219.264 274.868 219.328 274.899C219.401 274.934 219.431 275.019 219.398 275.092C219.363 275.166 219.278 275.197 219.204 275.162C219.136 275.131 212.498 271.95 210.298 263.275C207.567 252.528 212.57 243.175 214.846 239.654C218.737 233.633 228.604 226.786 237.014 229.592C237.074 229.613 237.113 229.669 237.113 229.729V229.727Z",
    fill: "url(#paint94_linear_376_3569)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M239.557 230.679C239.557 230.679 239.557 230.695 239.557 230.702C239.543 230.782 239.47 230.836 239.39 230.822C239.305 230.809 230.756 229.501 224.021 235.003C217.693 240.175 213.73 248.119 213.42 256.252C213.081 265.106 216.943 272.682 223.746 276.515C223.816 276.555 223.839 276.642 223.8 276.712C223.761 276.782 223.672 276.807 223.603 276.766C216.703 272.879 212.789 265.202 213.128 256.239C213.442 248.022 217.443 239.999 223.835 234.775C230.674 229.188 239.35 230.517 239.437 230.532C239.508 230.544 239.559 230.606 239.559 230.675L239.557 230.679Z",
    fill: "url(#paint95_linear_376_3569)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M240.72 231.578V231.582C240.72 231.662 240.653 231.726 240.571 231.724C230.314 231.509 225.403 237.53 222.153 241.513L221.723 242.041C218.405 246.079 215.057 256.051 218.001 265.574C220.933 275.067 228.384 278.006 228.46 278.035C228.535 278.064 228.574 278.147 228.543 278.223C228.514 278.298 228.431 278.335 228.355 278.306C228.28 278.277 220.699 275.295 217.722 265.661C214.747 256.035 218.14 245.948 221.497 241.858L221.927 241.331C225.212 237.303 230.176 231.219 240.575 231.435C240.655 231.435 240.719 231.501 240.719 231.58L240.72 231.578Z",
    fill: "url(#paint96_linear_376_3569)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M241.563 232.288V232.292C241.561 232.373 241.493 232.435 241.412 232.433C241.319 232.43 232.045 232.246 224.718 242.775C217.516 253.123 220.365 262.989 221.303 266.231L221.38 266.502C222.24 269.512 227.164 277.779 233.691 279.438C233.769 279.457 233.815 279.536 233.796 279.614C233.777 279.691 233.697 279.739 233.62 279.718C226.887 278.01 222.002 269.741 221.101 266.581L221.024 266.31C220.079 263.035 217.201 253.069 224.481 242.606C231.902 231.942 241.331 232.137 241.423 232.141C241.501 232.143 241.563 232.209 241.563 232.286V232.288Z",
    fill: "url(#paint97_linear_376_3569)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M241.856 233.314C241.856 233.388 241.8 233.452 241.724 233.459C236.663 233.935 230.591 238.842 227.647 243.311C224.883 247.502 220.839 256.154 224.786 267.033C228.573 277.467 237.279 280.21 237.366 280.237C237.444 280.26 237.485 280.342 237.463 280.419C237.44 280.496 237.359 280.539 237.281 280.516C237.192 280.489 228.35 277.708 224.511 267.131C220.523 256.136 224.61 247.387 227.403 243.15C230.388 238.623 236.549 233.653 241.697 233.169C241.777 233.161 241.848 233.221 241.856 233.301C241.856 233.305 241.856 233.31 241.856 233.314Z",
    fill: "url(#paint98_linear_376_3569)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M243.096 281.266C243.096 281.278 243.096 281.289 243.092 281.301C243.073 281.378 242.993 281.427 242.916 281.407C236.482 279.805 231.701 275.957 228.705 269.971C226.539 265.641 225.885 261.135 225.84 259.156L225.833 258.854C225.759 255.846 225.621 250.247 230.045 243.448C234.884 236.009 241.847 234.111 241.917 234.094C241.994 234.072 242.073 234.119 242.095 234.198C242.112 234.275 242.068 234.355 241.99 234.376C241.922 234.393 235.064 236.268 230.289 243.609C225.916 250.334 226.051 255.873 226.123 258.85L226.131 259.152C226.135 259.332 226.722 277.081 242.986 281.129C243.052 281.146 243.096 281.204 243.096 281.27V281.266Z",
    fill: "url(#paint99_linear_376_3569)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M248.25 281.69C248.25 281.69 248.25 281.7 248.25 281.703C248.242 281.783 248.171 281.841 248.091 281.833C241.796 281.21 233.686 276.108 230.368 267.559C227.269 259.568 228.147 250.131 232.609 243.518C236.983 237.036 242.1 235.106 242.151 235.086C242.226 235.059 242.309 235.098 242.337 235.173C242.366 235.249 242.325 235.332 242.249 235.359C242.199 235.378 237.165 237.282 232.848 243.68C228.437 250.218 227.568 259.549 230.636 267.454C233.911 275.893 241.909 280.931 248.114 281.545C248.19 281.553 248.246 281.616 248.246 281.69H248.25Z",
    fill: "url(#paint100_linear_376_3569)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M252.54 281.719C252.54 281.719 252.54 281.728 252.54 281.734C252.532 281.814 252.46 281.872 252.381 281.864C252.296 281.856 243.76 280.933 237.998 274.762C231.902 268.232 229.785 260.274 231.706 251.108C233.891 240.689 242.294 236.21 242.379 236.166C242.45 236.129 242.538 236.156 242.574 236.228C242.611 236.299 242.584 236.386 242.512 236.423C242.429 236.466 234.147 240.886 231.991 251.166C230.091 260.234 232.183 268.104 238.209 274.562C243.895 280.653 252.325 281.566 252.41 281.574C252.486 281.581 252.54 281.645 252.54 281.719Z",
    fill: "url(#paint101_linear_376_3569)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M257.899 281.278C257.899 281.357 257.835 281.423 257.754 281.423C257.698 281.423 252.116 281.417 247.229 279.086C244.428 277.749 235.15 272.339 233.388 258.843C231.647 245.53 241.931 237.489 242.371 237.152C242.435 237.104 242.526 237.116 242.575 237.179C242.623 237.241 242.611 237.334 242.547 237.383C242.114 237.713 231.958 245.657 233.676 258.804C235.061 269.412 241.649 276.1 247.353 278.822C252.18 281.125 257.696 281.132 257.752 281.131C257.831 281.131 257.897 281.194 257.897 281.276L257.899 281.278Z",
    fill: "url(#paint102_linear_376_3569)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M266.139 279.345C266.139 279.409 266.097 279.469 266.031 279.486C257.462 281.765 248.67 279.459 243.084 273.469C236.663 266.583 234.078 258.053 235.984 250.065C237.971 241.744 242.65 237.936 242.697 237.899C242.761 237.849 242.852 237.859 242.902 237.922C242.953 237.984 242.943 238.075 242.879 238.126C242.832 238.162 238.228 241.914 236.266 250.133C234.382 258.024 236.944 266.458 243.297 273.272C248.81 279.184 257.493 281.458 265.957 279.208C266.035 279.186 266.114 279.233 266.135 279.31C266.139 279.322 266.141 279.335 266.141 279.347L266.139 279.345Z",
    fill: "url(#paint103_linear_376_3569)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M270.089 277.76C270.089 277.82 270.05 277.876 269.99 277.898C269.893 277.931 260.29 281.117 252.355 277.149C243.582 272.761 238.998 266.638 237.489 257.293C236.761 252.781 237.08 245.932 242.732 238.915L242.825 238.801C242.875 238.739 242.966 238.727 243.03 238.778C243.094 238.828 243.104 238.919 243.054 238.983L242.961 239.099C237.375 246.033 237.059 252.797 237.777 257.248C239.269 266.491 243.805 272.548 252.486 276.89C260.309 280.804 269.802 277.656 269.897 277.623C269.973 277.598 270.056 277.638 270.081 277.714C270.087 277.729 270.089 277.745 270.089 277.76Z",
    fill: "url(#paint104_linear_376_3569)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M277.916 272.759C277.916 272.804 277.894 272.848 277.855 272.875C271.045 277.912 262.486 278.945 254.374 275.712C246.712 272.657 240.586 264.761 239.133 256.067C237.605 246.931 242.863 239.496 242.916 239.422C242.962 239.356 243.053 239.343 243.119 239.389C243.185 239.436 243.198 239.527 243.152 239.592C243.1 239.666 237.911 247.004 239.42 256.02C240.857 264.618 246.912 272.423 254.483 275.443C262.498 278.639 270.954 277.619 277.683 272.643C277.747 272.595 277.838 272.608 277.886 272.674C277.906 272.699 277.916 272.73 277.916 272.761V272.759Z",
    fill: "url(#paint105_linear_376_3569)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M282.165 268.639C282.165 268.671 282.153 268.704 282.132 268.731C282.072 268.805 275.974 276.006 264.035 275.642C250.035 275.215 243.43 262.784 243.157 262.256C239.371 254.952 239.309 247.45 242.975 239.956C243.01 239.885 243.097 239.854 243.169 239.891C243.242 239.925 243.272 240.012 243.237 240.084C239.613 247.49 239.673 254.904 243.415 262.122C243.686 262.645 250.213 274.93 264.043 275.352C275.833 275.712 281.847 268.619 281.907 268.548C281.957 268.486 282.05 268.476 282.112 268.528C282.147 268.557 282.165 268.598 282.165 268.641V268.639Z",
    fill: "url(#paint106_linear_376_3569)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M285.597 264.142C285.597 264.175 285.585 264.206 285.564 264.233C278.194 273.287 269.755 273.396 265.699 273.448L265.409 273.452C261.82 273.504 250.245 271.213 244.343 260.389C238.643 249.931 242.983 240.455 243.026 240.36C243.061 240.287 243.146 240.256 243.22 240.291C243.293 240.325 243.322 240.411 243.289 240.484C243.245 240.577 238.97 249.926 244.599 260.249C250.431 270.948 261.86 273.212 265.405 273.16L265.697 273.156C269.709 273.104 278.057 272.997 285.339 264.049C285.39 263.987 285.483 263.977 285.545 264.028C285.58 264.057 285.599 264.099 285.599 264.14L285.597 264.142Z",
    fill: "url(#paint107_linear_376_3569)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M288.413 258.82C288.413 258.841 288.409 258.863 288.4 258.882C288.363 258.961 284.578 266.845 274.557 269.997C264.307 273.222 254.64 268.217 250.959 265.121C247.514 262.221 239.844 254.034 243.049 240.665C243.068 240.587 243.146 240.539 243.225 240.556C243.303 240.576 243.353 240.653 243.332 240.73C240.163 253.943 247.74 262.032 251.145 264.897C254.783 267.958 264.34 272.905 274.468 269.718C284.361 266.605 288.098 258.836 288.134 258.758C288.169 258.685 288.254 258.654 288.328 258.688C288.38 258.714 288.411 258.766 288.411 258.82H288.413Z",
    fill: "url(#paint108_linear_376_3569)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M290.362 253.199C290.362 253.22 290.358 253.242 290.348 253.261C285.43 263.54 277.638 268.569 267.191 268.205C258.254 267.893 249.867 263.08 245.821 255.943C241.621 248.533 242.942 241.14 242.956 241.067C242.971 240.987 243.047 240.935 243.126 240.95C243.206 240.966 243.256 241.041 243.243 241.121C243.227 241.194 241.929 248.486 246.074 255.799C250.07 262.852 258.362 267.607 267.2 267.915C277.522 268.275 285.221 263.302 290.085 253.137C290.12 253.066 290.207 253.035 290.278 253.07C290.331 253.095 290.362 253.147 290.362 253.201V253.199Z",
    fill: "url(#paint109_linear_376_3569)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M291.437 247.813C291.437 247.813 291.437 247.83 291.435 247.84C291.423 247.906 290.11 254.563 283.172 260.141C276.964 265.135 268.095 266.506 259.449 263.813C252.209 261.557 244.076 254.186 243.264 244.969C243.25 244.892 243.316 244.818 243.396 244.812C243.475 244.804 243.547 244.864 243.553 244.944C244.354 254.035 252.385 261.308 259.534 263.535C268.087 266.201 276.856 264.846 282.988 259.915C289.837 254.406 291.135 247.852 291.146 247.786C291.162 247.707 291.237 247.654 291.317 247.67C291.386 247.683 291.435 247.743 291.435 247.813H291.437Z",
    fill: "url(#paint110_linear_376_3569)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M291.906 241.31C291.906 241.31 291.906 241.315 291.906 241.319L291.898 241.459C291.768 243.589 291.369 250.072 283.292 256.76C273.84 264.588 260.193 262.729 252.151 257.006C243.996 251.202 243.127 241.484 243.119 241.385C243.111 241.304 243.173 241.234 243.252 241.228C243.332 241.222 243.404 241.281 243.409 241.362C243.417 241.459 244.277 251.045 252.319 256.768C260.272 262.429 273.764 264.271 283.106 256.536C291.086 249.927 291.477 243.538 291.607 241.439L291.617 241.3C291.621 241.221 291.691 241.159 291.77 241.164C291.847 241.168 291.906 241.232 291.906 241.31Z",
    fill: "url(#paint111_linear_376_3569)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M291.864 238.379C291.864 238.379 291.864 238.393 291.864 238.398C291.853 238.486 290.652 247.074 283.044 252.938C274.851 259.253 265.106 259.237 259.251 257.305C250.333 254.362 244.84 248.447 242.921 239.728C242.905 239.648 242.954 239.571 243.031 239.555C243.109 239.538 243.188 239.588 243.204 239.666C245.1 248.279 250.529 254.12 259.342 257.03C265.129 258.939 274.764 258.955 282.866 252.71C290.375 246.921 291.564 238.447 291.576 238.364C291.587 238.284 291.659 238.228 291.739 238.238C291.812 238.248 291.864 238.309 291.864 238.381V238.379Z",
    fill: "url(#paint112_linear_376_3569)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M291.524 233.792C291.524 233.792 291.524 233.807 291.524 233.815C290.017 243.007 284.687 249.322 275.229 253.123C269.099 255.586 259.05 255.875 251.473 250.684C244.479 245.893 242.623 237.88 242.604 237.8C242.588 237.721 242.637 237.644 242.714 237.626C242.792 237.609 242.871 237.659 242.889 237.737C242.906 237.816 244.742 245.719 251.638 250.444C259.126 255.573 269.06 255.288 275.121 252.853C284.476 249.093 289.748 242.85 291.238 233.767C291.251 233.687 291.325 233.633 291.404 233.647C291.476 233.658 291.526 233.72 291.526 233.79L291.524 233.792Z",
    fill: "url(#paint113_linear_376_3569)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M290.699 228.203C290.699 228.307 290.465 238.612 281.638 245.099C273.236 251.272 263.648 251.739 257.991 250.261C255.008 249.483 245.039 246.076 241.986 234.945C241.967 234.868 242.011 234.789 242.087 234.767C242.164 234.746 242.246 234.792 242.265 234.87C245.277 245.849 255.118 249.212 258.064 249.98C262.569 251.156 272.568 251.402 281.466 244.865C290.174 238.466 290.409 228.303 290.409 228.201C290.409 228.122 290.476 228.056 290.556 228.058C290.635 228.058 290.699 228.123 290.699 228.203Z",
    fill: "url(#paint114_linear_376_3569)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M289.377 223.095C289.377 228.981 286.716 234.996 282.296 238.987C277.21 243.58 268.666 248.564 256.851 246.225C244.91 243.861 241.458 232.943 241.423 232.833C241.402 232.755 241.445 232.674 241.52 232.651C241.598 232.628 241.679 232.67 241.702 232.748C241.735 232.856 245.142 243.609 256.907 245.94C268.604 248.256 277.062 243.321 282.1 238.772C286.697 234.622 289.368 228.253 289.063 222.157C289.056 222.078 289.122 222.008 289.201 222.004C289.282 222 289.35 222.062 289.354 222.141C289.37 222.459 289.377 222.776 289.377 223.093V223.095Z",
    fill: "url(#paint115_linear_376_3569)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M287.916 218.525C287.916 220.988 287.486 225.738 284.608 229.88C281.175 234.819 274.759 240.995 263.685 242.368C254.256 243.537 244.748 239.027 241.076 231.642C241.041 231.571 241.07 231.484 241.142 231.447C241.213 231.412 241.3 231.441 241.337 231.513C244.955 238.791 254.34 243.235 263.65 242.08C274.619 240.72 280.972 234.604 284.371 229.713C288.387 223.934 287.561 216.952 287.552 216.88C287.544 216.805 287.598 216.728 287.678 216.718C287.757 216.708 287.831 216.764 287.84 216.844C287.842 216.865 287.918 217.496 287.918 218.525H287.916Z",
    fill: "url(#paint116_linear_376_3569)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M286.159 213.783C286.159 218.451 284.441 223.288 281.278 227.372C276.858 233.078 269.991 236.756 261.944 237.729C244.845 239.795 239.828 227.887 239.78 227.767C239.749 227.693 239.785 227.608 239.859 227.577C239.933 227.546 240.018 227.583 240.049 227.659C240.097 227.777 245.038 239.48 261.907 237.44C269.877 236.477 276.674 232.838 281.045 227.194C284.72 222.45 286.42 216.681 285.707 211.37C285.7 211.293 285.752 211.217 285.833 211.208C285.913 211.196 285.986 211.252 285.996 211.331C286.104 212.14 286.159 212.958 286.159 213.783Z",
    fill: "url(#paint117_linear_376_3569)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M284.197 208.718C284.197 212.309 283.007 219.394 274.956 226.223C268.808 231.439 260.981 234.034 253.481 233.343C247.599 232.801 242.516 230.242 239.169 226.132C239.119 226.07 239.129 225.979 239.191 225.927C239.253 225.877 239.344 225.886 239.396 225.948C242.693 229.996 247.705 232.519 253.508 233.053C260.931 233.736 268.68 231.164 274.768 226.001C285.994 216.478 283.73 206.489 283.705 206.39C283.685 206.311 283.734 206.234 283.811 206.214C283.889 206.195 283.968 206.243 283.987 206.321C283.995 206.35 284.197 207.236 284.197 208.716V208.718Z",
    fill: "url(#paint118_linear_376_3569)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M281.692 204.074C281.692 208.195 280.168 214.657 272.552 221.21C265.976 226.867 257.524 229.487 249.362 228.396C244.093 227.691 239.687 225.405 237.575 222.278C237.531 222.212 237.548 222.121 237.614 222.077C237.68 222.032 237.771 222.05 237.816 222.116C239.882 225.174 244.211 227.413 249.398 228.107C257.477 229.187 265.846 226.594 272.36 220.99C284.834 210.258 280.786 199.833 280.745 199.729C280.714 199.655 280.751 199.57 280.825 199.539C280.898 199.508 280.983 199.545 281.014 199.619C281.032 199.661 281.692 201.36 281.692 204.072V204.074Z",
    fill: "url(#paint119_linear_376_3569)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M279.008 198.401C279.008 204.151 276.289 213.943 262.75 220.389C253.18 224.946 246.373 224.187 242.348 222.748C237.977 221.185 235.842 218.495 235.821 218.468C235.773 218.404 235.782 218.314 235.846 218.265C235.91 218.217 236.001 218.226 236.05 218.29C236.133 218.397 244.512 228.751 262.624 220.128C280.151 211.784 279.363 197.825 278.193 194.545C278.168 194.47 278.204 194.387 278.28 194.36C278.355 194.333 278.439 194.371 278.466 194.447C278.747 195.234 279.006 196.625 279.006 198.403L279.008 198.401Z",
    fill: "url(#paint120_linear_376_3569)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M276.285 194.047C276.285 196.415 275.702 198.81 274.535 201.213C270.375 209.793 260.127 215.814 252.366 217.774C239.454 221.038 233.864 214.64 233.808 214.574C233.758 214.512 233.764 214.421 233.826 214.369C233.888 214.317 233.979 214.324 234.031 214.386C234.085 214.45 239.571 220.709 252.294 217.492C259.991 215.545 270.154 209.582 274.274 201.085C276.434 196.633 276.558 192.213 274.646 187.945C274.613 187.871 274.646 187.786 274.72 187.753C274.793 187.72 274.878 187.753 274.911 187.827C275.827 189.87 276.285 191.946 276.285 194.045V194.047Z",
    fill: "url(#paint121_linear_376_3569)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M273.17 188.332C273.17 191.139 272.335 194.751 269.422 198.807C264.764 205.298 253.995 212.576 244.035 213.52C238.676 214.029 234.25 212.669 230.881 209.477C230.823 209.42 230.821 209.33 230.876 209.271C230.932 209.213 231.023 209.211 231.081 209.266C234.387 212.398 238.736 213.733 244.008 213.232C253.882 212.293 264.564 205.075 269.186 198.638C275.86 189.34 271.465 182.47 271.419 182.402C271.376 182.336 271.392 182.245 271.46 182.201C271.527 182.156 271.616 182.176 271.661 182.241C271.686 182.282 273.168 184.594 273.168 188.332H273.17Z",
    fill: "url(#paint122_linear_376_3569)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M269.928 182.638C269.928 182.75 269.928 182.864 269.924 182.98C269.825 186.608 268.035 192.358 260.063 199.149C248.345 209.13 238.302 208.718 234.527 208.077C231.32 207.532 228.844 206.249 227.907 204.643C227.866 204.575 227.889 204.484 227.959 204.444C228.029 204.403 228.118 204.426 228.159 204.496C229.04 206.005 231.5 207.269 234.575 207.791C238.31 208.426 248.25 208.83 259.875 198.928C267.755 192.216 269.531 186.557 269.633 182.994C269.742 179.143 267.975 176.837 267.958 176.814C267.91 176.75 267.919 176.659 267.983 176.611C268.047 176.561 268.138 176.572 268.187 176.636C268.26 176.729 269.93 178.9 269.93 182.64L269.928 182.638Z",
    fill: "url(#paint123_linear_376_3569)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M266.17 176.679C266.17 179.357 265.299 182.998 262.041 187.25C255.529 195.746 248.076 199.278 242.308 201.405C239.588 202.409 230.312 205.301 225.16 200.4C225.104 200.344 225.1 200.253 225.156 200.195C225.211 200.137 225.304 200.135 225.362 200.19C230.392 204.974 239.526 202.12 242.207 201.132C247.936 199.019 255.343 195.51 261.81 187.072C268.644 178.153 264.816 172.012 264.776 171.952C264.731 171.885 264.751 171.796 264.818 171.751C264.886 171.709 264.975 171.726 265.02 171.794C265.041 171.827 266.17 173.628 266.17 176.677V176.679Z",
    fill: "url(#paint124_linear_376_3569)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M262.389 170.366C262.389 171.103 262.319 171.914 262.156 172.782C261.476 176.42 258.621 183.659 247.141 191.269C230.238 202.471 222.423 196.311 222.345 196.247C222.283 196.195 222.274 196.104 222.326 196.042C222.376 195.98 222.469 195.97 222.531 196.022C222.607 196.084 230.277 202.097 246.981 191.027C258.372 183.478 261.199 176.323 261.87 172.73C262.458 169.584 261.798 167.592 261.316 166.911C261.269 166.845 261.285 166.754 261.351 166.707C261.416 166.661 261.507 166.676 261.554 166.742C262.028 167.412 262.389 168.696 262.389 170.368V170.366Z",
    fill: "url(#paint125_linear_376_3569)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M258.374 164.78C258.374 165.157 258.351 165.562 258.3 165.993C257.919 169.153 255.806 174.372 247.901 181.295C232.766 194.55 221.478 193.542 218.654 191.046C218.594 190.992 218.588 190.901 218.642 190.841C218.697 190.781 218.788 190.775 218.848 190.827C221.612 193.269 232.72 194.203 247.709 181.076C262.643 167.998 257.026 160.938 256.97 160.866C256.919 160.804 256.925 160.713 256.987 160.661C257.049 160.609 257.14 160.617 257.192 160.678C257.247 160.744 258.376 162.118 258.376 164.78H258.374Z",
    fill: "url(#paint126_linear_376_3569)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M254.152 158.394C254.152 158.802 254.117 159.234 254.045 159.687C253.297 164.462 248.343 172.404 236.675 180.365C221.757 190.547 215.392 186.475 215.129 186.297C215.063 186.252 215.046 186.161 215.09 186.096C215.135 186.03 215.226 186.012 215.292 186.057C215.355 186.099 221.78 190.18 236.51 180.125C248.099 172.216 253.019 164.357 253.756 159.642C254.016 157.971 253.776 156.601 253.059 155.682C253.011 155.62 253.02 155.527 253.084 155.479C253.148 155.428 253.239 155.44 253.288 155.504C253.857 156.235 254.148 157.22 254.148 158.396L254.152 158.394Z",
    fill: "url(#paint127_linear_376_3569)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M249.596 152.653C249.596 155.608 247.795 160.957 238.61 169.019C222.813 182.884 213.145 183.011 210.939 180.902C210.881 180.846 210.879 180.755 210.935 180.697C210.992 180.639 211.083 180.637 211.141 180.693C213.198 182.661 222.925 182.4 238.418 168.803C252.972 156.03 248.668 150.084 248.624 150.026C248.573 149.962 248.585 149.871 248.649 149.823C248.713 149.775 248.804 149.784 248.852 149.848C248.926 149.941 249.596 150.854 249.596 152.655V152.653Z",
    fill: "url(#paint128_linear_376_3569)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M244.846 146.238C244.846 148.103 243.914 151.496 239.301 156.861C231.842 165.533 213.41 179.685 206.883 175.872C206.813 175.831 206.79 175.742 206.831 175.673C206.871 175.603 206.96 175.58 207.03 175.62C209.798 177.238 215.303 175.537 222.533 170.836C228.547 166.924 235.043 161.365 239.08 156.672C246.479 148.068 244.209 144.618 244.184 144.584C244.139 144.518 244.153 144.427 244.219 144.382C244.284 144.336 244.374 144.351 244.42 144.415C244.461 144.471 244.844 145.04 244.844 146.238H244.846Z",
    fill: "url(#paint129_linear_376_3569)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M240.157 140.354C240.157 143.92 235.237 149.486 234.135 150.69L233.928 150.916C231.398 153.677 225.477 160.143 215.725 166.516C205.746 173.038 202.994 171.19 202.881 171.107C202.815 171.058 202.802 170.968 202.85 170.904C202.897 170.84 202.988 170.824 203.052 170.871C203.077 170.89 205.816 172.643 215.566 166.272C225.287 159.918 231.191 153.472 233.713 150.719L233.92 150.492C237.316 146.791 240.843 141.604 239.613 139.172C239.576 139.101 239.605 139.014 239.677 138.977C239.748 138.94 239.835 138.969 239.872 139.041C240.07 139.432 240.159 139.873 240.159 140.351L240.157 140.354Z",
    fill: "url(#paint130_linear_376_3569)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M235.069 134.171C235.069 135.459 234.225 138.478 228.674 144.384C220.054 153.555 213.577 158.419 210.484 160.5C205.347 163.96 199.854 167.272 198.067 165.608C198.009 165.554 198.005 165.461 198.059 165.403C198.113 165.345 198.206 165.341 198.264 165.395C200.124 167.125 207.269 162.313 210.321 160.259C213.405 158.183 219.861 153.336 228.46 144.185C236.059 136.102 234.678 133.558 234.662 133.532C234.622 133.465 234.641 133.376 234.711 133.333C234.779 133.291 234.866 133.31 234.91 133.378C234.93 133.409 235.069 133.647 235.069 134.171Z",
    fill: "url(#paint131_linear_376_3569)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M229.902 128.261C229.902 130.95 223.127 138.039 223.053 138.116C220.975 140.281 214.651 146.867 205.073 154.486C196.008 161.697 193.904 160.902 193.819 160.865C193.746 160.832 193.713 160.747 193.746 160.673C193.777 160.602 193.862 160.567 193.934 160.598C193.972 160.611 196.116 161.24 204.893 154.26C214.455 146.652 220.769 140.078 222.844 137.917C226.096 134.531 230.316 129.172 229.518 127.86C229.478 127.793 229.499 127.702 229.567 127.661C229.635 127.621 229.726 127.642 229.766 127.71C229.859 127.862 229.902 128.048 229.902 128.263V128.261Z",
    fill: "url(#paint132_linear_376_3569)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M224.492 122.215C224.492 122.545 224.159 124.637 217.095 131.699C208.389 140.407 202.776 145.727 199.437 148.444C198.85 148.921 198.245 149.419 197.639 149.922C194.408 152.592 191.069 155.352 189.134 155.736C189.055 155.751 188.979 155.701 188.964 155.621C188.95 155.544 188.999 155.467 189.078 155.451C190.941 155.084 194.253 152.346 197.455 149.699C198.063 149.196 198.666 148.699 199.254 148.221C202.588 145.512 208.191 140.198 216.892 131.497C224.297 124.093 224.213 122.288 224.204 122.216C224.204 122.143 224.25 122.066 224.328 122.056C224.405 122.044 224.477 122.095 224.49 122.172C224.49 122.178 224.494 122.193 224.494 122.22L224.492 122.215Z",
    fill: "url(#paint133_linear_376_3569)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M218.954 116.445C218.954 116.458 218.952 116.474 218.948 116.487C218.613 117.573 215.671 120.709 211.034 125.418C206.862 129.653 199.064 137.301 193.647 142.465C188.153 147.704 184.336 150.577 184.299 150.604C184.235 150.653 184.144 150.639 184.096 150.575C184.049 150.512 184.061 150.421 184.125 150.372C184.163 150.343 187.966 147.48 193.445 142.254C198.861 137.09 206.657 129.446 210.825 125.213C214.435 121.547 218.315 117.542 218.669 116.4C218.693 116.323 218.776 116.28 218.851 116.304C218.913 116.323 218.954 116.381 218.954 116.443V116.445Z",
    fill: "url(#paint134_linear_376_3569)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M213.432 110.865C213.432 110.906 213.414 110.945 213.383 110.974C213.343 111.01 209.252 114.663 204.768 119.099C201.802 122.034 197.663 126.227 193.66 130.282C191.541 132.428 189.462 134.533 187.622 136.388C182.825 141.221 181.178 143.196 179.726 144.938L179.261 145.493C179.209 145.555 179.117 145.563 179.056 145.51C178.994 145.458 178.986 145.367 179.038 145.305L179.501 144.75C180.958 143.003 182.608 141.022 187.415 136.181C189.257 134.328 191.334 132.223 193.453 130.075C197.456 126.02 201.595 121.826 204.563 118.891C209.052 114.448 213.149 110.792 213.19 110.755C213.25 110.701 213.341 110.707 213.395 110.767C213.42 110.794 213.432 110.829 213.432 110.863V110.865Z",
    fill: "url(#paint135_linear_376_3569)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M207.819 105.402C207.819 105.468 207.774 105.526 207.709 105.543C206.391 105.872 203.221 108.47 198.535 113.061C195.384 116.149 187.125 124.505 181.711 130.619C176.54 136.462 174.109 140.467 174.086 140.507C174.045 140.575 173.956 140.598 173.886 140.558C173.819 140.515 173.795 140.426 173.836 140.358C173.859 140.318 176.302 136.294 181.493 130.428C186.91 124.306 195.177 115.944 198.33 112.854C203.118 108.163 206.25 105.607 207.637 105.263C207.714 105.243 207.794 105.292 207.813 105.369C207.817 105.381 207.817 105.392 207.817 105.404L207.819 105.402Z",
    fill: "url(#paint136_linear_376_3569)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M202.121 100.023C202.121 100.042 202.117 100.064 202.107 100.083C202.074 100.155 201.993 100.186 201.921 100.159C201.887 100.149 200.868 99.9264 197.017 102.962C193.238 105.941 186.817 112.235 180.662 118.997C174.999 125.219 168.862 133.6 169.079 135.686C169.095 135.763 169.031 135.837 168.952 135.846C168.872 135.856 168.8 135.798 168.791 135.719C168.533 133.324 175.39 124.358 180.447 118.802C186.612 112.03 193.045 105.723 196.835 102.734C200.905 99.5259 201.929 99.8451 202.032 99.8915C202.086 99.9167 202.117 99.9689 202.117 100.023H202.121Z",
    fill: "url(#paint137_linear_376_3569)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M196.705 95.0726C196.705 95.1074 196.693 95.1422 196.668 95.1693C196.613 95.2293 196.522 95.2331 196.462 95.179C194.69 93.5751 186.621 100.147 180.16 107.155C173.909 113.934 168.796 120.412 166.127 124.927C163.609 129.189 163.905 130.911 163.909 130.927C163.922 131.006 163.874 131.082 163.795 131.097C163.717 131.113 163.64 131.062 163.624 130.985C163.611 130.913 163.287 129.164 165.879 124.78C168.556 120.247 173.684 113.75 179.948 106.958C185.217 101.242 194.415 92.9308 196.66 94.9642C196.691 94.9932 196.708 95.0319 196.708 95.0726H196.705Z",
    fill: "url(#paint138_linear_376_3569)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M190.902 89.9418C190.902 89.9611 190.898 89.9824 190.89 90.0017C190.857 90.0752 190.772 90.1081 190.699 90.0752C190.677 90.0656 188.487 89.1601 184.698 91.981C181.094 94.6663 175.475 99.2594 168.322 108.099C161.548 116.471 157.523 124.411 158.947 126.566C158.992 126.632 158.974 126.723 158.906 126.767C158.839 126.812 158.749 126.792 158.705 126.727C157.182 124.43 161.134 116.521 168.095 107.917C175.267 99.0524 180.906 94.4439 184.524 91.7488C188.463 88.8138 190.722 89.7676 190.815 89.8102C190.869 89.8334 190.902 89.8876 190.902 89.9418Z",
    fill: "url(#paint139_linear_376_3569)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M185.5 85.3291C185.5 85.3581 185.491 85.3872 185.473 85.4143C185.427 85.48 185.336 85.4936 185.27 85.4471C182.051 83.141 174.009 89.5662 167.553 96.3474C159.954 104.33 156.083 112.127 154.769 115.108C152.728 119.746 153.617 122.062 153.625 122.085C153.656 122.159 153.619 122.244 153.545 122.275C153.472 122.306 153.386 122.269 153.355 122.195C153.315 122.099 152.404 119.761 154.504 114.992C155.823 111.997 159.712 104.166 167.342 96.1481C170.514 92.8146 181.196 82.1736 185.438 85.213C185.479 85.2421 185.498 85.2866 185.498 85.3311L185.5 85.3291Z",
    fill: "url(#paint140_linear_376_3569)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M180.106 80.8829C180.106 80.9158 180.094 80.9468 180.073 80.9739C180.022 81.0358 179.931 81.0455 179.867 80.9952C179.842 80.9758 177.363 79.043 172.509 81.8735C167.299 84.913 162.03 90.0013 155.927 97.8911C149.344 106.4 146.748 116.004 148.991 118.283C149.047 118.341 149.045 118.432 148.989 118.488C148.931 118.544 148.84 118.544 148.784 118.488C146.15 115.809 149.51 105.711 155.697 97.715C161.823 89.7962 167.121 84.6827 172.364 81.6239C177.406 78.6832 179.947 80.6856 180.051 80.7727C180.086 80.8017 180.106 80.8423 180.106 80.8849V80.8829Z",
    fill: "url(#paint141_linear_376_3569)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M174.473 76.4139C174.473 76.439 174.467 76.4642 174.454 76.4874C174.413 76.557 174.324 76.5802 174.254 76.5396C168.317 73.0687 158.922 82.2509 155.158 86.3583C150.198 91.7736 145.266 100.014 143.434 105.953C141.745 111.421 143.663 114.095 143.682 114.122C143.73 114.185 143.717 114.276 143.653 114.325C143.589 114.373 143.498 114.36 143.45 114.296C143.366 114.184 141.422 111.49 143.157 105.868C145.003 99.8917 149.96 91.6053 154.945 86.1629C158.757 82.0033 168.285 72.7108 174.401 76.29C174.448 76.3171 174.473 76.3655 174.473 76.4158V76.4139Z",
    fill: "url(#paint142_linear_376_3569)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M169.315 72.4826C169.315 72.5174 169.304 72.5503 169.279 72.5793C169.226 72.6393 169.133 72.6451 169.073 72.591C169.025 72.5484 164.196 68.4661 154.911 76.1876C145.869 83.704 141.8 91.8182 140.27 94.8712L140.066 95.2736C138.619 98.1312 135.666 107.058 138.947 110.544C139.001 110.602 138.999 110.695 138.941 110.749C138.883 110.804 138.79 110.802 138.735 110.744C135.084 106.865 138.712 97.3012 139.807 95.1421L140.008 94.7397C141.548 91.6712 145.637 83.5183 154.725 75.9612C164.217 68.0695 169.218 72.3278 169.267 72.3723C169.3 72.4013 169.315 72.44 169.315 72.4807V72.4826Z",
    fill: "url(#paint143_linear_376_3569)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M163.574 68.2899C163.574 68.3131 163.568 68.3382 163.557 68.3595C163.518 68.4292 163.429 68.4543 163.359 68.4156C158.085 65.4961 150.274 68.9612 142.973 77.4585C137.347 84.0114 133.975 90.4657 132.363 97.7731C131.127 103.372 133.744 106.737 133.769 106.772C133.82 106.833 133.81 106.924 133.746 106.975C133.684 107.025 133.593 107.015 133.543 106.951C133.516 106.917 130.812 103.452 132.078 97.7093C133.7 90.3534 137.093 83.8586 142.753 77.2689C150.146 68.6594 158.097 65.1711 163.499 68.1602C163.547 68.1873 163.574 68.2357 163.574 68.2879V68.2899Z",
    fill: "url(#paint144_linear_376_3569)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M157.81 64.2831C157.81 64.3082 157.802 64.3353 157.789 64.3586C157.748 64.4263 157.657 64.4495 157.589 64.4069C157.529 64.3702 151.509 60.8702 142.896 67.6514C134.55 74.2218 130.779 81.9587 128.668 87.2076C126.721 92.0464 125.605 100.36 129.216 103.693C129.274 103.748 129.278 103.838 129.223 103.898C129.169 103.957 129.076 103.96 129.018 103.906C125.307 100.478 126.421 92.0135 128.396 87.0973C130.521 81.8175 134.316 74.0341 142.716 67.4212C151.496 60.5085 157.678 64.1186 157.74 64.1554C157.785 64.1825 157.81 64.2309 157.81 64.2792V64.2831Z",
    fill: "url(#paint145_linear_376_3569)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M152.418 60.7197C152.418 60.741 152.414 60.7622 152.404 60.7816C152.369 60.8532 152.284 60.8841 152.211 60.8512C149.059 59.3576 145.476 59.4815 141.563 61.2227C133.779 64.6859 125.826 74.2666 123.066 83.5107C119.396 95.802 124.029 100.294 124.077 100.339C124.137 100.393 124.139 100.486 124.085 100.544C124.031 100.602 123.94 100.606 123.879 100.552C123.68 100.368 119.059 95.9104 122.789 83.4275C125.57 74.1118 133.591 64.4518 141.445 60.9576C145.439 59.1816 149.104 59.0578 152.334 60.5901C152.387 60.6152 152.418 60.6674 152.418 60.7216V60.7197Z",
    fill: "url(#paint146_linear_376_3569)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M147.213 57.461C147.213 57.4861 147.208 57.5113 147.194 57.5345C147.153 57.6042 147.064 57.6274 146.995 57.5867C146.896 57.5306 137.006 52.0244 125.319 65.8035C119.254 72.9523 115.733 82.2796 116.349 89.558C116.655 93.1856 117.964 96.0664 120.134 97.889C120.194 97.9412 120.201 98.0321 120.151 98.094C120.099 98.1559 120.008 98.1637 119.946 98.1114C117.716 96.2367 116.372 93.2882 116.058 89.5813C115.425 82.1132 118.89 72.9291 125.096 65.6139C136.948 51.6413 147.039 57.2753 147.14 57.3352C147.186 57.3623 147.212 57.4107 147.212 57.461H147.213Z",
    fill: "url(#paint147_linear_376_3569)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M141.062 53.8474C141.062 53.8629 141.06 53.8784 141.054 53.8919C141.029 53.9674 140.948 54.01 140.872 53.9848C136.617 52.5976 132.257 53.089 127.912 55.4475C120.901 59.2531 114.573 67.8974 112.163 76.9596C108.803 89.6147 115.373 95.0822 115.441 95.1344C115.503 95.1847 115.512 95.2776 115.462 95.3395C115.412 95.4014 115.32 95.4111 115.257 95.3608C115.189 95.3047 108.472 89.7191 111.882 76.8842C114.311 67.7504 120.697 59.0325 127.773 55.1921C132.191 52.795 136.626 52.2958 140.961 53.7081C141.023 53.7275 141.062 53.7855 141.062 53.8455V53.8474Z",
    fill: "url(#paint148_linear_376_3569)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M135.268 50.6899C135.268 50.7054 135.266 50.7228 135.26 50.7382C135.233 50.8137 135.15 50.8543 135.074 50.8272C134.971 50.7905 124.717 47.3602 114.498 59.5567C104.14 71.9196 104.496 86.7783 111.328 92.9017C111.388 92.9558 111.392 93.0468 111.339 93.1067C111.285 93.1667 111.194 93.1706 111.134 93.1183C104.202 86.9059 103.809 71.8635 114.276 59.371C124.63 47.012 135.068 50.5177 135.171 50.5544C135.231 50.5757 135.268 50.6318 135.268 50.6918V50.6899Z",
    fill: "url(#paint149_linear_376_3569)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M129.113 47.6117C129.113 47.6117 129.113 47.6233 129.113 47.6291C129.103 47.7084 129.031 47.7664 128.952 47.7568C115.256 46.1413 104.855 58.7615 102.023 71.4571C99.1488 84.3482 107.022 90.8218 107.102 90.8856C107.166 90.9359 107.175 91.0268 107.125 91.0907C107.075 91.1526 106.984 91.1642 106.92 91.1139C106.838 91.0481 98.8234 84.4681 101.74 71.3952C103.241 64.6643 106.73 58.2817 111.311 53.886C116.47 48.9331 122.583 46.7139 128.987 47.4704C129.06 47.4782 129.115 47.542 129.115 47.6136L129.113 47.6117Z",
    fill: "url(#paint150_linear_376_3569)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M123.325 44.9981C123.325 44.9981 123.325 45.0155 123.323 45.0232C123.31 45.1026 123.234 45.1548 123.155 45.1413C123.05 45.1239 112.636 43.431 103.809 54.1784C98.6124 60.5068 95.9492 69.1163 96.8615 76.6482C97.5239 82.1196 99.945 86.5598 103.861 89.4909C103.927 89.5393 103.939 89.6302 103.89 89.6941C103.842 89.7579 103.751 89.7715 103.687 89.7231C99.7049 86.7436 97.245 82.2338 96.5729 76.683C95.6529 69.0777 98.3374 60.383 103.584 53.9946C112.523 43.1098 123.099 44.8375 123.205 44.8569C123.275 44.8685 123.325 44.9304 123.325 45V44.9981Z",
    fill: "url(#paint151_linear_376_3569)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M119.08 43.2618C119.08 43.2618 119.08 43.2812 119.078 43.2908C119.062 43.3702 118.985 43.4205 118.905 43.405C114.119 42.4396 108.611 43.8519 103.792 47.2841C97.58 51.7069 93.3963 58.8963 92.3117 67.0086C90.1346 83.2719 101.035 88.3351 101.144 88.3834C101.218 88.4163 101.25 88.5014 101.218 88.575C101.185 88.6485 101.099 88.6814 101.026 88.6485C100.913 88.5982 89.8189 83.4576 92.0231 66.9699C93.1174 58.7783 97.3457 51.5153 103.621 47.0461C108.506 43.5675 114.096 42.1358 118.962 43.1187C119.029 43.1322 119.078 43.1941 119.078 43.2599L119.08 43.2618Z",
    fill: "url(#paint152_linear_376_3569)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M113.244 41.1493C113.244 41.1609 113.244 41.1725 113.24 41.1841C113.221 41.2615 113.142 41.3098 113.064 41.2905C112.969 41.2673 103.5 39.1004 93.9256 50.0567C88.5894 56.1627 86.2283 65.3584 87.9115 73.4862C89.2422 79.9192 92.8913 84.8527 98.1829 87.3775C98.2565 87.4123 98.2875 87.4975 98.2507 87.571C98.2158 87.6426 98.1287 87.6735 98.057 87.6387C92.6802 85.0733 88.9749 80.0681 87.6249 73.5443C85.9262 65.3314 88.3125 56.0369 93.7048 49.8652C103.403 38.7676 113.035 40.9848 113.132 41.008C113.198 41.0235 113.242 41.0835 113.242 41.1493H113.244Z",
    fill: "url(#paint153_linear_376_3569)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M108.136 39.6677C108.136 39.6812 108.136 39.6947 108.13 39.7083C108.107 39.7857 108.028 39.8282 107.95 39.807C105.188 38.9866 99.6254 40.0759 94.3376 43.7422C90.5084 46.3986 83.9694 52.5181 83.2082 63.6621C81.9376 82.3651 95.8077 86.635 95.9491 86.6756C96.0266 86.6969 96.0712 86.7782 96.0479 86.8555C96.0247 86.9329 95.9453 86.9774 95.8678 86.9542C95.7245 86.9136 81.6277 82.5624 82.9196 63.6427C83.6885 52.3768 90.3011 46.1896 94.173 43.5042C99.5363 39.7837 105.206 38.6887 108.033 39.5284C108.097 39.5477 108.138 39.6057 108.138 39.6677H108.136Z",
    fill: "url(#paint154_linear_376_3569)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M101.828 38.0345C101.828 38.0345 101.828 38.0422 101.828 38.0442C101.822 38.1235 101.754 38.1854 101.673 38.1796C101.535 38.1699 87.7931 37.4463 80.7467 54.2842C77.1576 62.8608 78.833 69.8355 80.8706 74.177C83.8806 80.5887 89.2806 84.7425 93.0247 85.8898C93.1021 85.9131 93.1409 85.9963 93.1215 86.0717C93.0983 86.1491 93.0169 86.1917 92.9395 86.1684C89.0095 84.9631 83.6714 80.8267 80.6072 74.3009C78.5444 69.9071 76.8477 62.8492 80.4774 54.1739C87.6072 37.1368 101.553 37.8816 101.692 37.8913C101.77 37.8971 101.828 37.961 101.828 38.0364V38.0345Z",
    fill: "url(#paint155_linear_376_3569)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M96.542 37.1119C96.542 37.1932 96.4761 37.259 96.3948 37.257C96.2611 37.257 82.8713 37.3073 76.5628 53.2978C73.0725 62.1511 74.9494 69.2593 77.1381 73.6646C79.9679 79.3566 85.0368 83.82 90.3632 85.3136C90.4407 85.3349 90.4853 85.4161 90.4639 85.4935C90.4426 85.5709 90.3613 85.6154 90.2858 85.5941C84.8818 84.0793 79.7451 79.5578 76.8785 73.7943C74.6627 69.3367 72.7626 62.1453 76.2936 53.1914C82.6757 37.0075 96.263 36.9649 96.3986 36.9668C96.478 36.9668 96.542 37.0326 96.542 37.1119Z",
    fill: "url(#paint156_linear_376_3569)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M91.328 36.5799C91.328 36.6534 91.2718 36.7172 91.1963 36.725C91.0665 36.7366 78.066 38.056 72.5885 52.6381C69.9969 59.5334 70.4095 66.8447 73.7429 73.2235C76.8419 79.1534 82.0173 83.4176 87.9403 84.9247C88.0178 84.9441 88.0624 85.0214 88.0449 85.1008C88.0256 85.1782 87.9462 85.2265 87.8687 85.2052C81.8662 83.6788 76.623 79.3604 73.4853 73.357C70.1112 66.9047 69.6967 59.5102 72.3154 52.5355C77.8588 37.7775 91.0375 36.4464 91.1692 36.4348C91.2486 36.427 91.3202 36.487 91.328 36.5663C91.328 36.5702 91.328 36.5741 91.328 36.5799Z",
    fill: "url(#paint157_linear_376_3569)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7204 84.9105C86.7204 84.9105 86.7204 84.926 86.7204 84.9338C86.7088 85.0131 86.6333 85.0673 86.5539 85.0537C86.5055 85.046 81.5935 84.2431 76.7628 80.8457C72.3215 77.7231 67.0435 71.708 67.0435 60.7865C67.0435 60.7343 67.0435 60.6859 67.0435 60.6337C67.0899 50.31 72.2615 44.2485 76.5924 40.9827C81.2797 37.446 86.0251 36.3355 86.0716 36.3239C86.1491 36.3064 86.2285 36.3548 86.2459 36.4322C86.2633 36.5115 86.2149 36.5889 86.1355 36.6063C86.089 36.6179 81.3978 37.7188 76.757 41.2206C72.4842 44.4478 67.3785 50.4338 67.3321 60.6337C67.3321 60.684 67.3321 60.7343 67.3321 60.7846C67.3321 71.5784 72.5404 77.516 76.9197 80.6C81.6961 83.9625 86.55 84.7577 86.5984 84.7654C86.6701 84.7771 86.7204 84.839 86.7204 84.9086V84.9105Z",
    fill: "url(#paint158_linear_376_3569)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9034 84.7528C83.9034 84.7528 83.9034 84.7663 83.9034 84.7741C83.8918 84.8534 83.8182 84.9076 83.7388 84.896C76.8705 83.8764 70.7925 79.6142 67.0621 73.1986C63.2096 66.5722 62.4484 58.6611 65.0264 52.0405C70.194 38.7702 80.5158 36.7388 80.6204 36.7194C80.6998 36.7059 80.7753 36.7581 80.7889 36.8355C80.8044 36.9129 80.7521 36.9903 80.6727 37.0038C80.57 37.0232 70.4032 39.0314 65.2975 52.143C62.7505 58.6824 63.504 66.4987 67.3139 73.0496C70.9998 79.3878 77.0022 83.5997 83.7814 84.6057C83.8531 84.6154 83.9054 84.6793 83.9054 84.7489L83.9034 84.7528Z",
    fill: "url(#paint159_linear_376_3569)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M87.373 85.3442C87.373 85.4158 87.3188 85.4797 87.2452 85.4874C81.173 86.2323 74.173 83.8932 68.9783 79.3853C65.2323 76.1349 60.7309 70.3018 60.5605 60.9667C60.5566 60.7887 60.5547 60.6107 60.5547 60.4327C60.5547 43.7167 75.066 37.7965 75.2132 37.7365C75.2868 37.7075 75.372 37.7442 75.401 37.8178C75.4301 37.8913 75.3933 37.9764 75.3197 38.0054C75.1725 38.0635 60.5237 44.036 60.8491 60.959C61.0176 70.1857 65.4647 75.9511 69.1662 79.1628C74.3009 83.6185 81.2137 85.9304 87.2065 85.1953C87.2859 85.1856 87.3595 85.2417 87.3692 85.321C87.3692 85.3268 87.3692 85.3326 87.3692 85.3384L87.373 85.3442Z",
    fill: "url(#paint160_linear_376_3569)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1569 85.4741C85.1569 85.5476 85.1026 85.6095 85.029 85.6173C78.3351 86.4067 71.8349 84.441 66.7234 80.082C61.2807 75.4406 57.9938 68.6285 57.7032 61.3926C57.1531 47.5652 68.9566 39.8534 69.0748 39.7779C69.1426 39.7353 69.2336 39.7547 69.2762 39.8224C69.3188 39.8901 69.2994 39.981 69.2317 40.0236C69.1135 40.0991 57.4495 47.7006 57.9938 61.3829C58.2804 68.5376 61.5305 75.2723 66.9112 79.8615C71.9608 84.1682 78.3816 86.1087 84.9942 85.329C85.0736 85.3193 85.1472 85.3754 85.1549 85.4567C85.1549 85.4625 85.1549 85.4683 85.1549 85.4741H85.1569Z",
    fill: "url(#paint161_linear_376_3569)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M85.691 85.5109C85.691 85.5747 85.6484 85.6347 85.5826 85.6502C77.9802 87.6913 63.3857 86.7607 56.9087 70.3272C53.2692 61.0947 55.6148 53.8878 58.2238 49.4689C61.0478 44.6844 64.786 42.0454 64.8228 42.0183C64.8887 41.9719 64.9797 41.9893 65.0262 42.0551C65.0708 42.1209 65.0572 42.2118 64.9914 42.2582C64.9546 42.2834 61.2609 44.8933 58.4698 49.6276C55.8976 53.9884 53.5849 61.1024 57.1798 70.2208C63.5832 86.4647 77.9996 87.3856 85.509 85.3696C85.5864 85.3484 85.6659 85.3948 85.6872 85.4722C85.691 85.4857 85.693 85.4973 85.693 85.5109H85.691Z",
    fill: "url(#paint162_linear_376_3569)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1751 85.347C87.1751 85.3973 87.148 85.4476 87.1015 85.4747C82.5246 88.0362 75.2457 88.2123 68.9856 85.9139C62.2123 83.4277 57.1085 78.3588 54.6119 71.6433C48.7721 55.9315 59.4425 45.896 59.551 45.7954C59.611 45.7413 59.7021 45.7451 59.7563 45.8051C59.8125 45.8632 59.8067 45.956 59.7485 46.0102C59.642 46.1089 49.115 56.0166 54.8869 71.5427C57.3526 78.1769 62.3963 83.184 69.0883 85.6411C75.2709 87.9124 82.4548 87.7422 86.962 85.2193C87.0317 85.1806 87.1208 85.2057 87.1596 85.2754C87.1731 85.2986 87.1789 85.3218 87.1789 85.347H87.1751Z",
    fill: "url(#paint163_linear_376_3569)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3605 85.3109C88.3605 85.3612 88.3333 85.4115 88.2849 85.4386C82.848 88.4316 68.9217 93.9881 57.0466 80.9655C44.2436 66.9291 53.6783 52.1536 53.7751 52.0046C53.8197 51.9369 53.9088 51.9195 53.9766 51.9621C54.0444 52.0046 54.0637 52.0956 54.0192 52.1633C53.9959 52.2 51.6194 55.8741 50.8407 61.2139C50.126 66.1358 50.6548 73.5226 57.2616 80.7682C68.9973 93.6379 82.7686 88.1414 88.1435 85.1813C88.2133 85.1426 88.3024 85.1677 88.3411 85.2374C88.3527 85.2586 88.3585 85.2838 88.3585 85.307L88.3605 85.3109Z",
    fill: "url(#paint164_linear_376_3569)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1565 85.3422C89.1565 85.3828 89.1391 85.4254 89.1042 85.4544C85.2014 88.7106 79.5708 90.7265 74.0371 90.8446C69.1987 90.949 62.0689 89.6605 55.5745 82.9277C44.1487 71.0814 50.4998 57.2926 50.5657 57.1552C50.6005 57.0817 50.6858 57.0508 50.7594 57.0856C50.831 57.1204 50.862 57.2075 50.8272 57.2791C50.7632 57.4145 44.4993 71.0272 55.7837 82.7265C66.8996 94.2497 81.8505 91.129 88.9163 85.2319C88.9783 85.1797 89.0694 85.1894 89.1217 85.2513C89.1449 85.2784 89.1565 85.3112 89.1565 85.3441V85.3422Z",
    fill: "url(#paint165_linear_376_3569)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9872 85.3115C89.9872 85.3482 89.9737 85.385 89.9465 85.4121C85.3697 90.1057 79.2335 92.6944 72.6636 92.7002C65.898 92.7079 59.2757 89.9103 54.4974 85.029C44.9891 75.3148 48.0049 63.5768 48.0359 63.4588C48.0572 63.3814 48.1366 63.335 48.2141 63.3562C48.2915 63.3775 48.34 63.4549 48.3167 63.5342C48.2857 63.6503 45.3165 75.2335 54.7046 84.8259C59.4287 89.653 65.9735 92.4158 72.6636 92.41C79.1541 92.4042 85.2166 89.8465 89.7393 85.2089C89.7955 85.1509 89.8865 85.1509 89.9446 85.207C89.9737 85.236 89.9892 85.2728 89.9892 85.3115H89.9872Z",
    fill: "url(#paint166_linear_376_3569)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M90.884 85.5339C90.884 85.5629 90.8763 85.5919 90.8588 85.6171C90.7852 85.7216 83.3708 96.0472 69.1752 94.5555C55.0087 93.0677 46.5154 81.2369 46.4883 70.6578C46.4883 70.5765 46.5522 70.5127 46.6335 70.5127C46.7149 70.5127 46.7788 70.5765 46.7788 70.6578C46.8059 81.1072 55.2024 92.7949 69.2043 94.2672C83.2255 95.7395 90.547 85.5532 90.6187 85.4507C90.6651 85.3849 90.7562 85.3694 90.822 85.4159C90.8627 85.4449 90.884 85.4894 90.884 85.5339Z",
    fill: "url(#paint167_linear_376_3569)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8801 85.7567C91.8801 85.7818 91.8743 85.805 91.8607 85.8283C88.2116 92.2573 75.2983 101.469 60.6069 94.7338C45.685 87.8945 46.1285 74.6514 46.1324 74.514C46.1363 74.4347 46.2041 74.3728 46.2854 74.3766C46.3648 74.3805 46.4288 74.4482 46.4249 74.5275C46.4152 74.6533 45.9929 87.7146 60.7308 94.4687C75.2499 101.124 88.0082 92.031 91.6109 85.6832C91.6515 85.6135 91.7387 85.5884 91.8084 85.629C91.8549 85.6561 91.882 85.7044 91.882 85.7547L91.8801 85.7567Z",
    fill: "url(#paint168_linear_376_3569)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7803 85.9464C92.7803 85.9638 92.7784 85.9793 92.7726 85.9967C92.7397 86.0895 89.2862 95.2408 76.5704 98.6807C70.0256 100.451 62.5492 99.2805 56.5738 95.5503C51.0052 92.0736 47.2999 86.8383 46.1456 80.8097C46.1242 80.7323 46.1824 80.6549 46.2618 80.6394C46.3412 80.624 46.4167 80.6762 46.4322 80.7555C47.573 86.7048 51.2299 91.8724 56.7288 95.3046C62.6383 98.9922 70.0256 100.151 76.4949 98.4002C89.0673 94.9989 92.4666 85.9889 92.4995 85.898C92.5266 85.8226 92.6099 85.7839 92.6854 85.811C92.7455 85.8322 92.7823 85.8883 92.7823 85.9483L92.7803 85.9464Z",
    fill: "url(#paint169_linear_376_3569)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8145 86.24C93.8145 86.2555 93.8125 86.271 93.8067 86.2865C93.7506 86.4509 87.9147 102.724 68.7994 102.151C50.5363 101.604 46.587 85.5165 46.5502 85.3539C46.5289 85.2746 46.5812 85.1972 46.6587 85.1798C46.7361 85.1624 46.8156 85.2108 46.833 85.2882C46.8698 85.4487 50.7746 101.319 68.8091 101.859C87.7132 102.426 93.4775 86.3523 93.5336 86.1897C93.5607 86.1143 93.6421 86.0737 93.7176 86.1007C93.7777 86.122 93.8164 86.1781 93.8164 86.2381L93.8145 86.24Z",
    fill: "url(#paint170_linear_376_3569)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8006 86.468C94.8006 86.468 94.8006 86.4815 94.8006 86.4893C94.7812 86.6228 92.6506 99.9162 77.1767 104.19C61.6563 108.477 49.5488 97.6932 47.4104 90.7089C47.3891 90.6315 47.4298 90.5502 47.5073 90.527C47.5847 90.5038 47.6661 90.5464 47.6893 90.6238C49.7986 97.5133 61.759 108.148 77.1012 103.911C92.3872 99.6879 94.4946 86.5802 94.5139 86.4467C94.5256 86.3674 94.5992 86.3132 94.6786 86.3248C94.7522 86.3345 94.8025 86.3983 94.8025 86.468H94.8006Z",
    fill: "url(#paint171_linear_376_3569)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7465 86.7127V86.7185C95.7427 86.8152 95.2894 96.5372 85.3144 103.46C79.2248 107.685 70.5107 109.186 63.1156 107.286C58.5348 106.108 52.265 103.073 48.4125 95.299C48.3777 95.2274 48.4048 95.1403 48.4784 95.1035C48.5501 95.0687 48.6372 95.0977 48.674 95.1693C52.48 102.844 58.6684 105.841 63.1892 107.004C70.5068 108.885 79.126 107.401 85.1498 103.22C95.0067 96.3805 95.4541 86.8036 95.456 86.7069C95.458 86.6275 95.5257 86.5637 95.6071 86.5675C95.6846 86.5695 95.7465 86.6353 95.7465 86.7127Z",
    fill: "url(#paint172_linear_376_3569)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6174 87.9679C96.6174 89.0532 96.2843 104.57 78.519 110.02C71.215 112.26 64.3041 111.802 58.5321 108.693C52.9442 105.684 50.0349 101.138 49.5643 99.5259C49.541 99.4485 49.5856 99.3692 49.6631 99.346C49.7405 99.3227 49.8219 99.3672 49.8432 99.4446C50.3022 101.019 53.163 105.469 58.6697 108.435C64.3719 111.508 71.2053 111.958 78.4338 109.741C96.5438 104.185 96.3327 88.0743 96.3269 87.9156V87.9117C96.3269 87.8324 96.3889 87.7686 96.4683 87.7666C96.5496 87.7647 96.6155 87.8286 96.6174 87.9079C96.6174 87.9137 96.6174 87.933 96.6174 87.9679Z",
    fill: "url(#paint173_linear_376_3569)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7118 90.7114C97.7118 96.0938 95.6315 101.35 91.7635 105.661C86.8109 111.183 79.656 114.389 71.6217 114.688C55.7643 115.282 51.0111 104.044 50.9646 103.931C50.9337 103.858 50.9705 103.773 51.0441 103.742C51.1177 103.711 51.2029 103.748 51.2339 103.821C51.2784 103.933 55.9638 114.982 71.6101 114.398C79.5669 114.1 86.6482 110.929 91.5466 105.468C95.7187 100.816 97.7873 95.049 97.367 89.2294C97.3554 89.152 97.4212 89.0804 97.5026 89.0746C97.582 89.0688 97.6517 89.1288 97.6575 89.21C97.6943 89.7111 97.7118 90.2142 97.7118 90.7133V90.7114Z",
    fill: "url(#paint174_linear_376_3569)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7963 94.3946C98.7963 98.5833 97.3843 106.384 88.217 112.908C81.2964 117.832 72.9077 119.563 65.2008 117.656C59.4327 116.228 54.8267 112.831 52.5605 108.334C52.5257 108.263 52.5528 108.176 52.6244 108.139C52.6961 108.102 52.7833 108.131 52.8201 108.203C55.0475 112.624 59.5857 115.967 65.2705 117.373C72.8941 119.26 81.1957 117.545 88.0465 112.67C101.072 103.403 98.2637 91.568 98.2346 91.448C98.2114 91.3706 98.2617 91.2913 98.3392 91.272C98.4167 91.2526 98.4961 91.2991 98.5155 91.3764C98.5252 91.4132 98.7963 92.5566 98.7963 94.3907V94.3946Z",
    fill: "url(#paint175_linear_376_3569)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M100.27 98.193C100.27 102.386 98.8543 106.476 96.0904 110.182C91.3179 116.586 83.2061 120.97 74.3951 121.913C59.5604 123.497 54.5245 113.177 54.476 113.073C54.4431 112.999 54.4741 112.914 54.5458 112.879C54.6194 112.845 54.7046 112.876 54.7395 112.949C54.7879 113.052 59.7444 123.188 74.3642 121.624C83.0957 120.692 91.13 116.348 95.856 110.008C99.3328 105.344 100.648 100.066 99.6562 94.7511C99.6407 94.6756 99.693 94.5963 99.7724 94.5808C99.8519 94.5654 99.9274 94.6176 99.9429 94.6969C100.16 95.8655 100.268 97.0341 100.268 98.193H100.27Z",
    fill: "url(#paint176_linear_376_3569)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M101.94 101.815C101.94 106.147 100.282 113.278 91.2153 119.885C83.948 125.179 75.4179 127.206 67.8078 125.448C62.6131 124.248 58.5068 121.429 56.5428 117.712C56.506 117.643 56.5331 117.554 56.6029 117.517C56.6745 117.48 56.7617 117.507 56.7985 117.577C58.7238 121.218 62.7603 123.983 67.8737 125.163C75.4005 126.902 83.8454 124.892 91.0429 119.649C105.087 109.416 101.157 97.9667 101.117 97.8526C101.09 97.7771 101.128 97.6939 101.204 97.6668C101.279 97.6398 101.363 97.6784 101.39 97.7539C101.405 97.7965 101.94 99.3539 101.94 101.813V101.815Z",
    fill: "url(#paint177_linear_376_3569)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M103.811 105.205C103.811 107.01 103.507 109.219 102.655 111.614C100.971 116.341 96.6929 122.942 85.8695 127.549C75.9545 131.768 69.2199 130.329 65.3151 128.379C61.0752 126.26 59.1615 123.093 59.1422 123.06C59.1015 122.991 59.1247 122.902 59.1925 122.861C59.2622 122.82 59.3513 122.844 59.392 122.911C59.4114 122.942 61.2902 126.047 65.4603 128.125C69.309 130.043 75.9545 131.453 85.7571 127.282C96.4837 122.716 100.718 116.188 102.382 111.516C104.012 106.938 103.619 102.744 102.821 101.229C102.784 101.157 102.812 101.07 102.883 101.033C102.955 100.997 103.042 101.024 103.079 101.095C103.472 101.842 103.813 103.299 103.813 105.207L103.811 105.205Z",
    fill: "url(#paint178_linear_376_3569)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M105.897 109.246C105.897 113.419 104.197 120.233 95.2171 127.119C87.5567 132.993 78.8174 135.448 71.2402 133.858C66.7292 132.911 63.1575 130.574 61.4395 127.45C61.4008 127.38 61.426 127.291 61.4976 127.252C61.5673 127.214 61.6564 127.239 61.6952 127.31C63.3725 130.361 66.8725 132.644 71.3003 133.575C78.7942 135.148 87.4482 132.712 95.0409 126.891C109.233 116.012 105.041 105.363 104.997 105.257C104.966 105.183 105.002 105.098 105.076 105.067C105.15 105.036 105.235 105.071 105.266 105.146C105.283 105.187 105.897 106.742 105.897 109.25V109.246Z",
    fill: "url(#paint179_linear_376_3569)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M108.291 113.17C108.291 114.547 108.084 116.14 107.561 117.896C106.337 122.013 102.448 129.779 90.1406 135.518C80.5355 139.997 74.0643 139.025 70.3241 137.422C66.2605 135.678 64.4534 132.825 64.434 132.796C64.3894 132.728 64.4127 132.637 64.4805 132.596C64.5483 132.554 64.6393 132.575 64.68 132.643C64.6974 132.67 66.4677 135.458 70.4539 137.16C74.1359 138.735 80.52 139.681 90.0166 135.253C102.219 129.563 106.072 121.882 107.28 117.811C108.56 113.506 107.927 110.233 106.994 108.739C106.951 108.67 106.972 108.581 107.04 108.538C107.108 108.496 107.199 108.517 107.24 108.585C107.819 109.513 108.287 111.098 108.287 113.166L108.291 113.17Z",
    fill: "url(#paint180_linear_376_3569)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M110.896 117.62C110.896 121.723 109.035 128.272 99.6602 135.233C91.3586 141.397 82.9583 144.114 76.0106 142.881C72.1756 142.2 69.1036 140.362 67.3624 137.706C67.3178 137.64 67.3372 137.549 67.405 137.505C67.4728 137.46 67.5619 137.479 67.6064 137.547C69.3051 140.138 72.3092 141.929 76.0629 142.597C82.9312 143.816 91.2521 141.119 99.4878 135.001C114.76 123.66 109.883 113.512 109.831 113.41C109.796 113.34 109.823 113.251 109.895 113.214C109.966 113.177 110.054 113.206 110.09 113.278C110.112 113.319 110.896 114.952 110.896 117.618V117.62Z",
    fill: "url(#paint181_linear_376_3569)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M113.699 121.354C113.699 122.449 113.54 123.637 113.218 124.856C112.337 128.189 108.82 136.7 95.2323 143.719C77.684 152.785 71.2167 143.787 71.1527 143.696C71.1082 143.63 71.1237 143.539 71.1896 143.495C71.2554 143.448 71.3464 143.466 71.391 143.532C71.453 143.621 77.7924 152.402 95.0967 143.462C108.581 136.495 112.064 128.077 112.936 124.782C113.706 121.872 113.528 119.162 112.463 117.527C112.42 117.461 112.438 117.37 112.506 117.326C112.573 117.281 112.662 117.301 112.707 117.368C113.364 118.376 113.697 119.767 113.697 121.354H113.699Z",
    fill: "url(#paint182_linear_376_3569)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M116.732 125.976C116.732 126.494 116.693 127.059 116.601 127.667C116.076 131.099 113.641 136.615 105.008 143.4C93.47 152.472 85.0755 152.783 81.101 152.162C77.5874 151.613 75.4627 150.125 74.6453 148.914C74.6007 148.848 74.6182 148.757 74.684 148.713C74.7499 148.668 74.8409 148.686 74.8855 148.751C75.6331 149.858 77.7211 151.34 81.1455 151.876C85.0755 152.489 93.3771 152.176 104.83 143.174C121.168 130.329 115.46 121.983 115.4 121.899C115.353 121.834 115.367 121.743 115.433 121.696C115.496 121.65 115.588 121.665 115.636 121.729C115.688 121.803 116.732 123.291 116.732 125.978V125.976Z",
    fill: "url(#paint183_linear_376_3569)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M119.663 129.833C119.663 132.513 118.652 136.698 113.97 141.726C106.683 149.554 94.7754 157.459 86.1117 157.423C82.9138 157.409 80.3145 156.335 78.3873 154.23C78.3331 154.17 78.3369 154.079 78.397 154.025C78.457 153.971 78.548 153.975 78.6023 154.035C80.4714 156.078 82.999 157.119 86.1136 157.132C94.6921 157.167 106.515 149.308 113.759 141.527C121.826 132.859 118.849 126.817 118.818 126.757C118.781 126.688 118.808 126.599 118.88 126.562C118.952 126.525 119.039 126.552 119.076 126.624C119.089 126.651 119.665 127.814 119.665 129.831L119.663 129.833Z",
    fill: "url(#paint184_linear_376_3569)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M123.185 134.159C123.185 137.431 121.079 141.571 117.093 145.972C112.288 151.281 107.532 155.315 97.447 160.222C86.918 165.343 82.7614 160.185 82.7207 160.133C82.6704 160.069 82.6839 159.978 82.7459 159.93C82.8079 159.881 82.9009 159.893 82.9493 159.955C82.9899 160.005 87.0168 164.971 97.3172 159.961C107.36 155.075 112.094 151.061 116.876 145.779C122.013 140.104 123.992 134.906 122.309 131.514C122.274 131.443 122.301 131.356 122.375 131.319C122.447 131.284 122.534 131.313 122.571 131.385C122.983 132.213 123.185 133.145 123.185 134.159Z",
    fill: "url(#paint185_linear_376_3569)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M126.77 138.412C126.77 141.32 124.997 147.159 114.42 156.118C101.464 167.088 93.4354 167.587 90.5843 167.293C88.9709 167.127 87.6983 166.585 87.0921 165.809C87.0437 165.748 87.0533 165.655 87.1173 165.606C87.1812 165.556 87.2722 165.568 87.3206 165.631C87.8765 166.345 89.0774 166.847 90.6134 167.005C93.4277 167.295 101.361 166.796 114.232 155.896C129.58 142.898 126.113 136.446 126.076 136.382C126.035 136.313 126.059 136.224 126.128 136.183C126.198 136.142 126.287 136.166 126.328 136.235C126.378 136.32 126.771 137.04 126.771 138.41L126.77 138.412Z",
    fill: "url(#paint186_linear_376_3569)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M130.308 142.707C130.308 145.429 128.435 150.963 117.561 160.153C103.886 171.709 96.5144 172.401 93.9809 172.161C92.7297 172.043 91.7728 171.647 91.2867 171.047C91.2363 170.985 91.246 170.894 91.308 170.842C91.37 170.792 91.461 170.801 91.5133 170.863C91.9433 171.395 92.8536 171.763 94.01 171.871C96.5066 172.107 103.784 171.415 117.375 159.93C133.401 146.389 129.602 140.859 129.564 140.803C129.515 140.74 129.531 140.649 129.595 140.6C129.659 140.552 129.75 140.565 129.798 140.631C129.854 140.707 130.309 141.366 130.309 142.707H130.308Z",
    fill: "url(#paint187_linear_376_3569)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M134.281 146.95C134.281 149.049 132.559 154.097 121.162 164.508C107.397 177.081 99.9763 177.648 98.0316 177.523C97.1252 177.464 96.4337 177.227 96.1335 176.871C96.0831 176.809 96.0889 176.718 96.1509 176.665C96.2129 176.613 96.3039 176.621 96.3562 176.683C96.4492 176.791 96.8443 177.155 98.051 177.232C99.9685 177.356 107.288 176.789 120.966 164.293C136.669 149.949 133.769 145.913 133.738 145.872C133.69 145.81 133.698 145.72 133.76 145.669C133.822 145.619 133.913 145.627 133.963 145.689C134.002 145.735 134.283 146.105 134.283 146.95H134.281Z",
    fill: "url(#paint188_linear_376_3569)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M138.383 151.535C138.383 155.579 130.876 164.295 118.634 174.336C105.952 184.739 101.504 182.932 101.322 182.849C101.249 182.816 101.218 182.731 101.249 182.657C101.282 182.584 101.367 182.551 101.441 182.584C101.497 182.607 105.971 184.346 118.45 174.111C131.561 163.358 139.22 154.197 137.969 150.767C137.939 150.692 137.98 150.608 138.056 150.581C138.131 150.554 138.215 150.593 138.242 150.668C138.337 150.928 138.383 151.218 138.383 151.537V151.535Z",
    fill: "url(#paint189_linear_376_3569)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M142.822 156.053C142.822 157.013 141.796 161.018 128.813 173.284C116.49 184.925 109.225 188.75 106.746 188.487C106.412 188.452 106.178 188.338 106.048 188.15C106.004 188.084 106.021 187.993 106.085 187.949C106.151 187.904 106.242 187.92 106.286 187.986C106.364 188.1 106.534 188.173 106.775 188.198C108.721 188.405 115.512 185.451 128.611 173.073C143.384 159.116 142.528 155.941 142.516 155.912C142.489 155.838 142.528 155.755 142.601 155.726C142.675 155.697 142.756 155.732 142.787 155.803C142.795 155.821 142.822 155.896 142.822 156.053Z",
    fill: "url(#paint190_linear_376_3569)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M147.219 160.968C147.219 163.358 140.5 170.692 126.746 183.324C115.764 193.41 111.793 194.068 111.631 194.091C111.551 194.102 111.478 194.046 111.466 193.967C111.452 193.89 111.509 193.814 111.588 193.803C111.629 193.797 115.669 193.102 126.549 183.109C140.918 169.913 147.758 162.365 146.869 160.686C146.832 160.616 146.859 160.527 146.931 160.49C147.002 160.454 147.089 160.481 147.126 160.552C147.186 160.668 147.217 160.808 147.217 160.968H147.219Z",
    fill: "url(#paint191_linear_376_3569)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M152.106 165.879C152.106 165.903 152.1 165.926 152.088 165.949C152.02 166.075 150.341 169.112 143.074 176.248C126.525 192.493 118.183 199.913 116.821 199.596C116.744 199.576 116.693 199.501 116.713 199.422C116.73 199.344 116.81 199.294 116.887 199.313C118.109 199.598 126.85 191.768 142.871 176.042C150.107 168.938 151.817 165.845 151.833 165.814C151.871 165.742 151.958 165.717 152.03 165.754C152.079 165.781 152.106 165.829 152.106 165.881V165.879Z",
    fill: "url(#paint192_linear_376_3569)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M157.039 170.884C157.039 170.921 157.026 170.958 156.997 170.987L122.62 205.29C122.564 205.346 122.471 205.346 122.415 205.29C122.359 205.233 122.359 205.141 122.415 205.084L156.791 170.782C156.847 170.726 156.94 170.726 156.997 170.782C157.026 170.811 157.039 170.848 157.039 170.884Z",
    fill: "url(#paint193_linear_376_3569)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M163.51 241.86C161.666 240.424 159.805 238.948 157.938 237.437C157.903 237.414 157.885 237.396 157.885 237.396L157.88 237.39C156.1 235.949 154.314 234.473 152.516 232.962C152.505 232.956 147.089 228.33 147.089 228.33C145.181 226.674 143.268 224.983 141.34 223.246C141.34 223.246 137.693 219.939 135.884 218.26C135.873 218.254 132.405 215.012 130.666 213.344C129.642 214.04 128.745 214.646 127.738 215.315C126.236 216.31 124.747 217.267 123.281 218.192C121.716 219.175 120.174 220.121 118.65 221.028C116.916 222.058 115.212 223.033 113.536 223.963C113.048 224.23 112.564 224.497 112.082 224.759C112.058 224.77 112.035 224.782 112.012 224.793C111.21 225.2 110.418 225.594 109.633 225.974C109.633 225.974 109.628 225.979 109.616 225.985C108.324 226.606 107.055 227.194 105.812 227.734C105.812 227.734 105.806 227.734 105.806 227.74C104.497 228.309 103.216 228.839 101.967 229.321C101.403 229.541 100.844 229.75 100.292 229.948C100.292 229.948 100.28 229.953 100.263 229.959C100.234 229.971 100.204 229.982 100.175 229.994C98.9939 230.418 97.8376 230.807 96.7084 231.151C97.1791 229.808 97.704 228.425 98.2792 227.007C98.7324 225.902 99.2167 224.77 99.7338 223.619C100.193 222.59 100.689 221.539 101.2 220.469C101.2 220.469 101.206 220.464 101.212 220.446C102.416 217.966 103.761 215.397 105.237 212.746C105.237 212.746 105.242 212.74 105.248 212.723C105.969 211.432 106.726 210.119 107.51 208.795C109.203 205.942 111.041 203.007 113.025 200.004C113.612 199.114 114.206 198.22 114.816 197.318C115.235 196.709 115.655 196.092 116.085 195.477C116.085 195.477 116.085 195.471 116.091 195.465C117.087 194.035 118.103 192.594 119.151 191.135C120.298 189.549 121.477 187.951 122.694 186.335C122.694 186.335 122.694 186.329 122.7 186.323C123.852 184.801 125.026 183.267 126.242 181.721C126.248 181.715 126.248 181.709 126.254 181.703C127.528 180.076 128.844 178.432 130.186 176.781L130.192 176.776C131.513 175.148 132.874 173.51 134.265 171.865C135.656 170.221 137.081 168.565 138.536 166.903C139.99 165.241 141.474 163.573 142.993 161.9C142.993 161.9 142.993 161.894 142.998 161.888C143.849 160.951 144.709 160.017 145.576 159.081C147.757 156.722 150.004 154.35 152.307 151.974C153.861 150.376 155.437 148.772 157.043 147.169L157.188 147.023C160.597 143.618 164.012 140.329 167.421 137.156C167.944 136.669 168.356 136.29 168.879 135.814C167.942 134.947 167.006 134.094 166.075 133.244C166.069 133.239 162.718 130.24 161.054 128.787C159.39 127.334 157.732 125.91 156.086 124.521C154.44 123.132 152.815 121.744 151.186 120.425C151.18 120.419 146.25 116.478 146.245 116.472C144.697 115.257 143.169 114.075 141.645 112.924C141.639 112.918 138.456 110.5 136.868 109.354C135.408 108.308 133.965 107.292 132.533 106.298C132.528 106.292 131.294 105.442 130.684 105.03C129.975 105.698 129.305 106.348 128.596 107.033L128.584 107.027C128.584 107.027 128.59 107.039 128.59 107.044H128.584C126.676 108.886 124.762 110.769 122.847 112.68L122.684 112.843C120.881 114.644 119.107 116.445 117.362 118.235C116.482 119.136 115.616 120.036 114.755 120.938C113.834 121.891 112.934 122.843 112.037 123.797H112.031C110.286 125.645 108.576 127.492 106.9 129.328H106.895C105.126 131.263 103.398 133.192 101.706 135.111L101.694 135.123L101.688 135.129C100.013 137.029 98.3664 138.929 96.7723 140.813C96.72 140.859 96.691 140.894 96.691 140.894L96.6968 140.9C95.0272 142.846 93.404 144.793 91.8216 146.724C90.3553 148.513 88.924 150.297 87.5275 152.069C87.51 152.092 87.4984 152.104 87.4868 152.116C87.481 152.127 87.4752 152.133 87.4752 152.133C85.7881 154.277 84.1476 156.411 82.5593 158.525C82.5477 158.537 82.5361 158.554 82.5245 158.566C82.3966 158.74 82.263 158.914 82.1351 159.088C81.0001 160.605 79.8961 162.11 78.8133 163.61C78.8075 163.616 78.8075 163.621 78.8017 163.627C78.6681 163.796 78.5984 163.906 78.5984 163.906C77.3704 165.614 76.1792 167.311 75.0209 168.996C75.0151 169.002 75.0093 169.013 75.0035 169.019C73.7115 170.896 72.4603 172.761 71.2575 174.609C71.2459 174.62 71.2401 174.632 71.2342 174.638C71.2168 174.667 71.1994 174.696 71.1761 174.725C71.1064 174.829 71.0715 174.893 71.0483 174.922C71.0425 174.934 71.0367 174.94 71.0309 174.951C69.6925 177.008 68.4122 179.047 67.1803 181.071C67.1687 181.088 67.1571 181.105 67.1454 181.123C66.3184 182.477 65.5223 183.832 64.7437 185.168C64.7321 185.186 64.7204 185.203 64.7146 185.215C64.7088 185.226 64.703 185.232 64.703 185.238L64.6972 185.244C63.7074 186.946 62.7603 188.632 61.8519 190.305C61.8461 190.317 61.8345 190.328 61.8286 190.34H61.8345C60.8679 192.112 59.944 193.867 59.0763 195.604C59.0724 195.612 59.0686 195.62 59.0647 195.628C59.0124 195.715 58.9892 195.767 58.9892 195.767V195.773C58.257 197.22 57.552 198.667 56.8896 200.097C56.8837 200.108 56.8779 200.114 56.8721 200.126C56.0993 201.77 55.3768 203.403 54.6912 205.013C54.6854 205.024 54.6737 205.042 54.6679 205.053C54.0636 206.466 53.498 207.861 52.9634 209.244C52.9402 209.296 52.9286 209.32 52.9286 209.32C52.3533 210.802 51.811 212.266 51.3113 213.719V213.725C51.2532 213.887 51.2009 214.044 51.1428 214.207C51.137 214.224 51.1369 214.236 51.1311 214.247C51.1253 214.265 51.1253 214.282 51.1195 214.294C50.6372 215.683 50.1995 217.06 49.7986 218.415C49.7986 218.426 49.7927 218.426 49.7927 218.432C49.7869 218.45 49.7869 218.455 49.7869 218.455C49.2756 220.169 48.8204 221.86 48.4253 223.522C48.4079 223.58 48.3904 223.638 48.373 223.696C48.0825 224.911 47.821 226.115 47.5944 227.299V227.311C47.5827 227.34 47.5769 227.357 47.5769 227.357C47.205 229.263 46.9029 231.128 46.6859 232.958V232.975C46.471 234.719 46.3315 236.433 46.2618 238.112V238.124C46.2269 238.973 46.2095 239.815 46.2095 240.647C46.2095 241.233 46.2153 241.821 46.2327 242.401V242.413C46.2385 242.61 46.2443 242.802 46.2501 242.993C46.3199 244.609 46.4535 246.19 46.6685 247.735V247.764H46.6743C47.0636 250.636 47.6989 253.379 48.5996 255.975C48.5996 255.981 48.6054 255.987 48.6054 255.993C48.7565 256.422 48.9076 256.854 49.0761 257.277V257.283C49.0761 257.283 49.0819 257.289 49.0819 257.295C49.4073 258.15 49.7618 258.992 50.153 259.812C50.1762 259.899 50.1937 259.94 50.1937 259.94L50.2053 259.934C51.5321 262.724 53.1901 265.332 55.1851 267.733C55.1909 267.744 55.1967 267.75 55.2025 267.756C55.4059 268.011 55.6209 268.255 55.8417 268.505L55.8243 268.516C55.8533 268.539 55.8824 268.557 55.9056 268.58C55.9114 268.586 55.9172 268.592 55.923 268.598C56.4518 269.201 57.0116 269.795 57.5868 270.37C58.0459 270.828 58.5185 271.277 58.995 271.707C59.2041 271.904 59.3262 272.003 59.3262 272.003C60.7111 273.223 62.1715 274.332 63.6958 275.321C63.7423 275.361 63.783 275.396 63.8295 275.431L63.8411 275.408C65.5165 276.489 67.2849 277.43 69.123 278.232C69.1405 278.238 69.1521 278.244 69.1521 278.244C70.9495 279.022 72.8167 279.668 74.7536 280.179H74.7594C74.7594 280.179 74.771 280.19 74.7768 280.19L74.7827 280.185C76.4929 280.649 78.2671 280.999 80.0878 281.249C80.1401 281.26 80.1692 281.266 80.1692 281.266C81.1531 281.4 82.1468 281.504 83.1598 281.58V281.585C83.2121 281.585 83.2702 281.585 83.3225 281.591C84.411 281.672 85.515 281.719 86.6326 281.73C86.6501 281.73 86.6675 281.73 86.6791 281.736V281.73C87.6398 281.742 88.6102 281.73 89.6 281.69H89.6174C91.1127 281.632 92.637 281.521 94.1846 281.347H94.1904C94.1904 281.347 94.202 281.347 94.2078 281.353V281.347C96.0285 281.156 97.8841 280.883 99.7803 280.529H99.8036V280.523C101.781 280.163 103.794 279.722 105.849 279.186H105.866V279.18C107.594 278.745 109.351 278.238 111.142 277.675C111.148 277.675 111.154 277.669 111.154 277.669C112.899 277.124 114.673 276.518 116.471 275.857C116.54 275.851 116.604 275.845 116.674 275.833L116.657 275.787C118.297 275.183 119.955 274.543 121.631 273.841H121.636C121.636 273.841 121.648 273.835 121.654 273.835C121.66 273.835 121.671 273.829 121.671 273.829C123.864 272.916 126.093 271.935 128.344 270.871C128.355 270.865 128.361 270.865 128.361 270.865C130.066 270.064 131.782 269.221 133.521 268.325H133.533C133.533 268.325 133.539 268.319 133.544 268.319C135.708 267.208 137.908 266.036 140.124 264.786C140.136 264.78 140.147 264.775 140.159 264.769C141.898 263.797 143.649 262.782 145.412 261.723C145.476 261.689 145.528 261.66 145.569 261.636C145.586 261.625 145.604 261.619 145.621 261.607C145.673 261.573 145.708 261.555 145.72 261.544C145.726 261.544 145.726 261.538 145.731 261.538C147.366 260.555 149.012 259.545 150.67 258.492C151.019 258.301 151.24 258.144 151.31 258.092C151.327 258.08 151.339 258.069 151.339 258.069C152.927 257.051 154.527 256.018 156.133 254.936C156.162 254.919 156.185 254.907 156.185 254.902H156.191C157.814 253.814 159.443 252.7 161.083 251.549C161.101 251.537 161.124 251.52 161.141 251.508C161.176 251.485 161.217 251.467 161.246 251.444L161.24 251.438C163.16 250.102 165.091 248.712 167.035 247.283C167.041 247.277 167.047 247.271 167.053 247.271C167.064 247.265 167.07 247.259 167.082 247.248C167.227 247.155 167.308 247.091 167.308 247.091L167.303 247.085C167.86 246.679 168.298 246.346 168.858 245.928C168.736 245.847 163.512 241.854 163.512 241.854L163.51 241.86Z",
    fill: "#27E6D6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_376_3569",
    x1: 158.765,
    y1: 4.59375,
    x2: 186.282,
    y2: 7.88243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_376_3569",
    x1: 167.039,
    y1: 24.4116,
    x2: 178.86,
    y2: 29.5936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_376_3569",
    x1: 162.025,
    y1: 13.5771,
    x2: 181.867,
    y2: 22.5073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_376_3569",
    x1: 172.425,
    y1: 6.33203,
    x2: 181.137,
    y2: 6.67718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_376_3569",
    x1: 170.666,
    y1: 4.6123,
    x2: 173.272,
    y2: 4.64143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_376_3569",
    x1: 146.919,
    y1: 7.41601,
    x2: 170.898,
    y2: 9.88948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_376_3569",
    x1: 161.305,
    y1: 25.8345,
    x2: 167.427,
    y2: 26.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_376_3569",
    x1: 152.204,
    y1: 16.0122,
    x2: 162.44,
    y2: 16.6768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_376_3569",
    x1: 150.658,
    y1: 14.0942,
    x2: 171.096,
    y2: 16.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_376_3569",
    x1: 146.994,
    y1: 22.5547,
    x2: 169.735,
    y2: 28.2449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_376_3569",
    x1: 162.07,
    y1: 37.7373,
    x2: 173.892,
    y2: 42.9191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_376_3569",
    x1: 172.093,
    y1: 12.2109,
    x2: 189.233,
    y2: 13.5391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_376_3569",
    x1: 176.708,
    y1: 28.252,
    x2: 182.829,
    y2: 28.6535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_376_3569",
    x1: 178.565,
    y1: 20.1519,
    x2: 188.801,
    y2: 20.8164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_376_3569",
    x1: 172.213,
    y1: 29.1133,
    x2: 185.648,
    y2: 32.2129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_376_3569",
    x1: 172.086,
    y1: 20.6548,
    x2: 189.139,
    y2: 23.3441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_376_3569",
    x1: 145.938,
    y1: 0.0605436,
    x2: 186.999,
    y2: 5.22306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_376_3569",
    x1: 153.524,
    y1: 36.374,
    x2: 173.367,
    y2: 45.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_376_3569",
    x1: 156.7,
    y1: 34.7993,
    x2: 170.856,
    y2: 38.6283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_376_3569",
    x1: 167.263,
    y1: 34.7979,
    x2: 172.651,
    y2: 35.2384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_376_3569",
    x1: 172.086,
    y1: 20.6548,
    x2: 189.139,
    y2: 23.3441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_376_3569",
    x1: 158.061,
    y1: 2.22754,
    x2: 183.105,
    y2: 11.1767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_376_3569",
    x1: 158.349,
    y1: 0.257812,
    x2: 178.191,
    y2: 9.18642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_376_3569",
    x1: 160.747,
    y1: 1.62646,
    x2: 172.569,
    y2: 6.80848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_376_3569",
    x1: 164.885,
    y1: 1.42236,
    x2: 179.041,
    y2: 5.25095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_376_3569",
    x1: 165.266,
    y1: 0.0898431,
    x2: 170.653,
    y2: 0.530113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_376_3569",
    x1: 148.526,
    y1: 2.69385,
    x2: 158.763,
    y2: 3.3584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_376_3569",
    x1: 155.013,
    y1: 3.04932,
    x2: 161.135,
    y2: 3.45087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_376_3569",
    x1: 150.539,
    y1: 6.43115,
    x2: 163.974,
    y2: 9.53091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_376_3569",
    x1: 146.94,
    y1: 8.40918,
    x2: 163.992,
    y2: 11.0978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_376_3569",
    x1: 148.572,
    y1: 8.40967,
    x2: 176.088,
    y2: 11.6983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_376_3569",
    x1: 149.844,
    y1: 23.0557,
    x2: 169.686,
    y2: 31.9836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_376_3569",
    x1: 155.777,
    y1: 14.9531,
    x2: 167.598,
    y2: 20.1356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_376_3569",
    x1: 156.404,
    y1: 8.41162,
    x2: 165.116,
    y2: 8.75681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_376_3569",
    x1: 165.022,
    y1: 8.41211,
    x2: 167.629,
    y2: 8.44123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_376_3569",
    x1: 164.534,
    y1: 5.40429,
    x2: 188.514,
    y2: 7.87817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_376_3569",
    x1: 174.885,
    y1: 6.83349,
    x2: 185.121,
    y2: 7.49803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_376_3569",
    x1: 170.412,
    y1: 5.47021,
    x2: 176.534,
    y2: 5.87178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_376_3569",
    x1: 164.668,
    y1: 8.41162,
    x2: 185.105,
    y2: 11.0501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_376_3569",
    x1: 164.537,
    y1: 8.37695,
    x2: 187.28,
    y2: 14.0685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_376_3569",
    x1: 145.938,
    y1: 274.702,
    x2: 186.999,
    y2: 279.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_376_3569",
    x1: 168.785,
    y1: 314.499,
    x2: 170.022,
    y2: 314.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_376_3569",
    x1: 157.636,
    y1: 275.5,
    x2: 175.836,
    y2: 276.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_376_3569",
    x1: 166.451,
    y1: 274.787,
    x2: 185.094,
    y2: 275.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_376_3569",
    x1: 168.552,
    y1: 276.404,
    x2: 188.164,
    y2: 277.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_376_3569",
    x1: 169.003,
    y1: 314.75,
    x2: 176.361,
    y2: 317.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_376_3569",
    x1: 164.886,
    y1: 314.753,
    x2: 169.195,
    y2: 315.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_376_3569",
    x1: 169.148,
    y1: 314.75,
    x2: 173.465,
    y2: 315.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_376_3569",
    x1: 168.84,
    y1: 313.652,
    x2: 178.155,
    y2: 318.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_376_3569",
    x1: 149.089,
    y1: 280.365,
    x2: 168.565,
    y2: 281.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_376_3569",
    x1: 146.942,
    y1: 292.997,
    x2: 167.65,
    y2: 295.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_376_3569",
    x1: 149.965,
    y1: 307.388,
    x2: 166.618,
    y2: 312.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_376_3569",
    x1: 159.254,
    y1: 314.747,
    x2: 166.728,
    y2: 318.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_376_3569",
    x1: 163.441,
    y1: 314.752,
    x2: 168.796,
    y2: 316.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_376_3569",
    x1: 146.874,
    y1: 275.659,
    x2: 167.879,
    y2: 277.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_376_3569",
    x1: 152.387,
    y1: 274.776,
    x2: 170.535,
    y2: 275.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_376_3569",
    x1: 161.966,
    y1: 275.711,
    x2: 179.733,
    y2: 276.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_376_3569",
    x1: 168.353,
    y1: 281.415,
    x2: 187.664,
    y2: 282.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_376_3569",
    x1: 168.524,
    y1: 294.316,
    x2: 188.954,
    y2: 296.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_376_3569",
    x1: 168.657,
    y1: 309.207,
    x2: 183.332,
    y2: 314.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_376_3569",
    x1: 36.8626,
    y1: 36.3056,
    x2: 269.016,
    y2: 65.4891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_376_3569",
    x1: 45.4817,
    y1: 75.7851,
    x2: 233.814,
    y2: 99.4601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_376_3569",
    x1: 53.377,
    y1: 81.6665,
    x2: 229.163,
    y2: 103.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_376_3569",
    x1: 78.2653,
    y1: 85.166,
    x2: 228.195,
    y2: 104.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_376_3569",
    x1: 84.4329,
    y1: 85.3882,
    x2: 228.569,
    y2: 103.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_376_3569",
    x1: 88.2736,
    y1: 86.1294,
    x2: 228.227,
    y2: 103.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_376_3569",
    x1: 90.6081,
    y1: 86.7475,
    x2: 227.872,
    y2: 104.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_376_3569",
    x1: 91.1282,
    y1: 86.9072,
    x2: 227.787,
    y2: 104.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_376_3569",
    x1: 70.3204,
    y1: 85.164,
    x2: 227.517,
    y2: 104.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_376_3569",
    x1: 61.9908,
    y1: 84.5976,
    x2: 227.274,
    y2: 105.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_376_3569",
    x1: 40.3445,
    y1: 68.3725,
    x2: 240.01,
    y2: 93.4564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_376_3569",
    x1: 37.8143,
    y1: 60.3501,
    x2: 247.21,
    y2: 86.6751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_376_3569",
    x1: 40.1523,
    y1: 52.0776,
    x2: 254.884,
    y2: 79.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_376_3569",
    x1: 47.4213,
    y1: 44.9346,
    x2: 262.178,
    y2: 71.9117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_376_3569",
    x1: 56.7569,
    y1: 39.353,
    x2: 268.019,
    y2: 65.9844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_376_3569",
    x1: 76.5277,
    y1: 36.3896,
    x2: 272.475,
    y2: 60.8631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_376_3569",
    x1: 76.0686,
    y1: 36.3506,
    x2: 272.497,
    y2: 60.9418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_376_3569",
    x1: 126.664,
    y1: 175.611,
    x2: 158.862,
    y2: 179.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_376_3569",
    x1: 132.254,
    y1: 180.345,
    x2: 163.901,
    y2: 184.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_376_3569",
    x1: 137.79,
    y1: 184.874,
    x2: 168.954,
    y2: 188.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_376_3569",
    x1: 143.285,
    y1: 189.294,
    x2: 174.033,
    y2: 192.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_376_3569",
    x1: 148.662,
    y1: 193.374,
    x2: 179.064,
    y2: 196.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_376_3569",
    x1: 154.036,
    y1: 197.374,
    x2: 184.049,
    y2: 200.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_376_3569",
    x1: 159.24,
    y1: 201.065,
    x2: 189.026,
    y2: 204.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_376_3569",
    x1: 164.362,
    y1: 204.633,
    x2: 193.721,
    y2: 207.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_376_3569",
    x1: 169.288,
    y1: 208.008,
    x2: 198.596,
    y2: 210.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_376_3569",
    x1: 174.249,
    y1: 211.219,
    x2: 202.951,
    y2: 213.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_376_3569",
    x1: 178.809,
    y1: 214.071,
    x2: 207.504,
    y2: 216.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_376_3569",
    x1: 183.43,
    y1: 216.893,
    x2: 211.746,
    y2: 219.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_376_3569",
    x1: 187.98,
    y1: 219.49,
    x2: 216.347,
    y2: 221.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_376_3569",
    x1: 192.378,
    y1: 221.775,
    x2: 220.35,
    y2: 224.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_376_3569",
    x1: 196.688,
    y1: 223.884,
    x2: 224.147,
    y2: 226.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_376_3569",
    x1: 200.607,
    y1: 225.809,
    x2: 228.136,
    y2: 228.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_376_3569",
    x1: 204.726,
    y1: 227.56,
    x2: 231.429,
    y2: 229.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_376_3569",
    x1: 208.472,
    y1: 228.943,
    x2: 234.805,
    y2: 230.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_376_3569",
    x1: 212.119,
    y1: 230.383,
    x2: 237.361,
    y2: 232.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_376_3569",
    x1: 215.677,
    y1: 231.43,
    x2: 238.736,
    y2: 232.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_376_3569",
    x1: 218.846,
    y1: 232.141,
    x2: 239.781,
    y2: 233.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_376_3569",
    x1: 222.139,
    y1: 233.168,
    x2: 240.324,
    y2: 234.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_376_3569",
    x1: 225.165,
    y1: 234.088,
    x2: 241.71,
    y2: 234.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_376_3569",
    x1: 227.797,
    y1: 235.078,
    x2: 246.655,
    y2: 236.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_376_3569",
    x1: 230.216,
    y1: 236.149,
    x2: 250.785,
    y2: 237.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_376_3569",
    x1: 232.266,
    y1: 237.123,
    x2: 255.851,
    y2: 238.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_376_3569",
    x1: 234.221,
    y1: 237.867,
    x2: 263.493,
    y2: 240.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_376_3569",
    x1: 235.976,
    y1: 238.746,
    x2: 267.191,
    y2: 241.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_376_3569",
    x1: 237.395,
    y1: 239.362,
    x2: 274.253,
    y2: 244.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_376_3569",
    x1: 238.705,
    y1: 239.875,
    x2: 278.038,
    y2: 245.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_376_3569",
    x1: 239.753,
    y1: 240.276,
    x2: 280.989,
    y2: 247.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_376_3569",
    x1: 240.559,
    y1: 240.553,
    x2: 283.264,
    y2: 248.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_376_3569",
    x1: 240.97,
    y1: 240.948,
    x2: 284.545,
    y2: 250.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_376_3569",
    x1: 241.462,
    y1: 244.812,
    x2: 283.92,
    y2: 257.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_376_3569",
    x1: 241.296,
    y1: 241.164,
    x2: 284.361,
    y2: 253.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_376_3569",
    x1: 241.089,
    y1: 238.237,
    x2: 284.06,
    y2: 251.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_376_3569",
    x1: 240.773,
    y1: 233.645,
    x2: 284.061,
    y2: 246.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_376_3569",
    x1: 240.161,
    y1: 228.058,
    x2: 283.779,
    y2: 239.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_376_3569",
    x1: 239.626,
    y1: 222.004,
    x2: 283.069,
    y2: 232.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_376_3569",
    x1: 239.311,
    y1: 216.717,
    x2: 282.038,
    y2: 226.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_376_3569",
    x1: 238.035,
    y1: 211.206,
    x2: 280.519,
    y2: 220.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_376_3569",
    x1: 237.454,
    y1: 206.21,
    x2: 278.886,
    y2: 214.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_376_3569",
    x1: 235.902,
    y1: 199.528,
    x2: 276.759,
    y2: 207.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_376_3569",
    x1: 234.176,
    y1: 194.351,
    x2: 274.272,
    y2: 201.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_376_3569",
    x1: 232.186,
    y1: 187.74,
    x2: 271.783,
    y2: 194.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_376_3569",
    x1: 229.255,
    y1: 182.177,
    x2: 268.731,
    y2: 188.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_376_3569",
    x1: 226.316,
    y1: 176.58,
    x2: 265.559,
    y2: 183.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_376_3569",
    x1: 223.582,
    y1: 171.728,
    x2: 261.929,
    y2: 178.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_376_3569",
    x1: 220.794,
    y1: 166.681,
    x2: 258.284,
    y2: 172.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_376_3569",
    x1: 217.119,
    y1: 160.626,
    x2: 254.356,
    y2: 166.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_376_3569",
    x1: 213.605,
    y1: 155.447,
    x2: 250.223,
    y2: 161.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_376_3569",
    x1: 209.449,
    y1: 149.792,
    x2: 245.738,
    y2: 155.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_376_3569",
    x1: 205.39,
    y1: 144.355,
    x2: 241.084,
    y2: 149.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_376_3569",
    x1: 201.426,
    y1: 138.961,
    x2: 236.507,
    y2: 144.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_376_3569",
    x1: 196.636,
    y1: 133.311,
    x2: 231.469,
    y2: 138.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_376_3569",
    x1: 192.382,
    y1: 127.641,
    x2: 226.439,
    y2: 132.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_376_3569",
    x1: 187.634,
    y1: 122.054,
    x2: 221.128,
    y2: 126.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_376_3569",
    x1: 182.764,
    y1: 116.297,
    x2: 215.69,
    y2: 120.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_376_3569",
    x1: 177.717,
    y1: 110.718,
    x2: 210.238,
    y2: 114.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_376_3569",
    x1: 172.546,
    y1: 105.258,
    x2: 204.69,
    y2: 109.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_376_3569",
    x1: 167.538,
    y1: 99.8613,
    x2: 199.087,
    y2: 103.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_376_3569",
    x1: 162.368,
    y1: 94.6509,
    x2: 193.712,
    y2: 98.2255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_376_3569",
    x1: 157.165,
    y1: 89.6289,
    x2: 187.987,
    y2: 93.0157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_376_3569",
    x1: 151.915,
    y1: 84.6733,
    x2: 182.61,
    y2: 87.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_376_3569",
    x1: 146.675,
    y1: 80.0264,
    x2: 177.248,
    y2: 83.2394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_376_3569",
    x1: 141.242,
    y1: 75.4863,
    x2: 171.642,
    y2: 78.6324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_376_3569",
    x1: 135.943,
    y1: 71.1855,
    x2: 166.482,
    y2: 74.3005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_376_3569",
    x1: 130.551,
    y1: 67.1084,
    x2: 160.782,
    y2: 70.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_376_3569",
    x1: 125.404,
    y1: 63.1807,
    x2: 155.092,
    y2: 66.0375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_376_3569",
    x1: 120.178,
    y1: 59.5264,
    x2: 149.721,
    y2: 62.3339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_376_3569",
    x1: 114.818,
    y1: 56.1626,
    x2: 144.512,
    y2: 58.9361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_376_3569",
    x1: 109.791,
    y1: 52.9248,
    x2: 138.477,
    y2: 55.4816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_376_3569",
    x1: 105.051,
    y1: 50.0679,
    x2: 132.79,
    y2: 52.4226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_376_3569",
    x1: 100.055,
    y1: 47.3257,
    x2: 126.752,
    y2: 49.4687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_376_3569",
    x1: 95.3884,
    y1: 44.7456,
    x2: 121.074,
    y2: 46.6755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_376_3569",
    x1: 90.7118,
    y1: 42.8154,
    x2: 116.795,
    y2: 44.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_376_3569",
    x1: 86.1077,
    y1: 40.8125,
    x2: 111.076,
    y2: 42.5634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_376_3569",
    x1: 81.8907,
    y1: 39.2617,
    x2: 106.052,
    y2: 40.8711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_376_3569",
    x1: 77.4781,
    y1: 37.8843,
    x2: 99.9088,
    y2: 39.2533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_376_3569",
    x1: 73.5063,
    y1: 36.9668,
    x2: 94.7357,
    y2: 38.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_376_3569",
    x1: 69.8399,
    y1: 36.4341,
    x2: 89.6518,
    y2: 37.4906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_376_3569",
    x1: 66.3083,
    y1: 36.3203,
    x2: 85.1333,
    y2: 37.2747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_376_3569",
    x1: 62.7574,
    y1: 36.7173,
    x2: 82.2561,
    y2: 37.7533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_376_3569",
    x1: 59.5528,
    y1: 37.7266,
    x2: 85.1493,
    y2: 39.5262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_376_3569",
    x1: 56.6582,
    y1: 39.7554,
    x2: 82.8614,
    y2: 41.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_376_3569",
    x1: 53.8918,
    y1: 41.9922,
    x2: 83.0767,
    y2: 44.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_376_3569",
    x1: 51.5838,
    y1: 45.7573,
    x2: 84.1491,
    y2: 49.1167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_376_3569",
    x1: 48.9154,
    y1: 51.939,
    x2: 84.7982,
    y2: 56.5352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_376_3569",
    x1: 47.2369,
    y1: 57.0713,
    x2: 85.1412,
    y2: 62.7651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_376_3569",
    x1: 45.9724,
    y1: 63.3511,
    x2: 85.3726,
    y2: 70.5037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_376_3569",
    x1: 44.8297,
    y1: 70.5127,
    x2: 85.2649,
    y2: 79.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_376_3569",
    x1: 44.4211,
    y1: 74.3765,
    x2: 85.6653,
    y2: 84.8092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_376_3569",
    x1: 44.3986,
    y1: 80.6367,
    x2: 85.1982,
    y2: 93.3102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_376_3569",
    x1: 44.7794,
    y1: 85.1763,
    x2: 85.1877,
    y2: 99.2936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_376_3569",
    x1: 45.6341,
    y1: 86.3232,
    x2: 86.9728,
    y2: 99.3789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_376_3569",
    x1: 46.6285,
    y1: 86.5674,
    x2: 88.8261,
    y2: 98.2199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_376_3569",
    x1: 47.8,
    y1: 87.7666,
    x2: 90.2855,
    y2: 98.3811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_376_3569",
    x1: 49.2068,
    y1: 89.0742,
    x2: 91.8203,
    y2: 98.8334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_376_3569",
    x1: 50.8175,
    y1: 91.2676,
    x2: 93.238,
    y2: 100.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_376_3569",
    x1: 52.7516,
    y1: 94.5781,
    x2: 94.8466,
    y2: 103.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_376_3569",
    x1: 54.8298,
    y1: 97.6582,
    x2: 96.7015,
    y2: 106.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_376_3569",
    x1: 57.4525,
    y1: 101.017,
    x2: 98.798,
    y2: 108.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_376_3569",
    x1: 59.7598,
    y1: 105.056,
    x2: 100.921,
    y2: 112.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_376_3569",
    x1: 62.7718,
    y1: 108.516,
    x2: 103.508,
    y2: 115.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_376_3569",
    x1: 65.7111,
    y1: 113.198,
    x2: 106.144,
    y2: 120.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_376_3569",
    x1: 69.537,
    y1: 117.302,
    x2: 109.15,
    y2: 124.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_376_3569",
    x1: 73.0474,
    y1: 121.669,
    x2: 112.275,
    y2: 128.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_376_3569",
    x1: 76.8056,
    y1: 126.545,
    x2: 115.346,
    y2: 133.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_376_3569",
    x1: 81.1771,
    y1: 131.304,
    x2: 119.012,
    y2: 137.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_376_3569",
    x1: 85.578,
    y1: 136.163,
    x2: 122.717,
    y2: 142.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_376_3569",
    x1: 89.7953,
    y1: 140.571,
    x2: 126.376,
    y2: 146.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_376_3569",
    x1: 94.6731,
    y1: 145.636,
    x2: 130.488,
    y2: 151.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_376_3569",
    x1: 99.8491,
    y1: 150.573,
    x2: 134.757,
    y2: 155.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_376_3569",
    x1: 104.649,
    y1: 155.716,
    x2: 139.257,
    y2: 160.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_376_3569",
    x1: 110.128,
    y1: 160.474,
    x2: 143.822,
    y2: 164.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_376_3569",
    x1: 115.386,
    y1: 165.737,
    x2: 148.763,
    y2: 170.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_376_3569",
    x1: 121.078,
    y1: 170.74,
    x2: 153.81,
    y2: 174.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldwide);
export default __webpack_public_path__ + "static/media/worldwide.c7356dd5c7bcb65f25a1c279ce222d1f.svg";
export { ForwardRef as ReactComponent };